import { ApiRequestModel } from "../api_request_model";
import { BaseClass } from "../master/mastermodel";
import { Time } from '@angular/common';
import { Data } from '@angular/router';

//import { BillDetails, PrescribingDoctor, ReferringDoctor } from '../../modules/testnurse/opbilling/receipt.component';
import { Type } from '@angular/core';
import { PrescribingDoctor, ReferringDoctor, BillDetails, BillItemDeleted } from '../../modules/testnurse/_MasterClasses/BillingClasses';

export class S_Methods {
  Methods: Map<string, string> = new Map<string, string>();

  Register(tn: string, m: string) {
    this.Methods[tn] = m;
  }

  //Charts
  public static readonly xyReport: string = 'Report/xyReport';

  // generic post
  public static readonly SaveGenericPost: string = 'patient/GenericProcPost';
  public static readonly GetGenericPost: string = 'patient/GenericProcPost';
  //purhcase mdoule
  public static readonly SavePurchaseIndents: string = 'patient/SavePurchaseIndents';
  public static readonly SavePurchaseOrders: string = 'patient/SavePurchaseOrders';
  public static readonly SaveVendorInvoices: string = 'patient/SaveVendorInvoices';

  // xyz module

  // Services
  
}

export class InstantReportRequest extends BaseClass {
  ReportName: string;
  ReportCode: number;
  VariableList: string;
  Facility: number;
  FromDate: Date;
  ToDate: Date;
  Employee: number;
  PatientFormatted: string;
  ProcedureName: string;


  IsFacility: Boolean;
  IsFromDate: Boolean;
  IsToDate: Boolean;
  IsEmployee: Boolean;
  IsPatientFormatted: Boolean;
}
export class ActorProfileController {
  //public Salutation: string ;
  //public FirstName: string ;
  //public MiddleName: string ;
  //public LastName: string ;
  //public DisplayName: string ;
  //public ActorType: string ;
  //public ActorTypeCode: number  ;
  //public Line1: string ;
  //public Line2: string ;
  //public City: string ;
  //public Country: string ;
  //public State: string ;
  //public Zip: string ;
  //public Telephone1: string ;
  //public Telephone2: string ;
  //public Email: string ;
  //public AddressType: number  ;
  //public HcpFormattedCode: string ;
  //public DateOfBirth: Date  ;
  //public PlaceOfBirth: string ;
  //public Gender: string ;
  //public Nationality: string ;
  //public Occupation: string ;
  //public ActorImageFile: string ;
  //public ActorImageFileExtension: string;
  //public ActorImageFileUrl: string;
  //public ActorImageCode: number;

  //public ActorCode: number;
  //public HcpProfileCode: number;
  //public HcpDemographicsCode: number;
  //public AddressCode: number;
  //public ActorAddressCode: number;


  public Salutation: string;
  public FirstName: string;
  public MiddleName: string;
  public LastName: string;
  public DisplayName: string;
  public ActorType: string;
  public ActorTypeCode: number;
  public Line1: string;
  public Line2: string;
  public City: string;
  public Country: string;
  public State: string;
  public Zip: string;
  public Telephone1: string;
  public Telephone2: string;
  public Email: string;
  public AddressType: number;
  public HcpFormattedCode: string;
  public ActorImageFile: string;
  public ActorImageFileExtension: string;
  public ActorImageFileUrl: string;
  public ActorImageCode: number;
  public ActorCode: number;
  public HcpProfileCode: number;
  public AddressCode: number;
  public ActorAddressCode: number;
}
export class UpdatePatientInfoRequest extends BaseClass {
  public ActorCode: number;
  public Prefix: string;
  public IdProof: string;
  public DisplayName: string;
  public Gender: string;
  public DateOfBirth: Date;
  public FemaleDateofBirth: Date;
  public Age: number;
  public MaritalStatus: string;
  public Language: string;
  public Religion: string;
  public Institution: string;
  public BloodGroup: string;
  public Occupation: string;
  public Nationality: string;

  public EducationTitle: string;
  public EducationInDetail: string;

  public ReferalDetailCode: number;
  public RefCode: number;
  public RefType: string;
  public RefDetails: string;
  public RefContactNo: string;
  public RefInstitute: string;
  public RefContactNo2: string;

  public UserLoginFacility: number;
  public CreatedUser: number;
  public MaleDateOfBirth: Date;
  public WeddingAnniversary: Date;
  public UserName: string;
  public DonorTypeName: string;
  public SalutationMale: string;
  public DisplayNameMale: string;
  public Remarks: string;
  public IsInsured: boolean;
  public InsuranceProvider: string;
  public ActorType: number;
  public MaleTelephone1: string;
  public CredentialType: string;
  public CredentialNumber: string;
  public ValidFrom: Date;
  public ValidTo: Date;
  public IssuingAuthority: string;
  public Details: string;
  public RegistrationType: string;
  public RegistrationReason: string;
  public BillingCategory: string;
  public RegistrationValidity: Date;
  public IsOldRegistration: boolean;
  public OldRegistrationNo: string;
  public PrimaryDoctor: string;

  public AddressCode: number;
  public AddressLine1: string;
  public AddressLine2: string;
  public City: string;
  public State: string;
  public County: string;
  public ZipCode: string;

  public Telephone1: string;
  public Telephone2: string;
  public Email: string;
  public BirthIdentification1: string;
}
export class SavePatientInfoRequest extends BaseClass {
  public ActorCode: number;
  public Prefix: string;
  public DisplayName: string;
  public UserLoginFacility: number;
  public CreatedUser: number;
  public Gender: string;
  public DateOfBirth: Date;
  public IdProof: string;
  public FemaleDateofBirth: Date;
  public WeddingAnniversary: Date;
  public UserName: string;
  public AddressCode: number;
  public DonorTypeName: string;

  public SalutationMale: string;
  public Salutation: string;
  public DisplayNameMale: string;
  public ReferalDetailCode: number;
  public RefCode: number;
  public RefType: string;
  public RefDetails: string;
  public RefContactNo: string;
  public RefInstitute: string;
  public RefContactNo2: string;
  public Remarks: string;
  public Religion: string;
  public Institution: string;
  public BloodGroup: string;
  public Occupation: string;
  public Nationality: string;
  public EducationTitle: string;
  public EducationInDetail: string;
  public IsInsured: boolean;
  public InsuranceProvider: string;
  //public string Gender { get; set; }
  //public System.DateTime DateOfBirth { get; set; }
  //public System.DateTime AgeDate { get; set; }
  //public string MaritalStatus { get; set; }
  //public string Nationality { get; set; }
  //public string Occupation { get; set; }
  //public string Institution { get; set; }
  //public long EducationalLevel { get; set; }
  //public string EducationInDetail { get; set; }
  //public string EducationTitle { get; set; }
  //public string PrimeRelation { get; set; }
  //public string PrimeRelativeName { get; set; }
  //public long PatientRegistrationNumber { get; set; }
  //public DateTime RegistrationValidity { get; set; }
  //public string FormattedCode { get; set; }
  //public System.DateTime RegistrationDate { get; set; }
  //public string PrimaryDoctor { get; set; }
  //public string PrimaryDiagnosis { get; set; }
  //public string RefferingDoctor { get; set; }
  //public System.DateTime FirstVisitDate { get; set; }
  //public System.DateTime LastVisitDate { get; set; }
  //public string RegistrationComment { get; set; }
  //public string PatientCategory { get; set; }
  //public string PatientCategory2 { get; set; }
  public AddressLine1: string;
  public AddressLine2: string;
  //public string AddressLine2 { get; set; }
  //public long AddressCode { get; set; }
  //public string City { get; set; }
  //public string State { get; set; }
  //public string County { get; set; }
  //public string ZipCode { get; set; }
  public Telephone1: string;
  public ActorType: number;
  //public FemaleTelephone1: string;
  public MaleTelephone1: string;
  //public string Telephone2 { get; set; }
  //public string Email { get; set; }
  //public string Website { get; set; }
  //public string FacilityName { get; set; }
  //public string PatientImageFile { get; set; }
  //public string FileExtension { get; set; }
  //public long FacilityCode { get; set; }
  //public string FacilityGID { get; set; }
  //public string CreatedUser { get; set; }
  //public System.DateTime CreatedTimeStamp { get; set; }
  //public string RecordStatus { get; set; }
  // public long ConditionalOperator { get; set; }
  public CredentialType: string;
  public CredentialNumber: string;
  public ValidFrom: Date;
  public ValidTo: Date;
  public IssuingAuthority: string;
  public Details: string;
  public RegistrationType: string;
  public RegistrationReason: string;
  public BillingCategory: string;
  public RegistrationValidity: Date;
  public IsOldRegistration: boolean;
  public Age: number;
  public MaritalStatus: string;
  public Language: string;
  public OldRegistrationNo: string;
  public PrimaryDoctor: string;
  public City: string;
  public State: string;
  public County: string;
  public ZipCode: string;
  public Telephone2: string;
  public Email: string;
  public BirthIdentification1: string;


}
export class VendorInvoiceListRequest extends BaseClass {
  public FacilityCode: number;
  public InvoiceCode: number;
  public FromDate: Date;
  public ToDate: Date;
}
export class VendorInvoiceListController {
  public VendorInvoiceCode: number;
  public VendorInvoiceNo: string;
  public InvoiceDate: Date;
  public SupplierName: string;
  public RefNo: string;
  public PO: string;
  public InvoiceAmount: number;
  public IsCreditInvoice: boolean;
  public DueDate: Date;
  public Status: string;
  public DocID: string;

  public PayAgainst: string;
  public PaymentDue: Date;
  public DeliveryDetails: string;

  public TotalBeforeDisc: number;
  public DiscountAmount: number;
  public TaxAmount: number;
  public GrandTotal: number;
  public Remarks: string;

  public OwnerStore: number;
  public OwnerStoreName: string;

  public NetAmount: number;
  public BranchName: string;
  public DocumentStatus: string;
}
export class VendorInvoiceDetailsRequest extends BaseClass {
  public Invoice: string;
}
export class VendorInvoiceDetailsController {
  public VendorInvoiceItemCode: number;
  public MaterialCode: number;
  public MaterialDescription: string;
  public InvoiceQuantity: number;
  public BonusQuantity: number;
  public PurchasePrice: number;
  public UOM: string;
  //public TotalAmount: number;
  public DiscountPercent: number;
  public DiscountAmount: number;
  public TaxType: string;
  public TaxPercent: number;
  public TaxAmount: number;
  public NetAmount: number;
  public Remarks: string;
  public Invoice: string;

  public PurchaseAmount: number;
  public HSNCode: number;
  public ItemTax: number;
  public TotalQuantity: number;
  public BatchNo: string;
  public ExpiryDate: Date;
  public SellingPrice: number;
  public MRP: number;

  public UnitPrice: number;
  public Pack: number;
}
export class VendorInvoiceDetailsInfoController {
  public InvoiceItems: VendorInvoiceDetailsController[];
  public InvoiceHeader: VendorInvoiceListController;
}
export class PurchaseOrdersListRequest extends BaseClass {
  public FacilityCode: number;
  public FromDate: Date;
  public ToDate: Date;
  public PurchaseOrderCode: number;
}
export class PurchaseOrdersListController {
  public Remarks: string;
  public DocID: string;
  public PurchaseOrderCode: number;
  public OrderNo: string;
  public OrderDate: Date;
  public SupplierCode: number;
  public SupplierName: string;
  public RefNo: string;
  public OrderAmount: number;
  public DeliveryDate: Date;
  public OrderStatus: string;
  public VendorContactPerson: number;
  public VendorContactPersonName: string;
  public VendorDocumentReference: string;
  public ShipToLocation: string;
  public ShipToLocationCode: number;
  public PayAgainst: string;
  public PaymentTermsinDays: number;
  public TermsAndConditions: string;
  public Tax: number;
  public TotalBeforeDiscount: number;
  public DiscountAmount: number;
  public GrandTotal: number;
  public CurrentAvailability: number;

  public ReportHeaderTitle: string;
  public ShortName: string;
  public AddressLine1: string;
  public AddressLine2: string;
  public City: string;
  public State: string;
  public Country: string;
  public Fax1: string;
  public Zip: string;
  public Telephone1: string;
  public CounterPerson: string;
  public CSTNO: string;
  public Net: number; 
}
export class PurchaseOrderDetailsRequest extends BaseClass {
  public DOC: string;
}
export class PurchaseOrderDetailsController {
  public PurchaseOrderItemCode: number;
  public MaterialCode: number;
  public MaterialDescription: string;
  public Quantity: number;
  public UOM: string;
  public BonusQuantity: number;
  public PurchasePrice: number;
  public DiscountPercent: number;
  public TaxType: string;
  public TaxPercent: number;
  public PurchaseAmount: number;
  public MRP: number;

  public TotalOrderQuantity: number;
  public IsTotalQuantityReceived: boolean;
  public UnitPrice: number;
  public ItemTaxPercent: number;
  public TaxCode: number;
  public SellingPrice: number;

  public Net: number;
  public TotalAmount: number;
  public TaxAmount: number;
  public Pack: number;

  public BatchNo: string;;
  public ExpiryDate: Date;

  public DiscountAmount: number;
}
export class PurchaseOrderDetailsInfoController {
  public OrderItems: PurchaseOrderDetailsController[];
  public OrderHeader: PurchaseOrdersListController;
}
export class PurchaseIndentsListRequest extends BaseClass {
  public FacilityCode: number;
  public FromDate: Date;
  public ToDate: Date;
  public PurchaseIndentCode: number;
}
export class PurchaseIndentsListController {
  public PurchaseIndentCode: number
  public IndentNo: string;
  public RequestDate: Date;
  public RequestedByActorCode: number;
  public RequestedByActorName: string;
  public ExpectedDeliveryDate: Date;
  public IndentStatus: string;
  public Remarks: string;
  public DocID: string;

  public IsIndentClosed: boolean;
  public FromStoreName: string;
  public ToStoreLocation: number;
  public FromStoreLocation: string;
  public OwnerLocation: number;
  public OwnerLocationShortName: string;
  public AutoGenerated: boolean;
}
export class PurchaseIndentItemsInfoController {
  public PurchaseItems: PurchaseIndentItemsController[];
  public PurchaseHeader: PurchaseIndentsListController;
}
export class PurchaseIndentItemsRequest extends BaseClass {
  public DOCID: string;
}
export class PurchaseIndentItemsController {
  public PurchaseIndentItemCode: number
  public MaterialCode: number;
  public MaterialDescription: string;
  public Quantity: number;
  public UOM: string;
  public IsIndentClosed: boolean;
  public OrderQuantity: number;
  public TaxPercent: number;
  public OldPurchasePrice: number;
  public OldSalePrice: number;
  public OldMrp: number;
  public OldPack: number;

}
export class SavePurchaseIndentRequest extends BaseClass {
  public RequestedDept: string;
  public OwnerCode: number;
  public OwnerName: string;
  public RequestedDate: Date;
  public OwnerLocationCode: number;
  public OwnerLocationShortName: string;
  public ExpectedDeliveryDate: Date;
  public IndentStatus: string;
  public Remarks: string;
  public TotalQty: number;
  public AcceptedQty: number;
  public FromStore: number;
  public ToStore: number;
  public FromStoreName: string;
  public IsIndentClosed: boolean;
  public PurchaseIndentCode: number;
  public Items: SavePurchaseIndentItem[];
}
export class SavePurchaseIndentItem{
  public MaterialCode: number;
  public Quantity: number;  
  public PurchaseIndentItemCode: number;
  public UOM: string;
  public MaterialDescription: string;
}
export class SavePurchaseOrderRequest extends BaseClass {
  public PurchaseOrderCode: number;
  public SupplierCode: number;
  public SupplierContactPersonCode: number;
  public SupplierRef: string;
  public OrderStatus: string;
  public PostingDate: Date;
  public DeliveryDate: Date;
  public TotalBeforeDiscount: number;
  public DiscountPercent: number;
  public TotalAfterDiscount: number;
  public Tax: number;
  public NetDue: number;
  public Remarks: string;
  public OwnerLocation: number;
  public Owner: number;
  public DocID: string;
  public ShipToLocation: number;
  public OwnerName: string;
  public SupplierName: string;
  public SupplierContactPersonName: string;
  public OwnerLocationShortName: string;
  public AmountPaid: number;
  public Terms: string;
  public RefDetails: string;
  public IsDeliveryChargesIncluded: boolean;
  public POFormattedCode: string;
  public HasQuotation: boolean;
  public RefDocNo: string;
  public IsTotalOrderReceived: boolean;
  public OwnerStore: number;
  public OwnerStoreName: string;
  public HasIndent: boolean;
  public IndentFormattedCode: string;
  public PayInDays: number;
  public ReleaseCount: number;
  public CancelCount: number;
  public Items: PurchaseOrderItemRequest[];
  public PayAgainst: string;
  public GrandTotal: number;
  public TotalBeforeTax: number;
  public DiscountAmount: number;
}
export class PurchaseOrderItemRequest {
  public PurchaseOrderItemCode: number;
  public DocID: string;
  public ItemCode: number;
  public ItemDescription: string;
  public Quantity: number;
  public Tax: number; // item tax
  public UnitPrice: number;
  public DiscountPercent: number;
  public Discount: number;
  public ItemTotal: number;
  public UomName: string;
  public Remarks: string;
  public TaxPercent: number;
  public BonusQuantity: number;
  public TotalOrderQuantity: number;
  public AbatedTax: number;
  public Mrp: number;
  public HasTaxOnBonus: boolean;
  public Pack: number;
  //public TaxTypeName: string;
  public SalePrice: number;
  public PurchasePrice: number;
  public ItemNet: number;

  public BatchNo: string;
  public ExpiryDate: Date;

  public Material: number;
  public MaterialGroup: number;
}
export class SaveVendorInvoice extends BaseClass {
  public VendorInvoiceCode: number;
  public DocID: string;
  public InvFormattedCode: string;
  public InvDate: Date;
  public VendorCode: number;
  public VendorName: string;
  public NetAmount: number;
  public TaxAmount: number;
  public GrossAmount: number;
  public Notes: string;
  public PaymentDue: Date;
  public Facility: number;
  public DocumentStatus: string;
  public IsDeliveryChargeIncluded: boolean;
  public DeliveryCharges: number;
  public FacilityShortName: string;
  public DiscountAmount: number;
  public TotalBeforeDesc: number;
  public RefDocNo: string;
  public Remarks: string
  public CoinAdj: number;
  public PaymentStatus: string;
  public OwnerStore: number;
  public OwnerStoreName: string;
  public POorGRN: string;
  public IsPOUpdated: boolean;
  public GRNList: string;
  public Items: VendorInvoiceItemRequest[];

  public HasPO: boolean;
  public PurchaseOrderCode: number;
  public InvoiceStatus: string;
}
export class VendorInvoiceItemRequest {
  public VendorInvoiceItemCode: number;
  public Invoice: string;
  public ItemType: string;
  public ItemCode: number;
  public ItemDescription: string;
  public TaxPercent: number;
  public TaxAmount: number;
  public NetAmount: number;
  public GrossAmount: number;
  public Quantity: number;
  public UOM: string;
  public Discount: number;
  public DiscountPercent: number;
  public UnitPrice: number;
  public Remarks: string;
  public BonusQuantity: number;
  public TaxTypeName: string;
  public AbatedTax: number;
  public HasAbatedTax: boolean;
  public Mrp: number;
  public HasTaxOnBonues: boolean;
  public BatchNo: string;
  public ExpiryDate: Date;
  public Pack: number;
  public TotalSellUnits: number;
  public SellUnitName: string;
  public SellingPrice: number;
  public SellUnitCode: number;
  public PurchaseUnitCode: number;
  public GrossAfterDiscount: number;

  public TotalOrderQuantity: number;
  public PurchasePrice: number;
}
export class AdmissionsListRequest extends BaseClass {
  public FacilityCode: number;
  public AdmissionCode: number;
  public SearchText: string;
  public FromDate: Date;
  public ToDate: Date;
}
export class AdmissionsHeader2 {
  public AdmissionCode: number;
  public ChargeEntry: number;
  public PatientCode: number;
  public PatientFormattedCode: string;
  
  public AdmissionNo: string;
  public IsDischargeInitiated: boolean;
  public IsDischarged: boolean;
  public PatientName: string;
  
}
export class PatientSearchResult {
  public DisplayName: string;
  public GenderAge: string;
  public Telephone1: string;
  public FormattedCode: string;
  public City: string;
}
export class OverseasController {
  public PassportNumber: string;
  public PassportExpiryDate: Date;
  public IssueCountry: string;
  public VisaType: string;
  public VisaExpiryDate: Date;
  public NationalRegNo: string;
}
export class AdmissionsListController {
  public AdmissionCode: number;
  public FacilityCode: number;
  public PatientCode: number;
  public PatientFormattedCode: string;
  public AdmittedOn: Date;
  public AdmissionNo: string;
  public AdmissionReason: string;
  public IsDischargeInitiated: boolean;
  public ConsentFormNo: string;
  public HasTpi: boolean;
  public FacilityName: string;
  public PatientName: string;
  public InsuranceProvider: string;
  public AdmissionStatus: string;
  public Ward: string;
  public Room: string;
}
export class AdmissionsByCodeRequest extends BaseClass {
  public FacilityCode: number;
  public AdmissionCode: number;
}
export class AdmissionsByCodeController {
  public AdmissionCode: number;
  public AdmissionNo: string;
  public PatientCode: number;
  public PatientFormattedCode: string;
  public PatientName: string;
  public PatientID: string;
  public CaseRecordNo: string;
  public AdmissionDate: Date;
  public AdmissionType: string;
  public CaseType: string;
  public TreatmentCategory: string;
  public ProviderIncharge: string;
  public AdmissionReferralType: string;
  public ReferralPhysicianName: string;
  public ReferralDetails: string;
  public PaymentReference: string;
  public CareUnit: string;
  public BedLocation: string;
  public EstimatedLengthOfStay: number;
  public PlannedDischargeDate: number;
  public PatientConsentSigned: boolean;
  public ConsentFormNo: string;
  public AdmissionStatus: string;
  public AdmissionReason: string;
  public ProposedTreatmentCode: number;
  public ProposedTreatment: string;
  public ProposedTreatmentRemarks: string;
  public ProcedureDoneOn: Date;
  public DebtorType: string;
  public Insurance: boolean;
  public InsuranceProvider: string;
  public TpiApprovalStatus: string;
  public CardNo: string;
}
export class AdmissionDetailsInfoController {
  public AdmissionItems: AdmissionsByCodeController[];
  public AdmissionHeader: AdmissionsListController[];
}
export class BillAdvanceByCodeRequest extends BaseClass {
  public FacilityCode: number;
  public PatientCode: number;
}
export class BillAdvanceByCodeController {
  public PatientCode: number;
  public PatientName: string;
  public AdvanceType: number;
  public AdvanceName: string;
  public branch: number;
  public BranchName: string;
  public AdvanceAmount: number;
}
export class X_BillReceiptsController {
  public CompanyReceiptCode: number;
  public AccountNo: number;
  public BillNo: string;
  public ReceiptDate: Date;
  public ChargeEntry: number;
  public PatientCode: number;
  public PatientName: string;
  public Company: number;
  public CompanyName: string;
  public Branch: number;
  public BranchName: string;
  public AmountPaid: number;
  public Remarks: string;
  public IsAdvance: boolean;
  public Payee: number;
  public PayeeName: string;
  public AmountPayable: number;
  public FormattedCode: string;
  public BillFormattedCode: string;
  public PaymentInstrument: string;
  public ReceiptReferenceNo: string;
  public ReceivedAmount: number;
  public PatientAccountReceiptDetailCode: number;
}
export class X_BillHeaderController {
  public ChargeEntry: number;
  public BillNo: string;
  public BillDate: Date;
  public PatientCode: number;
  public PatientName: string;
  public Company: number;
  public CompanyName: string;
  public Branch: number;
  public BranchName: string;
  public ItemTotal: number;
  public FormattedCode: string;
  public BillStatus: string;
  public PaidTotal: number;
  public Balance: number;
  public RecordStatus: string;
  public PatientFormattedCode: string;
  public PatientAgeY: number;
  public PatientAgeM: number;
  public PatientAgeD: number;
  public PatientGender: string;
  public PatientAddress: string;
  public TotalAmount: number;
  public Discount: number;
  public Net: number;
  public Tax: number;
  public AdditionalCharges: number;
  public BillType: string;
  public OverAllDiscount: number;
  public FirstReceiptDate: Date;
  public LastReceiptDate: Date;
  public BillCreatedDate: Date;
  public PatientTelephoneNumber1: string;
  public PatientTelephoneNumber2: string;
  public PatientImageFile: string;
  public FileExtension: string;
  public PayeeNumber: number;
  public PayeeName: string;
  public IahOderCode: number;
  public IsIahBill: number;
  public IahOrderStatus: string;
  public ReceiptFormattedCode: string;
  public Paid: number;
  public IsGuest: boolean;
  //public Discountmode: string;
  //public PreviousDiscount: number;
  //public DiscountAmount: number;
  //public DiscountRemarks: string;
}
export class X_BillItemsController {
  public ChargeEntry: number;
  public ChargeType: string;
  public ItemCode: number;
  public ItemDescription: string;
  public BranchCode: number;
  public BranchName: string;
  public DepartmentCode: number;
  public DepartmentName: string;
  public CompanyService: number;
  public UnitPrice: number;
  public Quantity: number;
  public ItemTotal: number;
  public Discount: number;
  public BillNo: string;
  public Prescriber: number;
  public PrescriberName: string;
  public ItemReferenceNo: number;
  public ServicePoint: string;
  public RefundableAmount: number;
  public ItemEntryDate: Date;
  public ItemEntryTime: Date;
  public GroupName: string;
  public ServiceCategory: number;
  public ServiceCategoryName: string;
  public ServiceRevenueCategory: string;
  public PatientCategory: string;
  public ReportServiceCategory: number;
  public ReportServiceCategoryName: string;
  public ChargeItemCode: number;
  public RefundableQuantity: number;
  public BatchNo: string;
  public ExpiryDate: Date;
  public Tax: number;
  public DiscountAllowed: boolean;
  public MaterialBatchStorage: number;

}
export class X_BillReceiptsController2 {
  public CompanyReceiptCode: number;
  public AccountNo: number;
  public BillNo: string;
  public ReceiptDate: Date;
  public ChargeEntry: number;
  public PatientCode: number;
  public PatientName: string;
  public Company: number;
  public CompanyName: string;
  public Branch: number;
  public BranchName: string;
  public AmountPaid: number;
  public Remarks: string;
  public IsAdvance: boolean;
  public Payee: number;
  public PayeeName: string;
  public AmountPayable: number;
  public FormattedCode: string;
  public BillFormattedCode: string;
  public PaymentInstrument: string;
  public ReceiptReferenceNo: string;
  public ReceivedAmount: number;
  public PatientAccountReceiptDetailCode: number;
}
export class X_BillHeaderController2 {
  public ChargeEntry: number;
  public BillNo: string;
  public BillDate: Date;
  public PatientCode: number;
  public PatientName: string;
  public Company: number;
  public CompanyName: string;
  public Branch: number;
  public BranchName: string;
  public ItemTotal: number;
  public FormattedCode: string;
  public BillStatus: string;
  public PaidTotal: number;
  public Balance: number;
  public RecordStatus: string;
  public PatientFormattedCode: string;
  public PatientAgeY: number;
  public PatientAgeM: number;
  public PatientAgeD: number;
  public PatientGender: string;
  public PatientAddress: string;
  public TotalAmount: number;
  public Discount: number;
  public Net: number;
  public Tax: number;
  public AdditionalCharges: number;
  public BillType: string;
  public OverAllDiscount: number;
  public FirstReceiptDate: Date;
  public LastReceiptDate: Date;
  public BillCreatedDate: Date;
  public PatientTelephoneNumber1: string;
  public PatientTelephoneNumber2: string;
  public PatientImageFile: string;
  public FileExtension: string;
  public PayeeNumber: number;
  public PayeeName: string;
  public IahOderCode: number;
  public IsIahBill: number;
  public IahOrderStatus: string;
  public ReceiptFormattedCode: string;
  public Paid: number;
  public IsGuest: boolean;
  //public Discountmode: string;
  //public PreviousDiscount: number;
  //public DiscountAmount: number;
  //public DiscountRemarks: string;
}
export class X_BillItemsController2 {
  public ChargeEntry: number;
  public ChargeType: string;
  public ItemCode: number;
  public ItemDescription: string;
  public BranchCode: number;
  public BranchName: string;
  public DepartmentCode: number;
  public DepartmentName: string;
  public CompanyService: number;
  public UnitPrice: number;
  public Quantity: number;
  public ItemTotal: number;
  public Discount: number;
  public BillNo: string;
  public Prescriber: number;
  public PrescriberName: string;
  public ItemReferenceNo: number;
  public ServicePoint: string;
  public RefundableAmount: number;
  public ItemEntryDate: Date;
  public ItemEntryTime: Date;
  public GroupName: string;
  public ServiceCategory: number;
  public ServiceCategoryName: string;
  public ServiceRevenueCategory: string;
  public PatientCategory: string;
  public ReportServiceCategory: number;
  public ReportServiceCategoryName: string;
  public ChargeItemCode: number;
  public RefundableQuantity: number;
  public BatchNo: string;
  public ExpiryDate: Date;
  public Tax: number;
  public Remarks: string;
  public ServiceStatus: string;
  public StatusChangeTime: Date;
  public StatusModifiedByUserCode: number;
  public StatusModifiedByUserName: string;
}

export class X_BillHeaderByProviderCodeController {
  public ChargeEntry: number;
  public BillNo: string;
  public BillDate: Date;
  public PatientCode: number;
  public PatientName: string;
  public Company: number;
  public CompanyName: string;
  public Branch: number;
  public BranchName: string;
  public ItemTotal: number;
  public FormattedCode: string;
  public BillStatus: string;
  public PaidTotal: number;
  public Balance: number;
  public RecordStatus: string;
  public PatientFormattedCode: string;
  public PatientAgeY: number;
  public PatientAgeM: number;
  public PatientAgeD: number;
  public PatientGender: string;
  public PatientAddress: string;
  public TotalAmount: number;
  public Discount: number;
  public Net: number;
  public Tax: number;
  public AdditionalCharges: number;
  public BillType: string;
  public OverAllDiscount: number;
  public FirstReceiptDate: Date;
  public LastReceiptDate: Date;
  public BillCreatedDate: Date;
  public PatientTelephoneNumber1: string;
  public PatientTelephoneNumber2: string;
  public PatientImageFile: string;
  public FileExtension: string;
  public PayeeNumber: number;
  public PayeeName: string;
  public IahOderCode: number;
  public IsIahBill: number;
  public IahOrderStatus: string;
  public ReceiptFormattedCode: string;
  public Paid: number;
  public IsGuest: boolean; 
      
  public AdmissionFormattedCode: string;
  public AdmissionCode: number;
}

export class X_BillItemsByProviderCodeController {
  public ChargeItemID: string;
  public ChargeItemCode: number;
  public ChargeEntry: number;
  public ChargeType: string;
  public ItemCode: number;
  public ItemDescription: string;
  public BranchCode: number;
  public BranchName: string;
  public DepartmentCode: number;
  public DepartmentName: string;
  public CompanyService: number
  public UnitPrice: number;
  public Quantity: number;
  public ItemTotal: number;
  public Discount: number;
  public BillNo: string;
  public Prescriber: number;
  public PrescriberName: string;
  public ItemReferenceNo: number;
  public ServicePoint: string;
  public RefundableAmount: number;
  public ItemEntryDate: Date;
  public ItemEntryTime: Date;
  public GroupName: string;
  public ServiceCategory: number;
  public ServiceCategoryName: string;
  public ServiceRevenueCategory: string;
  public PatientCategory: string;
  public ReportServiceCategory: number;
  public ReportServiceCategoryName: string;
  public RefundableQuantity: number;
  public BatchNo: string;
  public ExpiryDate: Date;
  public Tax: number;
  public AdmissionCode: number;
  public AdmissionFormattedCode: string;
  public DiscountAllowed: boolean;
  public MaterialBatchStorage: number;

  public ProviderCode: number;
  public ProviderName: string;
}

export class X_BillReceiptsByProviderCodeController {
  public CompanyReceiptCode: number;
  public AccountNo: number;
  public BillNo: string;
  public ReceiptDate: Date;
  public ChargeEntry: number;
  public PatientCode: number;
  public PatientName: string;
  public Company: number;
  public CompanyName: string;
  public Branch: number;
  public BranchName: string;
  public AmountPaid: number;
  public Remarks: string;
  public IsAdvance: boolean;
  public Payee: number;
  public PayeeName: string;
  public AmountPayable: number;
  public FormattedCode: string;
  public BillFormattedCode: string;
  public ReceiptDetail: string;
  public PaymentInstrument: string;
  public ReceiptReferenceNo: string;
  public ReceivedAmount: number;
  public PatientAccountReceiptDetailCode: number;
}

export class BillDetailsInfoController {
  public Receipts: X_BillReceiptsController[];
  public Items: X_BillItemsController[];
  public Header: X_BillHeaderController;
}
export class BillDetailsInfoController2 {
  public Receipts: X_BillReceiptsController2[];
  public Items: X_BillItemsController2[];
  public Header: X_BillHeaderController2;
}

export class BillDetailsByProviderCodeInfoController {
  public Receipts: X_BillReceiptsByProviderCodeController[];  
  public Items: X_BillItemsByProviderCodeController[];
  public Header: X_BillHeaderByProviderCodeController;
}

export class x_BillDetailsRequest extends BaseClass {
  public BillType: string;
  public ChargeEntry: number;
  //put all necessary fields..
  public Branch: number;
  public FormattedCode: string;
  public SearchText: string;
  public FromDate: Date;
  public ToDate: Date;
  public ActorCode: number;
  public AdmissionCode: number;
}

export class x_BillDetailsByProviderCodeRequest extends BaseClass {
  public BillType: string;
  public ChargeEntry: number;
  //put all necessary fields..
  public Branch: number;
  public FormattedCode: string;
  public SearchText: string;
  public FromDate: Date;
  public ToDate: Date;
  public ActorCode: number;
  public AdmissionCode: number;
}

export class SaveServiceItemTrackingStatusRequest extends BaseClass {
  public Remarks: string;
  public CECode: number;
  public CEItem: number;
  public TrackingStatus: string;
  public UserName: string;
  public UserCode: number;

}
export class SaveMaterialBatchInfoRequest extends BaseClass {
  public MaterialBatchStorageCode: number;
  public SupplierMaterialBatchCode: number;
  public CurrBatchQty: number;
  public NewBatchQty: number;
  public CurrAvailableQty: number;
  public NewAvailableQty: number;
  public MaterialSpec: number;
}
export class StoreLocationMaterialsController {
  public MaterialSpec: number;
  public MaterialInventoryCode: number;
  public AvailableQuantity: number;
  public ROL: number;
  public SafetyQuantity: number;
  public StoreLocation: number;
  public Material: number;
  public Description: string;
  public MaterialType: string;
  public MaterialGroup: number;
  public MaterialID: number;
  public ShortName: string;
  public GroupName: string;
  public Facility: number;
  public GroupMaterialType: string;
  public GroupParentCode: number;
  public GroupParentName: string;
  public StoreName: string;
  public CanBeSold: boolean;
  public CanBePurchased: boolean;
  public CostingMethod: string;
  public IssueQuantity: number;
  public AllowOrderCreation: boolean;
  public SaleUOM: string;
}
export class StoreLocationMaterialsRequest extends BaseClass {

  //public string ConditionalOperator { get; set; }
  public StoreCode: number;
  public SearchText: string;

}
export class LabOrderTestResultsController {
  public OrderCode: number;
  public OrderTestObservation: number;
  public OrderTestCode: number;
  public OrderTestStatus: string;
  public TestName: string;
  public LabType: string;
  public AgeProfile: string;
  public ObservationName: string;
  public ObservationValue: string;
  public UOM: string;
  public OriginalTestCode: number;
  public ReferenceRange: string;
  public PatientID: number;
  public EffectiveOrderDate: Date;
  public PatientDisplayName: string;
  public PatientFormattedCode: string;
  public OrderStatus: string;
  public FirstSigning: string;
  public SecondSigning: string;
  public LabName: string;
  public IsSpecimenAssociated: boolean;
  public OrderTestObservation1: number;
  public SpecimenCollectionDate: Date;
  public SpecimenCollectionTime: Date;
  public SpecimenName: string;
  public ObservationMethod: string;
  public FirstSigningName: string;
  public SecondSigningName: string;
  public FirstSignCode: number;
  public SecondSignCode: number;
  public ExaminationType: string;
}
export class LabOrderResultsController {
  public OrderCode: number;
  public OrderTestObservation: number;
  public OrderTestCode: number;
  public OrderTestStatus: string;
  public TestName: string;
  public LabType: string;
  public AgeProfile: string;
  public ObservationName: string;
  public ObservationValue: string;
  public UOM: string;
  public OriginalTestCode: number;
  public ReferenceRange: string;
  public PatientID: number;
  public EffectiveOrderDate: Date;
  public PatientDisplayName: string;
  public PatientFormattedCode: string;
  public OrderStatus: string;
  public FirstSigning: string;
  public SecondSigning: string;
  public LabName: string;
  public IsSpecimenAssociated: boolean;
  public OrderTestObservation1: number;
  public SpecimenCollectionDate: Date;
  public SpecimenCollectionTime: Date;
  public SpecimenName: string;
  public ObservationMethod: string;
  public FirstSigningName: string;
  public SecondSigningName: string;
  public FirstSignCode: number;
  public SecondSignCode: number;
}
export class LabOrderResultsRequest extends BaseClass {
  public OrderCode: number;
  public UserCode: number;
}
export class LabOrderResultsByTestController {
  public Result: number;
  public PatientFormattedCode: string;
  public PatientName: string;
  public OrderRequestFormattedCode: string;
  public EffectiveOrderDate: Date;
  public EnteredBy: string;
  public PatientContactNo: string;
  public LabOrderTestStatus: string;
}
export class LabOrderResultsByTestRequest extends BaseClass {
  public LabOrderCode: number;
  public UserCode: number;
}
export class SaveSpecimenCollectionInfoRequest extends BaseClass {
  public OrderTestSpecimenCollectionCode: number;
  public OrderCode: number;
  public OrderDate: Date;
  public BranchCode: number;
  public PatientCode: number;
  public Tests: SpecimenOrderTest[];
  public Specimen: string;
  public CollectionVolume: number;
  public CollectionDate: Date;
  public CollectionTime: Time;
  public TestMethod: string;
  public TestKit: string;
  public DOC: number;
  public GestationAge1: number;
  public GestationAge2: number;
  public Comments: string;
  public GestationAge1Units: string;
  public GestationAge2Units: string;
}
export class SpecimenOrderTest {
  public TestSpecimenCode: number;
  public TestName: string;
  public OrderTestCode: number;
}
export class SaveTestResultsInfoRequest extends BaseClass {

  public OrderCode: number;
  public OrderTestCode: number;
  public OriginalTestCode: number;
  public Results: ResultItems[];
  public Comments: string;

}
export class ResultItems {
  public ObservationValue: string
  public ObservationName: string
  public OrderTestObservation: number;
}
export class SaveResultStatusInfoRequest extends BaseClass {

  public OrderCode: number;
  public OrderTestCode: number;
  public OriginalTestCode: number;
  public SignStatus: string;
}
export class SaveVendorInfoRequest extends BaseClass {
  public VendorName: string;
  public Location: string;
  public ContactNo: string;
  public AddressLine1: string;
}
export class GenericProcPostRequest extends BaseClass {
  public QueryData: string;
  
}

export class SaveMaterialDetailsInfoRequest extends BaseClass {
  public MaterialCode: number;
  public MaterialName: string;
  public SellingUnit: string;
  public PurchaseUnit: string;
  public HsnCode: string;
  public MaterialGroupCode: number;
  public TaxPercentage: string;
}
export class MaterialsListRequest extends BaseClass {
  public MaterialCode: number;
  public SearchText: string;
}
export class MaterialsListController {
  public MaterialCode: number;
  public MaterialName: string;
  public MaterialShortName: string;
  public MaterialDesscription: string;
  public MaterialType: string;
  public RecordStatus: string;
  public MaterialGroup: number;
  public MaterialFormattedCode: string;
  public MaterialID: string;
  public MaterialGroupName: string;
  public MaterialGroupShortName: string;
  public UOM: string;
}
export class ClinicalOrderRxHeaderController {
  public ClinicalOrderRxItemCode: number;
  public ClinicalOrderEntryCode: number;
  public Date: Date;
  public Patient: number;
  public OrderringProvider: number;
  public VisitCode: number;
  public RxEntryRecordStatus: string;
  public OrderType: string;
  public OrderTypeReference: number;
  public Admission: number;
  public Facility: number;
  public GenericMedicineCode: number;
  public GenericMedicineName: string;
  public MedicineTradeCode: number;
  public MedicineTradeName: string;
  public Form: string;
  public Dose: string;
  public Periodicity: string;
  public Frequency: string;
  public DurationType: string;
  public Duration: number;
  public StartDate: Date;
  public EndDate: Date;
  public Instructions: string;
  public StopIf: string;
  public StopReason: string;
  public StopDate: Date;
  public IsStopped: boolean;
  public RxItemRecordStatus: string;
  public OrderEntryType: string;
}
export class SaveMaterialToStoreInfoRequest extends BaseClass {
  public MaterialStoreCode: number;
  public MaterialStoreName: string;
  public SupplierCode: number;
  public SupplierName: string;
  public BatchNo: string;
  public ManufacturingDate: Date;
  public ExpiryDate: Date;
  public SellingPrice: number;
  public PurchasingPrice: number;
  public GST: string;
  public MaterialCode: number;
  public StockInUnits: number;
}
export class ClinicalOrderRxHeaderRequest extends BaseClass {
  public PatientCode: number;
  public FacilityCode: number;
  public ProviderCode: number;
  public FromDate: Date;
  public ToDate: Date;
}
export class TradedDrugDetailViewController {
  public Category: string;
  public GenericName: string;
  public TradeName: string;
  public DosageForm: string;
  public Concentration: string;
  public Unit: string;
  public Manufacturer: string;
  public CategoryCode: number;
  public GenericCode: number;
  public TradedDrugDetailCode: number;
  public TradeNameCode: number;
  public ConcentrationCode: number;
  public DosageFormCode: number;
  public ProductReference: number;
}
export class TradedDrugDetailViewRequest extends BaseClass {
  public FacilityCode: number;
}
export class ClinicalOrderRxItemsController {
  public ClinicalOrderRxItemCode: number;
  public ClinicalOrderEntryCode: number;
  public Date: Date;
  public Patient: number;
  public OrderringProvider: number;
  public VisitCode: number;
  public RxEntryRecordStatus: string;
  public OrderType: string;
  public OrderTypeReference: number;
  public Admission: number;
  public Facility: number;
  public GenericMedicineCode: number;
  public GenericMedicineName: string;
  public MedicineTradeCode: number;
  public MedicineTradeName: string;
  public Form: string;
  public Dose: string;
  public Periodicity: string;
  public Frequency: string;
  public DurationType: string;
  public Duration: number;
  public StartDate: Date;
  public EndDate: Date;
  public Instructions: string;
  public StopIf: string;
  public StopReason: string;
  public StopDate: Date;
  public IsStopped: boolean;
  public RxItemRecordStatus: string;
  public OrderEntryType: string;
  public Purpose: string;
  public Route: string;

}
export class ClinicalOrderRxItemsRequest extends BaseClass {
  public OrderCode: number;
  public PatientCode: number;
  public FacilityCode: number;
  public ProviderCode: number;
  public FromDate: Date;
  public ToDate: Date;
}
export class SaveClinicalOrderRxHeaderInfoRequest extends BaseClass {
  public Admission: number;
  public FacilityCode: number;
  public OrderEntryType: string;
  public OrderType: string;
  public OrderTypeReference: number;
  public OrderringProvider: number;
  public PatientCode: number;
  public VisitCode: number;
  public ClinicalOrderRxItemCode: number;
  public ClinicalOrderEntry: number;
  public Dose: string;
  public DoseNumeric: number;
  public DurationType: string;
  public Duration: number;
  public Form: string;
  public EndDate: Date;
  public Frequency: string;
  public GenericMedicineCode: number;
  public GenericMedicineName: string;
  public MedicineTradeCode: number;
  public MedicineTradeName: string;
  public Periodicity: string;
  public RecordStatus: string;
  public RecordStatus1: string;
  public StartDate: Date;
  public TradedDrugDetailCode: number;
  public StopDate: Date;
  public StopReason: string;
  public IsStopped: boolean;
  public Purpose: string;
  public Route: string;
  public Instructions: string;
}
export class SaveVendorInformationRequest extends BaseClass {

  public VendorMasterCode: number;
  public ActorType: number;
  public VendorSalutaion: string;
  public DisplayName: string;
  public AddressLine1: string;
  public AddressLine2: string;
  public City: string;
  public State: string;
  public Zip: string;
  public Country: string;
  public Telephone1: string;
  public Telephone2: string;
  public Landline1: string;
  public Landline2: string;
  public Mobile1: string;
  public Mobile2: string;
  public Fax1: string;
  public Email: string;
  public VendorActorCode: number;
  public VendorAddressCode: number;
  public VendorShortName: string;

}

export class SaveSemenDataRequest extends BaseClass {

  public TreatmentCycle: number;
  public IterationType: string;
  public DateofSampleCollection: Date;
  public TimeofSampleCollection: string;
  public Volume: number;
  public Count: number;
  public Motility: number;
  public ActiveProgressiveMotility: number;
  public CellularDebris: string;
  public MethodofPreparation: string;
  public IncubationTime: number;
  public MotileSpermCount: number;
  public MotileSpermMotility: number;
  public PreparedBy: number;
  public PreparedByName: string;
  public Notes: string;
  public CatheterLoadTime: Date;
  public CatheterLoadDate: Date;
  public CatheterLoadedBy: number;
  public CatheterLoadedByName: string;
  public ReadyForInsemination: boolean;
  public SlideObserved: boolean;
  public SlideObservedBy: number;
  public SlideObservedByName: string;
  public Day: number;
  public SampleType: string;
  public Morphology: string;
  public DFI: string;
  public ProgressiveMotility: string;
  public NonProgressiveMotility: string;
  public Immotile: string;

}
export class SaveIahOrderStatusRequest extends BaseClass {
  public IahOrderCode: number;
  public MessageText: string;
  public UserName: string;
  public Timestamp: Date;
  public OrderStatus: string;
  public Comments: string;
}
export class SaveBillItemsInfoRequest extends BaseClass {
  public Bill: NewBillData;
  public ChargeEntry: string;
}
export class SaveIPBillItemsInfoRequest extends BaseClass {
  public Bill: NewBillData;
  public ChargeEntry: string;
}
export class NewBillData {
  public ActorCode: number;
  public PatientName: string;
  public Gender: string;
  public PhoneNumber: string;
  public PatientFormattedCode: string;
  public BranchCode: number;
  public BranchName: string;
  public BillDate: Date;
  public TotalBill: number;
  public TotalTax: number;
  public TotalDiscount: number;
  public NetPayable: number;
  public TotalRefund: number;
  public Items: BillDetails[];
  public DeletedItems: BillDetails[];
  public PrescriberDoctor: PrescribingDoctor[];
  public ReferringDoctor: ReferringDoctor[];
  public ChargeEntryCode: number;
  public BillStatus: string;
  public AdvanceAmount: number;
  public AdmissionCode: number;
  public AdmissionFormattedCode: string;
  public Discountmode: string;
  public PreviousDiscount: number;
  public DiscountAmount: number;
  public DiscountRemarks: string;
  public BillType: string;// OP/RX/IP
  public BillSource: string;//Internal, Customer, Auto
  public PayOptions: BillPaymentOption[];

}
export class SaveRefundPayInfoRequest extends BaseClass {
  public RefundPay: NewBillData;
  public ChargeEntry: string;
  public CompanyRefundCode: number;
}
export class SaveBillRefundsInfoRequest extends BaseClass {
  public Refund: NewBillData;
  public ChargeEntry: number;;
}
export class BillRefundData {
  public ActorCode: number;
  public BillDate: Date;
  public BillSource: string;
  public BillStatus: string;
  public BillType: string;
  public BranchCode: number;
  public BranchName: string;
  public ChargeEntryCode: number;
  public Gender: string;
  public Items: RefundItemsData[];
  public DeletedItems: string;
  public PrescriberDoctor: PrescribingDoctor[];
  public ReferringDoctor: ReferringDoctor[];
  public PatientFormattedCode: string;
  public PatientName: string;
  public PhoneNumber: string;
  public TotalDiscount: number;
  public TotalBill: number;
  public NetPayable: number;

  //public long RefundableAmount { get; set; }
  //public long ItemCode { get; set; }
  //public string ItemDescription { get; set; }
  //public long UnitPrice { get; set; }
  //public long ItemTotal { get; set; }
  //public long RefundableAmount { get; set; }
}
export class RefundItemsData {
  public IsDeleted: boolean;
  public Edit: boolean;
  public RowNumber: number;
  public ServiceDescription: string;
  public Quantitiy: number;
  public Discount: number;
  public ItemCode: number;
  public UnitPrice: number;
  public ItemRate: number;
  public GroupName: number;
  public PackageName: string;
  public DiscountAllowed: boolean;
  public ChargeItemCode: boolean;
  public Editablecharge: boolean;
  public RefundableAmount: number;
}

export class RefundDetailsInfoController {
  public RefundItems: RefundItemsController[];
  public RefundHeader: RefundListController2;
}
export class RefundItemsController {

  public BillNo: string;
  public PatientAccountRefundItemCode: number;
  public FirstLevelApprovedAmount: number;
  public ItemCode: number;
  public ItemDescription: string;
  public ItemTotal: number;
  public PatientAccountRefund: number;
  public PatientChargeItem: number;
  public Quantity: number;
  public RefundableTotal: number;
  public RefundApproved: number;
  public RefundQuantity: number;
  public RefundTotal: number;
  public SecondLevelApprovedAmount: number;
  public UnitPrice: number;
  public Discount: number;
  public ServiceCategoryCode: number;
  public ServiceCategoryName: string;
  public CompanyRefundCode: number;
  public Net: number;
  public RefundableQuantity: number;
}
export class RefundListController2 {
  public RefundCode: number;
  public PatientCode: number;
  public PatientName: string;
  public PatientFormattedCode: string;
  public BranchCode: number;
  public BillNo: string;
  public RefundDate: Date;
  public ItemTotal: number;
  public RefundStatus: string;
  public RefundType: string;
  public ChargeEntry: number;
  public BillType: string;
  public RefundRequestDate: Date;
  public RefundReason: string;
  public RefundRequestedUser: number;
  public RefundRequestedUserName: string;
  public RefundableAmount: number;
  public RequestedAmount: number;
  public FirstLevelApprovedUserCode: number;
  public FirstLevelApprovedUserName: string;
  public FirstLevelRemarks: string;
  public FirstLevelApprovedDate: Date;
  public SecondLevelApprovedUserCode: number;
  public SecondLevelApprovedUserName: string;
  public SecondLevelRemarks: string;
  public SecondLevelApprovedDate: Date;
  public ApprovedAmount: number;
  public RefundRequestStatus: string;
  public RefundPaidAmount: number;
  public RefundPaidDate: Date;
  public Payer: number;
  public PayerName: string;
  public RequestMode: string;
  //public CompanyCode: number;
}
export class RefundItemsRequest extends BaseClass {
  public RefundCode: number;
  public Branch: number;
  public FromDate: Date;
  public ToDate: Date;
}
export class BedLocationsListController {
  public BedLocationCode: number;
  public BedLocationFormattedCode: number;
  public ParentLayout: number;
  public ColumnName: string;
  public BedNo: number;
  public IsBlocked: boolean;
  public IsAssigned: boolean;
  public RecordStatus: string;
  public IsAvailable: number;
  public ServiceCode: number;
  public AliasName: string;
}
export class BedLocationsListRequest extends BaseClass {
  public FacilityCode: number;
  public BedLocationCode: number;
  public SearchText: string;
  public FromDate: Date;
  public ToDate: Date;
}
export class ItemWiseServiceController {
  public GeneratedBranch: number;
  public PatientChargeEntryCode: number;
  public ChargeType: string;
  public BillNo: string;
  public BillDate: Date;
  public PatientName: string;
  public PatientFormattedCode: string;
  public ServiceCategoryName: string;
  public ItemDescription: string;
  public Quantity: number;
  public RefundQuantity: number;
  public UnitPrice: number;
  public BeforeDiscount: number;
  public Discount: number;
  public AfterDiscount: number;
  public TaxType: string;
  public TaxPercent: number;
  public TaxAmount: number;
  public Total: number;
  public RecordStatus: string;
  public BillStatus: string;
  public RefundNo: number;
  public PrescriberName: string;
  public ProviderName: string;
  public BranchCode: number;
  public BranchName: string;
  public CompanyCode: number;
  public CompanyName: string;
  public HSNCODE: string;
}
export class ItemWiseServiceRequest extends BaseClass {
  public ItemCode: number;
  public FacilityCode: number;
  public StoreCode: number;
  public FromDate: Date;
  public ToDate: Date;
}
export class SaveRefundStatusRequest extends BaseClass {
  public RefundCode: number;
  public UserName: string;
  public RefundReason: string;
  public RefundStatus: string;
}
export class ExternalDoctorsListController {
  public DocCode: number;
  public Prefix: string;
  public FirstName: string;
  public MiddleName: string;
  public LastName: string;
  public DisplayName: string;
  public ActorCode: number;
  public AddressLine1: string;
  public AddressLine2: string;
  public City: string;
  public Country: string;
  public State: string;
  public ZipCode: string;
  public Telephone1: string;
  public Telephone2: string;
  public Email: string;
  public ClinicName: string;
  public IsInchargeProvider: boolean;
  public IsPrimaryCareGiver: boolean;
  public IsReferralDoctor: boolean;
  public RecordStatus: string;
}
export class ExternalDoctorsListRequest extends BaseClass {
  public DoctorCode: number;
}
export class RefundListController {
  public RefundCode: number;
  public PatientCode: number;
  public PatientName: string;
  public BillFormattedCode: string;
  public BranchCode: number;
  public BillNo: string;
  public RefundDate: Date;
  public ItemTotal: number;
  public RefundStatus: string;
  public RefundType: string;
  public ChargeEntry: number;
  public BillType: string;
  public RefundRequestDate: Date;
  public RefundReason: string;
  public RefundRequestedUser: number;
  public RefundRequestedUserName: string;
  public RefundableAmount: number;
  public RequestedAmount: number;
  public FirstLevelApprovedUserCode: number;
  public FirstLevelApprovedUserName: string;
  public FirstLevelRemarks: string;
  public FirstLevelApprovedDate: Date;
  public SecondLevelApprovedUserCode: number;
  public SecondLevelApprovedUserName: string;
  public SecondLevelRemarks: string;
  public SecondLevelApprovedDate: Date;
  public ApprovedAmount: number;
  public RefundRequestStatus: string;
  public RefundPaidAmount: number;
  public RefundPaidDate: Date;
  public Payer: number;
  public PayerName: string;
  public RequestMode: string;
  public BillTotal: number;
  public Discount: number;
  public NetPaid: number;
}
export class RefundListRequest extends BaseClass {
  public Branch: number;
  public FromDate: Date;
  public ToDate: Date;
}
export class SaveExpenseVoucherRequest extends BaseClass {
  public HeaderCode: number;
  public FacilityCode: number;
  public FacilityName: string;
  public Employee: number;
  public EmployeeName: string;
  public ReceiptDate: Date;
  public ClaimStatus: string;
  public AuthorizeStatus: string;
  public ApprovedBy: number;
  public ApprovedByName: string;
  public PaymentType: string;
  public Purpose: string;
  public Remarks: string;
  public Item: ItemData[];
}
export class ItemData {
  public ItemCode: number;
  public ItemName: string;
  public Description: string;
  public Remarks: string;
  public ItemAmount: string;
}
export class ExpenseVoucherController {
  //public Facility: string; 
  //public EmployeeName: string; 
  //public Date: Date; 
  //public ClaimStatus: string; 
  //public AuthorizeStatus: string; 
  //public ApprovedByName: string; 
  //public PaymentType: string;
  //public Purpose: string;
  //public Remarks: string; 
  //public HeaderCode: number; 
  //public ItemCode: number; 
  //public Description: string; 
  //public ItemAmount: number;
  //public VoucherID: number;
  public JECode: number;
  public CECode: number;
  public ABECode: number;
  public ReceiptDate: Date;
  public VoucherNo: string;
  public Amount: number;
  public AmountTowards: string;
  public AuthorizedName: string;
  public AuthroizedOn: Date;
  public OfficeName: string;
  public AccountantName: string;
  public Status: string;
  public CreditAmount: number;
  public CreditStatus: string;
  public Particulars: string;
}
export class CustomCodeValuesController {
  public DisplayName: string;
  public SearchName: string;
  public Code: number;
}
export class CustomCodeTypeRequest extends BaseClass {
  public RequestedType: string;
  public FacilityCode: number;
  public CodeType: string;
  public ActorCode: number;
  public TestCode: number;
  public MedicineCode: number;
  public CustomCode: number;
  public CustomType: string;
  public StringContains: string;
  //  public ApiRequestModel SendApiRequestModel { get; set; }
}

export class ConsumptionGroupItemsController {
  public GroupCode: number;
  public GroupName: string;
  public GroupType: string;
  public ItemCode: number;
  public ItemName: string;
  public MinQty: number;
  public MaxQty: number;
  public Uom: string;
}
export class ConsumptionGroupItemsRequest extends BaseClass {
  public GroupCode: number;
  //public string ConditionalOperator { get; set; }


}
export class MaterialSpecsController {
  public MaterialSpecCode: number;
  public MaterialSpecName: string;
  public ShortName: string;
  public MaterialName: string;
  public MaterialGroupCode: number;
  public MaterialFormattedCode: string;
  public Material: number;
  public Uom: string;
  public UomCode: number;
  public MaterialGroupName: string;
  public TaxPercent: string;
}
export class MaterialSpecsRequest extends BaseClass {
  public MaterialCode: number;
  public SearchText: string;
}
export class LabSpecimenCollectionController {
  public OrderTestSpecimenCollectionCode: number;
  public CollectionMethod: string;
  public EnteredLocation: number;
  public DOC: string;
  public SpecimenCode: string;
  public SpecimenCollectionAmount: string;
  public SpecimenCollectionUOM: string;
  public RecievedOn: Date;
  public TestCategory: string;
  public SpecimenName: string;
  public Abstinence: string;
  public SpecimenCollectionTime: Time;
  public TestsName: string;
  public TestsShortName: string;
  public CollectedUser: string;
  public SpecimenFormattedCode: string;
  public GestationAge1: number;
  public GestationAge2: number;
  public Comments: string;
  public GestationAge1Units: string;
  public GestationAge2Units: string;
}
export class LabSpecimenCollectionRequest extends BaseClass {
  public LabOrderCode: number;
}
export class LabOrderDetailsController {
  public LabOrderCode: number;
  public EffectiveOrderDate: Date;
  public Branch: number;
  public EnteredBy: string;
  public FormattedCode: string;
  public OrderDate: Date;
  public OrderingProvider: number;
  public OrderStatus: string;
  public PatientID: number;
  public PatientName: string;
  public Gender: string;
  public AgeYears: number;
  public AgeMonths: number;
  public AddressLine1: string;
  public AddressLine2: string;
  public IsAdmitted: boolean;
  public AccountCode: number;
  public City: string;
  public State: string;
  public Country: string;
  public ZipCode: string;
  public Telephone1: string;
  public Telephone2: string;
  public PrimaryDoctor: string;
  public RefferingDoctor: string;
  public FacilityName: string;
}
export class LabOrderDetailsRequest extends BaseClass {
  public LabOrderCode: number;
}
export class LabOrderTestsController {
  public LabOrderCode: number;
  public OrderTestCode: number;
  public OrderDate: Date;
  public OrderStatus: string;
  public LabOrderFormattedCode: string;
  public EnteredLocation: number;
  public PatientID: number;
  public TestName: string;
  public LabDepartment: number;
  public OrderTestStatus: string;
  public IsSpecimenAssociated: boolean;
  public SpecimenCollectionStatus: string;
  public HasFirstSign: boolean;
  public HasSecondSign: boolean;
  public FirstSignCode: number;
  public FirstSign: string;
  public SecondSignCode: number;
  public SecondSign: string;
  public LabType: string;
  public OrderType: string;
  public OrderReferenceNo: number;
  public PaymentStatus: string;
  public Organism: string;
  public Remarks: string;
  public Specimen: string;
  public TestSpecimenCode: number;
  public SpecimenUOM: string;
  public IsSelected: boolean;
  public LabDepartmentName: string;
}
export class LabOrderTestsRequest extends BaseClass {
  public LabOrderCode: number;
  public UserCode: number;
}

export class SaveConsumptionGroupRequest extends BaseClass {
  public GroupName: string;
  public GroupType: string;
  public GroupCode: number;
}
export class SaveConsumptionGroupItemRequest extends BaseClass {
  public ItemName: string;
  public ItemCode: number;
  public MinQty: number;
  public MaxQty: number;
  public UomCode: number;
  public UomName: string;
  public GroupCode: number;
  public GroupItemCode: number;
}
export class MaterialConsumptionEntries2Controller {
  public EntryDate: Date;
  public EntryTime: Time;
  public Remarks: string;
  public EntryCode: number;
  public EntryUser: number;
  public EntryUserName: string;
  public UserDepartmentName: string;
  public RegisterType: string;
  public AdjustmentStatus: string;
  public OwnerLocation: number;
  public OwnerLocationShortName: string;
  public FormattedCode: string;
  public PatientCode: number;
  public PatientFormattedCode: string;
  public PatientName: string;
  public IsEntryUpdated: boolean;
  public ConsumptionGroupCode: number;
  public ConsumptionGroupName: string;
  public StoreLocation: number;
  public StoreLocationName: string;
}
export class MaterialConsumptionEntriesRequest extends BaseClass {

  public PatientRegistrationNumber: number;
  public BranchCode: number;
  public FromDate: Date;
  public ToDate: Date;

}

export class SavePaymentModeInfoRequest extends BaseClass {
  public BillFormattedCode: string;
  public ReceiptNo: number;
  public CurrentPayMode: string;
  public ChangeToPayMode: string;
  public PatientAccountReceiptDetailCode: number;
}

export class MaterialBatchInaStoreController {
  public MaterialBatchStorage: number;
  public StorageLocation: number;
  public StorageLocationName: string;
  public StoreFacility: number;
  public SupplierMaterialBatchCode: number;
  public EntryDate: Date;
  public BatchNo: string;
  public BatchQuantity: number;
  public BatchUOM: string;
  public GRNDocId: number;
  public MfgDate: Date;
  public ExpiryDate: Date;
  public MaterialSpecCode: number;
  public MaterialSpecName: string;
  public AvailableQuantity: number;
  public IssueQuantity: number;
  public MaterialBatchRecordStatus: string;
  public SupplierBatchRecordStatus: string;
  public PurchaseUnitPrice: number;
  public PurchaseUnit: string;
  public PurchaseUOM: string;
  public ReceivedDate: Date;
  public SellingPrice: number;
  public SellingUnit: string;
  public SellingUOM: string;
  public SupplierCode: number;
  public SupplierShortName: string;
  public TaxShortName: string;
  public TaxPercent: number;
  public MinSellQty: number;
  public MinSellUnitName: string;
  public MinSellUoM: number;
  public SaleUomCode: number;
  public SaleUOM: string;
  public Quantity: number;
  public HsnCode: number;
}
export class MaterialBatchInaStoreRequest extends BaseClass {

  //public string ConditionalOperator { get; set; }
  public StoreCode: number;
  public MaterialCode: number;
  public MaterialBatchCode: number;
  public FromDate: Date;
  public ToDate: Date;
  public BranchCode: number;

}

export class GenerateIahBillRequest extends BaseClass {
  public IahOrderCode: number;
}

export class ExpenseVoucherRequest extends BaseClass {

  //public ConditionalOperator: string;  //10 list, , 20 -- detail with voucher id

  public VoucherID: string;



}
export class ExpenseVouchersController {
  public EmployeeName: string;
  public ClaimStatus: string;
  public AuthorizeStatus: string;
  public RecordKey: number;
  public EntryDate: Date;
  public journalcode: number;
  public officecode: number;
  public ReceiptDate: Date;
  public VoucherNo: string;
  public Towards: string;
  public TotalAmount: number;
  public PaymentInstrument: string;
}
export class ExpenseVouchersRequest extends BaseClass {

  //public string ConditionalOperator { get; set; }
  public FacilityCode: number;
  public FromDate: Date;
  public ToDate: Date;


}
export class LabOrderRequestsController {
  public OrderCode: number;
  public OrderTestCode: number;
  public PatientCode: number;
  public OrderDate: Date;
  public OrderStatus: string;
  public EnteredLocation: number;
  public OrderFormattedCode: string;
  public PatientName: string;
  public Gender: string;
  public AgeInYears: number;
  public LabDepartment: number;
  public LabTestName: string;
  public LabTestCode: number;
  public IsSpecimenAssociated: boolean;
  public PatientFormattedCode: string;
  public ServiceCode: number;
  public PaymentStatus: string;
  public TestCategory: string;
  public TestType: string;
  public OrderTestStatus: string;
  public SpecimenCollectionStatus: string;
  public LabDepartmentName: string;
  public EnteredByUser: string;
}
export class LabOrdersRequest extends BaseClass {
  public FacilityCode: number;
  public FromDate: Date;
  public ToDate: Date;
  public Department: number;
  public SearchText: string;
  public PatientCode: number;
}

export class RefundDetailsRequest extends BaseClass {

  //public string ConditionalOperator { get; set; }
  public Facility: number;
  public FromDate: Date;
  public ToDate: Date;
  public RequestStatus: string;
  public RefundCode: number;
  public PatientCode: number;

}
export class RefundDetailsController {
  public RefundRequestCode: number;
  public AccountNo: number;
  public PatientCode: number;
  public PatientFormattedRegCode: string;
  public PatientName: string;
  public PatientChargeEntry: number;
  public RefundReason: string;
  public RefundTotal: number;
  public RequestedAmount: number;
  public FirstLevelApprovedUser: string;
  public SecondLevelApprovedUser: string;
  public RequestStatus: string;
  public RefundStatus: string;
  public BothSignatureRequired: boolean;
  public Branch: number;
  public BranchName: string;
  public FirstLevelApproved: boolean;
  public SecondLevelApproved: boolean;
  public ChargeType: string;
  public ApprovedAmount: number;
  public RefundType: string;
  public BillNo: string;
  public RefundRequestDate: Date;
  public ApprovedDate: Date;
  public PatientGender: string;
  public PatientAgeY: number;
  public PatientPhoneNumber: string;
  public RefundRequestedUser: number;
  public RefundRequestedUserName: string;
  public Payer: number;
  public PayerName: string;

}

export class RefundDetailsData {
  public Items: RefundItemDetailsController[];
  public Master: RefundDetailsController;
}
export class RefundItemDetailsController {
  public RefundRequestCode: number;
  public RefundRequestItemCode: number;
  public PatientChargeItemCode: number;
  public ItemDescription: string;
  public ItemTotal: number;
  public Quantity: number;
  public RefundTotal: number;
  public Remarks: string;
  public RefundQuantity: number;
  public RefundApprovedAmount: number;
  public FirstLevelApprovedAmount: number;
  public SecondLevelApprovedAmount: number;
  public PostedUserName: string;
  public RefundPaidDate: Date;
  public Remarks1: string;
  public RequestRemarks: string;
  public FirstLevelRemarks: string;
  public SecondLevelRemarks: string;
}
export class BillPaymentOption {
  public PaymentMode: string;
  public IsSelected: boolean;
  public Amount: number;
  public Charges: number;
  public Refno: string;
  public Details: string;
}
export class BillHeaderWithItemsController {
  public ChargeEntryCode: number;
  public PatientName: string;
  public PatientAgeY: number;
  public ItemDescription: string;
  public Column1: string;
  public BillCode: string;
  public NetBillValue: number;
  public BillType: string;
  public BillDate: Date;
  public RefundableQuantity: number;
  public Quantity: number;
  public ItemValue: number;
  public BranchCode: number;
  public BranchName: string;
  public ActorCode: number;
}
export class BillHeaderWithItemsRequest extends BaseClass {
  public FromDate: Date;
  public ToDate: Date;
  public ChargeEntry: number;
  public ActorCode: number;

}


export class OrderData {
  public OrderItemCode: number;
  public ItemCode: Number;
  public Quantity: number;
  public ItemType: string;
  public Pack: string;
  public RowNumber: number;
  public Edit: boolean;
  public ItemRate: number;
  public ItemName: string;
  public Uom: number;
  public ItemGroup: string;
  public UnitPrice: number;
  public AssignedTo: number;
  public AssignedToName: string;
  public ScheduledDate: Date;
  public ScheduledTime: string;
}
export class IahOrdersController {
  public Code: number;
  public BranchLocation: number;
  public CreatedTime: Date;
  public CreatedUser: string;
  public CustomerName: string;
  public DeliverToAddress: string;
  public Discount: number;
  public MailAddress: string;
  public MobileNumber: string;
  public OrderDate: Date;
  public TotalAmount: number;
  public OrderStatus: string;
  public OrderSource: string;
  public CustomerActorCode: number;
  public CustomerActorFormattedCode: string;
  public AdmissionCode: number;
  public AgeY: number;
  public Gender: string;
  public PrescProvider: number;
  public PrescName: string;
  public ReferName: string;
  public ReferProvider: number;
  public VisitCode: number;
  public BillStatus: string;
  public OrderType: string;
}
export class IahOrdersRequest extends BaseClass {

  public BranchCode: number;
  public ActorCode: number;
  public FromDate: Date;
  public ToDate: Date;

}
export class IahOrderItemsController {
  public CustomerOrderItemCode: number;
  public ItemCode: number;
  public ItemGroup: number;
  public ItemType: string;
  public CustomerOrderCode: number;
  public Pack: string;
  public Quantity: number;
  public UnitPrice: number;
  public Uom: string;
  public AssignedTo: number;
  public AssignedToName: string;
  public Feedback: string;
  public ScheduledDate: Date;
  public ScheduledTime: Time;
  public ServiceStatus: string;
  public ItemName: string;
  public Comments: string;
}
export class IahOrderItemsRequest extends BaseClass {

  public IahOrderCode: number;
  public ActorCode: number;

}
export class FinalizeConsumptionEntryRequest extends BaseClass {
  public ConsumptionOrderCode: number;
}
export class GenerateIahOrderFromBillRequest extends BaseClass {
  public ChargeEntryCode: number;
}
export class IahOrderStatusTrackController {
  public Code: number;
  public CreatedUser: string;
  public FromStatus: string;
  public ToStatus: string;
  public Remarks: string;
  public StatusChangeOn: Date;
}
export class IahOrderStatusTrackRequest extends BaseClass {

  public IahOrderCode: number;

}
export class MaterialConsumptionItemsController {
  public MaterialConsumptionItemCode: number;
  public EntryDate: Date;
  public EntryTime: Time;
  public ExpiryDate: Date;
  public ItemCode: number;
  public ItemDescription: string;
  public ItemCost: number;
  public Material: number;
  public MaterialBatchStorage: number;
  public SupplierMaterialBatch: number;
  public MaterialGroup: number;
  public Remarks: string;
  public Quantity: number;
  public Uom: string;
  public GroupCode: number;
  public SupplierBatchDetails: string;
}
export class MaterialConsumptionItemsRequest extends BaseClass {

  public PatientRegistrationNumber: number;
  public ConsumptionCode: number;
}

export class SaveIahOrderItemStatusRequest extends BaseClass {

  //public string ConditionalOperator { get; set; }
  //public long PatientCode { get; set; }
  public IahOrderCode: number;
  public IahOrderItemCode: number;
  public MessageText: string;
  public UserName: string;
  public Timestamp: Date;
  public AssignedTo: number;
  public AssignedToName: string;
  public Time: Time;
  public OrderItemStatus: string;
  public Comments: string;
}
export class SaveMaterialConsumptionEntriesRequest extends BaseClass {

  public UserDepartment: string;
  public ConsumptionCode: number;
  public OwnerLocation: number;// employee login facility location code
  public OwnerLocationName: string; // employee login facility location name
  public StoreLocation: number;
  public StoreName: string;
  public Remarks: string;
  public PatientCode: number;
  public PatientName: string;
  public PatientFormattedCode: string;
  public ConsumptionGroup: number;
  public consumptionGroupName: string;
  public ConsumptionItems: ConsumptionItemsData[];

}

export class ConsumptionItemsData {

  public Code: number;
  public ItemCode: number;
  public ItemName: string;
  public Material: number;
  public MaterialGroup: number;
  public Supplier: number;
  public SupplierName: string;
  public MaterialBatchStorage: number;
  public Quantity: number
  public ItemCost: number;
  public ExpiryDate: Date;
  public SupplierBatchDetails: string;
  public Remarks: string;
  public SupplierMaterialBatch: number;
}

export class SaveSpermDetailsRequest extends BaseClass {

  public HASIMSI: boolean;
  public IMSIDetails: string;
  public IMSIPerformedBy: number;
  public IMSIPerformedByName: string;
  public Remarks2: string;
  public hasIVF: boolean;
  public IVFDetails: string;
  public IVFPerformedBy: number;
  public IVFPerformedByName: string;
  public Remarks3: string;
  public HasICSI: boolean;
  public ICSIDetails: string;
  public ICSIPerformedBy: number;
  public ICSIPerformedByName: string;
  public Remarks: string;
  public TreatmentCycleCode: number;
  public CycleOocyteQualityCode: number;
  public SpermSource: string;
  public SpermRetrieval: string;
  public SpermSourceFrom: string;
  public StorageLocation: number;
  public StorageLocationDetails: string;
  public StoreUnitLocation: number;
  public StoreUnitLocationDetails: string;
  public ExtractionDate: Date;
  public ExtractionTime: Date;
  public SpermSourceCode: number;
  public SpermSourceFormattedCode: string;
  public ExtractionTimeText: string;


}
export class SaveRefundApprovalRequest extends BaseClass {
  public BillNo: string;
  public PatientChargeItemCode: number;
  public RefundRequestItemCode: number;
  public RefundRequestCode: number;
  public RefundTotal: number;
  public FirstLevelApprovedUser: string;
  public SecondLevelApprovedUser: string;
  public ChargeType: string;
  public Comments: string;
  public CreatedTimeStamp: Date;


}
export class BranchWiseRevenueController {
  public year: number;
  public MonthName: string;
  public Month: number;
  public GG1: number;
  public GG2: number;
  public GG4: number;
  public GGHO: number;
}
export class BranchWiseRevenueRequest extends BaseClass {


  public FromDate: Date;
  public ToDate: Date;

}

export class BranchWiseRegistrationsController {
  public year: number;
  public MonthName: string;
  public Month: number;
  public GG1: number;
  public GG2: number;
  public GG4: number;
  public GGHO: number;
}

export class BranchWiseRegistrationsRequest extends BaseClass {


  public FromDate: Date;
  public ToDate: Date;

}
export class BranchWiseRefundsRequest extends BaseClass {


  public FromDate: Date;
  public ToDate: Date;

}
export class BranchWiseRefundsController {
  public year: number;
  public MonthName: string;
  public Month: number;
  public GG1: number;
  public GG2: number;
  public GG4: number;
  public GGHO: number;
}
export class BranchWiseVendorInvoiceRequest extends BaseClass {


  public FromDate: Date;
  public ToDate: Date;

}
export class BranchWiseVendorInvoiceController {
  public year: number;
  public MonthName: string;
  public Month: number;
  public GG1: number;
  public GG2: number;
  public GG4: number;
  public GGHO: number;
}
export class BranchWiseDuesRequest extends BaseClass {


  public FromDate: Date;
  public ToDate: Date;

}
export class BranchWiseDuesController {
  public year: number;
  public MonthName: string;
  public Month: number;
  public GG1: number;
  public GG2: number;
  public GG4: number;
  public GGHO: number;
}
export class LabDepartmentsListController {
  public ServiceCategoryCode: number;
  public CategoryName: string;
  public RecordStatus: string;
  public ParentCode: number;
  public ItemType: string;
}
export class LabDepartmentsListRequest extends BaseClass {

  public FacilityCode: number;
}
export class TestsByLabCodeController {
  public Code: number;
  public Name: string;
  public TestName: string;
  public LabDepartment: number;
  public ServiceCategoryCode: number;
  public CategoryName: string;
  public LabDepartmentName: string;
  public RecordStatus: string;
  public ParentCode: number;
  public ItemType: string;
  public AgeProfile: number;
  public ProfileName: string;
  public ServiceCode: number;
  public TestCategory: string;
}
export class TestsByLabCodeRequest extends BaseClass {
  public FacilityCode: number;
  public LabCode: number;
}
export class LabOrdersListController {
  public OrderTestCode: number;
  public EffectiveOrderDate: Date;
  public Signby: string;
  public PatientRegNumber: string;
  public PatientDisplayName: string;
  public TestName: string;
  public TestCode: number;
  public LabName: string;
  public LabCode: number;
  public IsSpecimenAssociated: number;
  public OrderTestStatus: string;
  public IsExternalLab: number;
  public FileLocationCode: number;
}
export class LabOrdersListRequest extends BaseClass {

  public PatientRegNumber: string;
  public EffectiveOrderDate: Date;
  public LabCode: number;
  public TestCode: number;
  public OrderTestCode: number;
}
export class OrderTestDataByCodeController {
  public ObservationName: string;
  public OrderTestStatus: string;
  public SpecimenCollectionStatus: string;
  public ObservationValue: string;
  public ReferenceRange: string;
  public UOM: string;
  public RequestedOn: string;
  public HasSecondSign: boolean;
  public HasAccessFirstSign: boolean;
  public HasAccessSecondSign: boolean;
  public FaciltyShortName: string;
  public FacilityName: string;
  public FacilityCode: number;
  public OrderDate: Date;
  public IsUnsignEdit: boolean;
  public TestName: string;
}
export class OrderTestDataByCodeRequest extends BaseClass {

  public OrderTestCode: number;
  //public isUnsignEdit: boolean;
  //public isDefalut: boolean;
}
export class VendorsListController {

  public VendorCode: number;
  public Prefix: string;
  public FirstName: string;
  public MiddleName: string;
  public LastName: string;
  public DisplayName: string;
  public ActorCode: number;
  public AddressLine1: string;
  public AddressLine2: string;
  public Country: string;
  public State: string;
  public ZipCode: string;
  public Telephone1: string;
  public Telephone2: string;
  public Email: string;
  public ShortName: string;
  public FormattedCode: string;
  public RecordStatus: string;

  public City: string;
  public VendorFax: string;

}
export class VendorsListRequest extends BaseClass {
  public VendorCode: number;
}

export class SpermSourceDetailsController {
  public TreatmentCycleCode: number;
  public OocyteQualityCode: number;
  public ProtocolName: string;
  public ProtocolStartDate: Date;
  public ProtocolEndDate: Date;
  public LMP: Date;
  public CycleNo: number;
  public InfertilityType: string;
  public EggSourceType: string;
  public LMPCycle: string;
  public IsReadyForPickup: boolean;
  public IsPickedUp: boolean;
  public IsPickupApproved: boolean;
  public RecepientType: string;
  public DateOfInsemination: Date;
  public CycleType: string;
  public CycleCreateAt: Date;
  public CreatedUser: string;
  public CycleCreatedUser: string;
  public CycleCreatedBranch: number;
  public OwnerName: string;
  public OwnerGender: string;
  public OwnerFormattedCode: string;
  public OwnerActorCode: number;
  public RecepientActorCode: number;
  public OwnerTelephone1: string;
  public OwnerTelephone2: string;
  public OwnerAgeYears: number;
  public OwnerPatientImageFile: string;
  public OwnerFileExtension: string;
  public RecepientName: string;
  public RecepientGender: string;
  public RecepientFormattedCode: string;
  public RecepientTelephone1: string;
  public RecepientTelephone2: string;
  public RecepientAgeYears: number;
  public RecepientPatientImageFile: string;
  public RecepientFileExtension: string;
  public TotalOocytes: number;
  public SpermSourceFrom: string;
  public SpermSource: string;
  public StorageLocationDetails: string;
  public SpermRetrieval: string;
  public TreatmentCycle: number;
  public IterationType: string;
  public Volume: number;
  public Count: number;
  public Motility: number;
  public ActiveProgressiveMotility: number;
  public CellularDebris: string;
  public IncubationTime: number;
  public MotileSpermCount: number;
  public MotileSpermMotility: number;
  public PreparedBy: number;
  public PreparedByName: string;
  public Notes: string;
  public RecordStatus: string;
  public CatheterLoadTime: Date;
  public CatheterLoadDate: Date;
  public CatheterLoadedBy: number;
  public CatheterLoadedByName: string;
  public ReadyForInsemination: boolean;
  public SlideObserved: boolean;
  public SlideObservedBy: number;
  public SlideObservedByName: string;
  public Day: number;
  public SampleType: string;
  public SemenDataCode: number;
  public DateOfSampleCollection: Date;
  public TimeOFSampleCollection: string;
  public MethodOfPreparation: string;
  public Morphology: string;
  public DFI: string;
  public ProgressiveMotility: string;
  public NonProgressiveMotility: string;
  public SpermSourceCode: number;
  public SpermSourceName: string;
  public Immotile: string;
  public ExtractionTimeText: string;
}
export class SpermSourceDetailsRequest extends BaseClass {


  public FromDate: Date;
  public ToDate: Date;
  public Status: string;
  //public long From { get; set; }
  public CycleCode: number;
  public Branch: number;
  //public string ActorCode { get; set; }
  public SemanDataCode: number;

}
export class ConvertEmbryoGradingToWellCultureRequest extends BaseClass {

  public CycleCode: number;
}
export class ReadyForPickUpsBetweenDateController {
  public PickUpCode: number;
  public TreatmentCycleCode: number;
  public ProtocolName: string;
  public ProtocolStartDate: Date;
  public ProtocolEndDate: Date;
  public LMP: Date;
  public CycleNo: number;
  public InfertilityType: string;
  public EggSourceType: string;
  public LMPCycle: string;
  public IsReadyForPickup: boolean;
  public IsPickedUp: boolean;
  public IsPickupApproved: boolean;
  public CycleType: string;
  public CycleCreateAt: Date;
  public CreatedUser: number;
  public CycleCreatedUser: string;
  public CycleCreatedBranch: number;
  public OwnerName: string;
  public OwnerGender: string;
  public OwnerFormattedCode: string;
  public OwnerTelephone1: string;
  public OwnerTelephone2: string;
  public OwnerAgeYears: number;
  public OwnerPatientImageFile: string;
  public OwnerFileExtension: string;
  public EggName: string;
  public EggGender: string;
  public EggFormattedCode: string;
  public EggTelephone1: string;
  public EggTelephone2: string;
  public EggAgeYears: number;
  public EggPatientImageFile: string;
  public EggFileExtension: string;
  public ActivityStatus: string;
  public LastUpdatedTime: Date;

}
export class SaveCycleStatusRequest extends BaseClass {


  //public int ConditionalOperator { get; set; }
  public TreatmentCycleCode: number;
  public ActivityName: string;
  public ActivityStatus: string;
  public Remarks: string;

}
export class TreatmentCycleInfoController {
  public Code: number;
  public ProtocolName: string;
  public ProtocolStartDate: Date;
  public ProtocolEndDate: Date;
  public ProtocolDuration: number;
  public CycleResult: string;
  public LMP: Date;
  public CycleNo: number;
  public Episode: number;
  public Protocol: number;
  public CycleRemarks: string;
  public InfertilityType: string;
  public TreatmentProcedure: string;
  public EggSourceType: string;
  public EggSource: number;
  public SpermSourceType: string;
  public SpermSource: number;
  public SpermSourceFormattedCode: string;
  public SpermRetrieval: string;
  public PregnancyType: string;
  public ClinicianSign: string;
  public EmbryologistSign: string;
  public LMPCycle: string;
  public DateOfInsemination: Date;
  public TimeOfInsemination: Date;
  public IsReadyForPickup: boolean;
  public IsPickedUp: boolean;
  public IsReadyForTransfer: boolean;
  public IsTransferred: boolean;
  public IsPickupApproved: boolean;
  public LMPCycleRemarks: string;
  public MemberRegistration: number;
  public RecepientType: string;
  public Recepient: number;
  public RecepientLMP: Date;
  public BlockEggDonor: boolean;
  public BlockRecepient: boolean;
  public BlockSpermDonor: boolean;
  public IsCycleClosed: boolean;
  public ClosingRemarks: string;
  public ClosedByUser: number;
  public ClosedByUserName: string;
  public ETPending: boolean;
  public ETPendingDate: Date;
  public ETResume: boolean;
  public ETResumeDate: Date;
  public ETPendingRemarks: string;
  public CycleType: string;
  public CycleTypeChangeRemarks: string;
  public CreatedDate: Date;
  public CreatedUser: number;
  public CreatedUserName: string;
  public CreatedFacility: number;
  public ClosingDate: Date;
  public OwnerName: string;
  public OwnerGender: string;
  public OwnerFormattedCode: string;
  public OwnerRegistrationDate: Date;
  public OwnerOldRegistrationNo: string;
  public OwnerTelephone1: string;
  public OwnerTelephone2: string;
  public OwnerEmail: string;
  public OwnerAgeYears: number;
  public OwnerCity: string;
  public OwnerPatientRegistrationNo: number;
  public OwnerActorCode: number;
  public OwnerPatientImageFile: string;
  public OwnerFileExtension: string;
  public EggName: string;
  public EggGender: string;
  public EggFormattedCode: string;
  public EggRegistrationDate: Date;
  public EggOldRegistrationNo: string;
  public EggTelephone1: string;
  public EggTelephone2: string;
  public EggEmail: string;
  public EggAgeYears: number;
  public EggCity: string;
  public EggPatientRegistrationNo: number;
  public EggActorCode: number;
  public EggPatientImageFile: string;
  public EggFileExtension: string;
  public RecepientName: string;
  public RecepientGender: string;
  public RecepientFormattedCode: string;
  public RecepientRegistrationDate: Date;
  public RecepientOldRegistrationNo: string;
  public RecepientTelephone1: string;
  public RecepientTelephone2: string;
  public RecepientEmail: string;
  public RecepientAgeYears: number;
  public RecepientCity: string;
  public RecepientPatientRegistrationNo: number;
  public RecepientActorCode: number;
  public RecepientPatientImageFile: string;
  public RecepientFileExtension: string;
  public FacilityName: string;
  public GradingModel: string;

}
export class TreatmentCyclesInfoRequest extends BaseClass {


  public FromDate: Date;
  public ToDate: Date;
  public Status: string;
  //public long From { get; set; }
  public CycleCode: number;
  public Branch: number;
  // public string ConditionalOperator { get; set; }

}
export class TreatmentCycleStatusController {
  public TreatmentCycleCode: number;
  public PhaseActivity: string;
  public ActivityStatus: string;
  public Remarks: string;
  public LastUpdatedUserName: string;
  public LastUpdatedTime: string;
  public CycleStatusCode: number;
  public Sequence: number;
}
export class PatientVisitDetailsController {
  public PatientCode: number;
  public FormattedCode: string;
  public VisitDate: Date;
  public Services: string;
}
export class PatientVisitDetailsRequest extends BaseClass {
  public PatientFormattedCode: string;

}
export class CaseRecordSignatoryController {
  public Title: string;
  public SignAuthority: string;
  public Line1: string;
  public Line2: string;
  public Line3: string;
}
export class CaseRecordSignatoryRequest extends BaseClass {
  public RecordType: string;
  public FacilityCode: number;
}
export class PatientwiseLabReportsController {
  public OrderRequestCode: number;
  public PatientID: number;
  public TestCode: number;
  public TestName: string;
  public LabDepartment: string;
  public Signby: string;
  public PatientRegNumber: string;
  public PatientDisplayName: string;
  public TestCategory: string;
  public ObservationName: string;
  public OrderTestStatus: string;
  public SpecimenCollectionStatus: string;
  public ObservationValue: string;
  public ReferenceRange: string;
  public UOM: string;
  public RequestedOn: string;
  public FaciltyShortName: string;
  public FacilityCode: number;
  public OrderDate: Date;
}
export class PatientwiseLabReportsRequest extends BaseClass {
  public PatientFormattedCode: string;
  public ActorCode: number;
  public PatientCode: number;

}

export class PatientwiseLabReportsByTestCodeController {
  public OrderRequestCode: number;
  public PatientID: number;
  public TestCode: number;
  public TestName: string;
  public LabDepartment: string;
  public Signby: string;
  public PatientRegNumber: string;
  public PatientDisplayName: string;
  public TestCategory: string;
  public ObservationName: string;
  public OrderTestStatus: string;
  public SpecimenCollectionStatus: string;
  public ObservationValue: string;
  public ReferenceRange: string;
  public UOM: string;
  public RequestedOn: string;
  public FaciltyShortName: string;
  public FacilityCode: number;
  public OrderDate: Date;
}
export class PatientwiseLabReportsByTestCodeRequest extends BaseClass {
  public ActorCode: number;
  public TestCode: number;

}
export class TreatmentCycleStatusRequest extends BaseClass {
  public TreatmentCycleCode: number;
}
export class ReadyForPickUpsBetweenDateRequest extends BaseClass {

  public FacilityCode: number;
  public FromDate: Date;
  public ToDate: Date;

}
export class CaseRegistrationByActorCodeController {
  public BaccCaseRegistrationCode: number;
  public BaccCaseRegistrationFormatted: string;
  public FemaleActor: number;
  public MaleActor: number;
  public RegistrationDate: Date;
  public EdrDisplayName: string;
  public EdrAddressLine1: string;
  public EdrAddressLine2: string;
  public EdrCity: string;
  public EdrState: string;
  public EdrCountry: string;
  public EdrEmail: string;
  public EdrZipCode: string;
  public EdrTelephone1: string;
  public EdrTelephone2: string;
  public EdrClinicName: string;
  public MarriageDate: Date;
  public BaseLocation: number;
  public ReferredBy: string;
  public ReferralContact: string
  public RefType: string;
  public RefDetails: string;
  public RefClinic: string;
  public FFormattedCode: string;
  public FDisplayName: string;
  public FPrefix: string;
  public FGender: string;
  public FRegistrationDate: Date;
  public FTelephone1: string;
  public FTelephone2: string;
  public FTotalBill: number;
  public FTotalPaid: number;
  public FBalance: number;
  public FLastPaidAmount: number;
  public FLastPaidDate: Date;
  public FLastBillAmount: number;
  public FLastBillDate: Date;
  public MFormattedCode: string;
  public MDisplayName: string;
  public MPrefix: string;
  public MGender: string;
  public MRegistrationDate: Date;
  public MTelephone1: string;
  public MTelephone2: string;
  public MTotalBill: number;
  public MTotalPaid: number;
  public MBalance: number;
  public MLastPaidAmount: number;
  public MLastPaidDate: Date;
  public MLastBillAmount: number;
  public MLastBillDate: Date;
  public AddressLine1: string;
  public City: string;
  public State: string;
  public AddressCode: number;
  public FDateOfBirth: Date;
  public MDateOfBirth: Date;
}
export class CaseRegistrationByActorCodeRequest extends BaseClass {
  public ActorCode: number;
  //public FromDate: Date;
  //public ToDate: Date;
  public Branch: number;

}
export class SingleWellInseminationByCycleController {
  public WellFollicle: number;
  public TreatmentCycle: number;
  public WellNo: number;
  public OocyteQualityPre: string;
  public OocyteQualityPost: string;
  public Morphology: string;
  public IsFrozen: boolean;
  public IsDiscarded: boolean;
  public iscontinue: number;
  public InseminationDate: Date;
  public technique: string;
  public IsSelected: boolean;
}
export class SingleWellInseminationByCycleRequest extends BaseClass {

  public TreatmentCycle: number;

}
export class IvfCycleInseminationLogByCycleWithDOCController {
  public InseminationLogCode: number;
  public TreatmentCycle: number;
  public IterationType: string;
  public RecordStatus: string;
  public DateofCollection: Date;
  public TimeofCollection: Date;
  public NtimesInformed: number;
  public InseminationDate: Date;
  public InseminationTime: Date;
  public ProcessedBy: number;
  public ProcessedByName: string;
  public SlideObserved: boolean;
  public Doctor: number;
  public DoctorName: string;
  public Nurse: number;
  public NurseName: string;
  public Patient: number;
  public InseminationTimeText: string;
}
export class IvfCycleInseminationLogByCycleWithDOCRequest extends BaseClass {

  public TreatmentCycle: number;
  public DOC: number;

}
export class IvfCycleInseminationByCycleController {
  public TreatmentCycle: number;
  public Technique: string;
  public OocyteCount: number;
  public InseminationCode: number;
  public PrescribedBy: number;
  public PrescribedByName: string;
  public Remarks: string;

}
export class SaveIvfCycleInseminationInfoRequest extends BaseClass {

  //public string ConditionalOperator { get; set; }

  public CycleCode: number;
  public Technique: string;
  public OocyteCount: number;
  public RecordStatus: string;
  public PrescribedByName: string;
  public Remarks: string;
  public PrescribedBy: number;
  public InseminationCode: number;

}
export class IvfCycleInseminationByCycleRequest extends BaseClass {

  //public string ConditionalOperator { get; set; }

  public CycleCode: number;


}
export class SaveAppointmentInformationNewRequest extends BaseClass {

  // public long CalendarCode { get; set; }
  public ActorCode: number;
  public AppointmentCode: number;
  public SlotNumber: number;
  public Gender: string;
  public AppointmentStatus: string;
  public PatientName: string;
  public Telephone: string;
  public ConsultationType: string;
  public ProviderCode: number;
  public SessionCode: number;
  public LocationCode: number;
  public wod: number;
  public ProviderName: string;
  public Date: Date;
  public StartTime: Date;
  public Specialty: string;
  public FormattedCode: string;
  public Email: string;
  public Age: number;
  public ActorGID: string;
  public VisitType: string;
  //public ConsultationType: string;
}
export class SaveSingleWellInseminationInfoRequest extends BaseClass {

  public WellFollicle: number;
  public technique: string;
  public InseminationDate: Date;
}
export class CompleteIvfCycleInseminationRequest extends BaseClass {

  public CycleCode: number;
  public DateOfInsemination: Date;
  public TimeOfInsemination: Date;
}
export class ReadyForEmbroTransferRequest extends BaseClass {

  public CycleCode: number;
  public TDay: number;
  public EnterUserEmpCode: number;
}
export class SingleWellCultureByCycleCodeController {
  public Treatmentcycle: number;
  public EmbSeq: number;
  public Morphology: string;
  public OoctyeQuality: string;
  public Technique: string;
  public isDisCarded: boolean;
  public IsFrozen: boolean;
  public IsTransFerred: boolean;
  public IsTransferrable: boolean;
  public status: string;
  public WellNo: number;
  public WellFollicle: number;
  public DOC1: number;
  public CellCount1: number;
  public Grade1: string;
  public Remarks1: string;
  public Image1: number;
  public DOC2: number;
  public CellCount2: number;
  public Grade2: string;
  public Remarks2: string;
  public Image2: number;
  public DOC3: number;
  public CellCount3: number;
  public Grade3: string;
  public Remarks3: string;
  public Image3: number;
  public DOC4: number;
  public CellCount4: number;
  public Grade4: string;
  public Remarks4: string;
  public Image4: number;
  public DOC5: number;
  public CellCount5: number;
  public Grade5: string;
  public Remarks5: string;
  public Image5: number;
  public DOC6: number;
  public CellCount6: number;
  public Grade6: string;
  public Remarks6: string;
  public Image6: number;
  public SingleWellCultureCode: number;
  public DiscardedComments: string;
  public Location: string;
  public StrawNo: string;
  public OocyteQualityPost: string;
  public OocyteQualityPre: string;
  public D1EmbryoGrade: number;
  public D2EmbryoGrade: number;
  public D3EmbryoGrade: number;
  public D4EmbryoGrade: number;
  public D5EmbryoGrade: number;
  public D6EmbryoGrade: number;
  public DocID6: number;
  public DocCaptureDate6: Date;
  public DocFileExtension6: string;
  public DocID1: number;
  public DocCaptureDate1: Date;
  public DocFileExtension1: string
  public DocFriendlyName1: string;
  public DocFriendlyName2: string;
  public DocFriendlyName3: string;
  public DocFriendlyName4: string;
  public DocFriendlyName5: string;
  public DocFriendlyName6: string;
  public DocID2: number;
  public DocCaptureDate2: Date;
  public DocFileExtension2: string;
  public DocID3: number;
  public DocCaptureDate3: Date;
  public DocFileExtension3: string;
  public DocID4: number;
  public DocCaptureDate4: number;
  public DocFileExtension4: string;
  public DocID5: number;
  public DocCaptureDate5: Date;
  public DocFileExtension5: string;
  public ActorCode: number;
  public D1Grade2: string;
  public CellStage1: string;
  public D2Grade2: string;
  public CellStage2: string;
  public D3Grade2: string;
  public CellStage3: string;
  public D4Grade2: string;
  public CellStage4: string;
  public D5Grade2: string;
  public CellStage5: string;
  public D6Grade2: string;
  public CellStage6: string;
}
export class SingleWellCultureByCycleCodeRequest extends BaseClass {

  public TreatmentCycle: number;

}
export class EmbryosFromStoreController {
  public FETDropletGradingCode: number;
  public ActorCode: number;
  public TreatmentCycle: number;
  public DOC: number;
  public Date: Date;
  public CellStage: string;
  public Grade: string;
  public Count: number;
  public Regrade: string;
  public Regrade2: string;
  public Remarks: string;
  public UserName: string;
  public CreatedTimeStamp: Date;
  public LastModifiedTime: Date;
  public StrawNo: string;
}
export class EmbryosFromStoreRequest extends BaseClass {

  //public string ConditionalOperator { get; set; }

  public ActorCode: number;
  public DOC: string;


}
export class SaveEmbryoStoreInfoRequest extends BaseClass {

  //public string ConditionalOperator { get; set; }

  public FetDropletGradingCode: number;
  public ActorCode: number;
  public CycleCode: number;
  public DOC: number;
  public Count: number;
  public Date: Date;
  public CellStage: string;
  public Grade: string;
  public ReGrade: string;
  public ReGrade2: string;
  public Remarks: string;
  public CreatedUser: number;
  public CreatedUserName: string;
  public RecordStatus: string;


}

export class SaveSingleEmbryoGradeInfoRequest extends BaseClass {

  public WellCulture: number;
  public DOC: number;
  public CellCount: number;
  public Grade: string;
  public Remarks: string;
  public Imagecode: number;
  public IsDiscarded: boolean;
  public IsFreeze: boolean;
  public IsTransfer: boolean;
  public DiscardedComments: string;
  public Location: string;
  public StrawNo: string;
  public IsTransFerred: boolean;
  public EmbryoGradeCode: number;

}

export class SaveNewsRequest extends BaseClass {

  public NewsCode: number;
  public Name: string;
  public CreatedAt: Date;
  public Category: string;
  public PostedBy: string;
  public PublishedIn: string;
  public PresentedIn: string;
  public URL: string;
  public CreatedBy: string;
  public CreatedUser: string;

}
export class NewsListController {
  public NewsCode: number;
  public Name: string;
  public Category: string;
  public PostedBy: string;
  public PublishedIn: string;
  public PresentedIn: string;
  public URL: string;
  public CreatedBy: string;
  public CreatedAt: string;
  public RecordStatus: string;
  public RowNo: number;
  public TotalRowCount: number;
  public StartIndex: number;
  public EndIndex: number;
  public NoofRows: number;
}
export class ReadyForTransferBetweenDateController {
  public TreatmentCycleCode: number;
  public EmbryoTransferCode: number;
  public ProtocolName: string;
  public ProtocolStartDate: Date;
  public ProtocolEndDate: Date;
  public LMP: Date;
  public CycleNo: number;
  public InfertilityType: string;
  public EggSourceType: string;
  public LMPCycle: string;
  public IsReadyForPickup: boolean;
  public IsPickedUp: boolean;
  public IsPickupApproved: boolean;
  public CycleType: string;
  public CycleCreateAt: Date;
  public CreatedUser: number;
  public CycleCreatedUser: string;
  public CycleCreatedBranch: number;
  public OwnerName: string;
  public OwnerGender: string;
  public OwnerFormattedCode: string;
  public OwnerTelephone1: string;
  public OwnerTelephone2: string;
  public OwnerAgeYears: number;
  public OwnerPatientImageFile: string;
  public OwnerFileExtension: string;
  public RecepientName: string;
  public RecepientGender: string;
  public RecepientFormattedCode: string;
  public RecepientTelephone1: string;
  public RecepientTelephone2: string;
  public RecepientAgeYears: number;
  public RecepientPatientImageFile: string;
  public RecepientFileExtension: string;
  public FrozenOocytes: number;
  public TotalOocytes: number;
  public GradingModel: string;
  public ActivityStatus: string;
  public LastUpdatedTime: Date;
}
export class ReadyForTransferBetweenDateRequest extends BaseClass {

  public FacilityCode: number;
  public FromDate: Date;
  public ToDate: Date;

}
export class IvfEmbryoTransferAttemptByCycleCodeController {
  public IvfEmbryoTransferAttemptCode: number;
  public AttemptNo: number;
  public Doc: number;
  public TransferDate: Date;
  public EndometriumThickness: number;
  public EndometriumThicknessUnit: string;
  public Ultrasound: boolean;
  public Catheter: string;
  public CatheterType: string;
  public TransferProcess: string;
  public ProcessComments: string;
  public Remarks: string;
  public RecordStatus: string;
  public TreatmentCycleCode: number;
  public TransferType: string;
  public TransferStage: string;
  public TransferEndDate: Date;
  public TransferEndTime: Date;
  public TransferStartTime: Date;
  public Surgeon: number;
  public SurgeonName: string;
  public AsstSurgeon: number;
  public AsstSurgeonName: string;
  public Anesthesiologist: number;
  public AnesthesiologistName: string;
  public AnaesthesiaType: string;
  public DayofCycle: number;
  public CultureMedia: string;
  public Speculum: string;
  public CervicalCleaning: string;
  public TransferMethod: string;
  public BloodOnCatheter: boolean;
  public CervicalMucus: boolean;
  public HasRetainedEmbryos: boolean;
  public HasRetransfer: boolean;
  public Technique: string;
  public Embryologist: number;
  public EmbryologistName: string;
  public HasFragmentation: boolean;
  public Fragmentation: number;
  public Ntc: number;
  public ThawingMedia: string;
  public TypeOfTransfer: string;
  public DayOfTransfer: string;
  public Notes: string;
  public HasStilette: boolean;
  public HasDilator: boolean;
}
export class IvfEmbryoTransferAttemptByCycleCodeRequest extends BaseClass {

  public TreatmentCycle: number;

}
export class IvfWorkbenchController {
  public Name: string;
  public NumberCount: number;
  public RouterLink: string;
  public color: string;
}
export class IvfWorkbenchRequest extends BaseClass {
  public FromDate: Date;
  public ToDate: Date;
  public SearchText: string;
  public Branch: string;
}
export class FollicularScansBetweenDateController {
  public CycleActivity: number;
  public DocDate: Date;
  public TreatmentCycle: number;
  public FollicularGrowthCode: number;
  public DOC: number;
  public ProtocolName: string;
  public ProtocolStartDate: Date;
  public ProtocolEndDate: Date;
  public LMP: Date;
  public CycleNo: number;
  public InfertilityType: string;
  public EggSourceType: string;
  public LMPCycle: string;
  public IsReadyForPickup: boolean;
  public CycleType: string;
  public FollicularGrowthOwnerName: string;
  public FollicularGrowthOwnerGender: string;
  public FollicularGrowthOwnerFormattedCode: string;
  public FollicularGrowthOwnerTelephone1: string;
  public FollicularGrowthOwnerTelephone2: string;
  public FollicularGrowthOwnerAgeYears: number;
  public FollicularGrowthOwnerPatientImageFile: string;
  public FollicularGrowthOwnerFileExtension: string;
  public OwnerName: string;
  public OwnerGender: string;
  public OwnerFormattedCode: string;
  public OwnerTelephone1: string;
  public OwnerTelephone2: string;
  public OwnerAgeYears: number;
  public OwnerPatientImageFile: string;
  public OwnerFileExtension: string;
  public PatientCode: number;
  public ActorID: number;
  public ActivityStatus: string;
  public LastUpdatedTime: Date;
  public GradingModel: string;
  public TCModelName: string;
}
export class FollicularScansBetweenDateRequest extends BaseClass {
  public FromDate: Date;
  public ToDate: Date;
  public Branch: number;
}
export class FollicularPickUpsBetweenDateController {
  public PickUpCode: number;
  public ActorCode: number;
  public PickUpTreatmentCycle: number;
  public PickUpDOC: number;
  public PickUpTotalOocytes: number;
  public ProtocolName: string;
  public ProtocolStartDate: Date;
  public ProtocolEndDate: Date;
  public LMP: Date;
  public CycleNo: number;
  public InfertilityType: string;
  public EggSourceType: string;
  public LMPCycle: string;
  public IsReadyForPickup: boolean;
  public IsPickedUp: boolean;
  public IsPickupApproved: boolean;
  public CycleType: string;
  public CycleCreateAt: Date;
  public CreatedUser: string;
  public CycleCreatedUser: string;
  public CycleCreatedBranch: number;
  public OwnerName: string;
  public OwnerGender: string;
  public OwnerFormattedCode: string;
  public OwnerTelephone1: string;
  public OwnerTelephone2: string;
  public OwnerAgeYears: number;
  public OwnerPatientImageFile: string;
  public OwnerFileExtension: string;
  public EggName: string;
  public EggGender: string;
  public EggFormattedCode: string;
  public EggTelephone1: string;
  public EggTelephone2: string;
  public EggAgeYears: number;
  public EggPatientImageFile: string;
  public EggFileExtension: string;
  //public ActorCode: number;
  public PickUpCycleActivity: number;
  public FollicularGrowth: number;
  public OvumPlannedPickupDate: Date;
  //public TriggerDate: Date; 
  //public TriggerTime: Date; 
  //public Medicine: string; 
  //public Dose: string; 
  //public OvumPlannedPickupDate: Date; 
  //public PickupTime: Date; 
  //public ActualPickupDate: Date; 
  //public ActualPickupTime: Date; 
  //public Surgeon: string; 
  //public AsstSurgeon: string; 
  //public Anesthesiologist: string; 
  //public NeedleUsed: string; 
  //public Route: string; 
  //public Complications: string; 
  //public LFollicleAspirated: number;
  //public RFollicleAspirated: number; 
  //public RFollicleCount: number; 
  //public LFollicleCount: number; 
  //public TotalRtOocytes: number; 
  //public TotalLtOocytes: number; 
  public ActivityStatus: string;
  public LastUpdatedTime: Date;
}
export class FollicularPickUpsBetweenDateRequest extends BaseClass {


  //public long ActorCode { get; set; }
  public FromDate: Date;
  public ToDate: Date;
  //public string Status { get; set; }
  //public long From { get; set; }
  //public long CycleCode { get; set; }
  public Facility: string;
  // public string ConditionalOperator { get; set; }

}
export class SaveSingleWellFollicleRequest extends BaseClass {

  public SingleWellFollicleCode: number;
  public TreatmentCycleCode: number;
  public WellNo: number;
  public OocyteQualityPre: string;
  public OocyteQualityPost: string;
  public Morphology: string;
  public IsFrozen: boolean;
  public IsDiscarded: boolean;
  public GroupId: string;
  public EmbryoId: string;
}
export class FollicularScanDetailController {
  public CycleActivity: number;
  public DOC: number;
  public ScanDate: Date;
  public EndometriumThickness: number;
  public EndometriumThicknessUnits: string;
  public Sign1: string;
  public Sign2: string;
  public Sign1Actor: number;
  public Sign2Actor: number;
  public RecordStatus: string;
  public Comments: string;
  public EndometriumDetails: string;
  public FollicularGrowth: number;
  public IvfCycleFollicularGrowthDetailCode: number;
  public NextDocDate: Date;
  public BloodFlowZone: string;
  public GCSF: string;
  public BAPC: string;
  public PILeft: string;
  public PIRight: string;
  public RILeft: string;
  public RIRight: string;
  public Evion: string;


}
export class FollicularScanDetailRequest extends BaseClass {
  public ScanCode: number;
  public CycleCode: number;
  public PatientCode: number;
}
export class FollicularScanOvaryDetailController {
  public RtOvComments: string;
  public LtOvComments: string;
  public OvarPos: string;
  public Count: number;
  public size: number;
  public CycleActorCode: number;
  public FollicularGrowth: number;
  public IvfCycleFollicularGrowthDetailCode: number;
  public CycleActivity: number;
  public DOC: number;
  public ScanDate: Date;
  public EndometriumThickness: number;
  public EndometriumThicknessUnits: string;
  public Sign1: string;
  public Sign2: string;
  public RecordStatus: string;
  public Comments: string;
  public EndometriumDetails: string;
  public Size: number;
  public TreatmentCycle: number;
  public ActorID: number;
  public PatientCode: number;
  public PatientName: string;
  public FollicularGrowthDetailCode: number;
  public AFCCount: string;
}
export class FollicularScanOvaryDetailRequest extends BaseClass {
  public ScanCode: number;
  public CycleCode: number;
  public PatientCode: number;
}
export class SaveTestCycleActivitiesRequest extends BaseClass {
  public ActivityDate: Date;
  public Doc: number;
  public TestName: string;
  public TestCode: number;
  public MedicineName: string;
  public MedicineCode: number;
  public Dose: string;
  public Form: string;
  public Instructions: string;
  public DurationType: string;
  public Comments: string;
  public ActivityType: string;
  public CounsellingActivityCode: number;
  public TreatmentCycleCode: number;
  public ActorCode: number;
  public ScheduleDate: Date;
  public ScheduleTime: string;
  public FollowupMode: string;
  public FollowupStatus: string;
  public AssignedToName: string;
  public Assignedto: number;
  public Remarks: string;
  public CreatedUser: string;
  public ActivityStatus: string;
  public LoginUserActorCode: number;
  public serviceCode: number;
  public FacilityCode: number;
  public SelectedActivity: string;

}
export class SaveIvfEmbryoTransferAttemptRequest extends BaseClass {

  public TreatmentCycleCode: number;
  public AttemptNo: number;
  public Doc: number;
  public TransferDate: Date;
  public EndometriumThickness: number;
  public EndometriumThicknessUnit: string;
  public Ultrasound: boolean;
  public Catheter: string;
  public CatheterType: string;
  public TransferProcess: string;
  public ProcessComments: string;
  public Remarks: string;
  public RecordStatus: string;
  public TransferType: string;
  public TransferStage: string;
  public TransferEndDate: Date;
  public TransferEndTime: Date;
  public TransferStartTime: Date;
  public Surgeon: number;
  public SurgeonName: string;
  public AsstSurgeon: number;
  public AsstSurgeonName: string;
  public Anesthesiologist: number;
  public AnesthesiologistName: string;
  public AnaesthesiaType: string;
  public DayofCycle: number;
  public CultureMedia: string;
  public Speculum: string;
  public CervicalCleaning: string;
  public TransferMethod: string;
  public BloodOnCatheter: boolean;
  public CervicalMucus: boolean;
  public HasRetainedEmbryos: boolean;
  public HasRetransfer: boolean;
  public Technique: string;
  public Embryologist: number;
  public EmbryologistName: string;
  public HasFragmentation: boolean;
  public Fragmentation: number;
  public SingleWellCultureCode: number;
  public IsTransferred: boolean;
  public ThawingMedia: string;
  public TypeOfTransfer: string;
  public DayOfTransfer: string;
  public Notes: string;
  public HasStilette: boolean;
  public HasDilator: boolean;
}
export class SaveTestMedCycleActivitiesRequest extends BaseClass {

  public CounsellingActivityCode: number;
  public TreatmentCycleCode: number;
  public PlanCode: number;
  public Remarks: string;
  public CycleActivityCode: number;
  public DOC: number;
  public ClinicalOrderEntryCode: number;
  public ServiceName: string;
  public BasePrice: number;
  public ActorCode: number;
  public FollowupPlanCode: number;
  public MedicineName: string;
  public MedicineTradeCode: number;
  public MedicineTradeName: string;
  public StartDate: Date;
  public EndDate: Date;
  public TradedDrugDetailCode: number;
  public ActivityDate: Date;
  public ActivityTime: string;
  public FollowupMode: string;
  public FollowupStatus: string;
  public AssignedToName: string;
  public Assignedto: number;
  public Comments: string;
  public CreatedUser: string;
  public ActivityStatus: string;
  public LoginUserActorCode: number;
  public TestCode: number;
  public FacilityCode: number;
  public Frequency: string;
  public DurationType: string;
  public Duration: number;
  public DoseNumeric: number;
  public Dose: string;
  public Instructions: string;
  public Form: string;
  public MedicineCode: number;
  public SelectActivity: string;
  public SelectActivityCode: number;
  public CycleTestCode: number;
  public ActivityType: string;
  public ScheduleTime: string;
  public Objective: string;
  public TestActivityData: TestData[];
}
export class TestData {
  public TestCode: number;
  public ServiceName: string;
}
export class CodeTypesController {
  public Name: string;
  public ShortName: string;
  public AllowHierarchy: number;
  public Code: number;
}
export class CodeTypeRequest2 extends BaseClass {
  public CodeTypeValueCode: number;
  public CodeType: string;
  public LongValue: string;
  public ShortValue: string;
  public ParentValue: string;
  public SeqNo: number;
}
export class CodeTypeRequest extends BaseClass {
  public CodeTypesCode: number;
  public Name: string;
  public ShortName: string;
  public AllowHierarchy: boolean;



}
export class LongCodeTypeValueController {
  public LongValue: string;
  public ShortValue: string;
  public CodeType: string;
  public Code: number;
  public SeqNo: number;
  public ParentValue: string;
}
export class LongCodeTypeValueRequest extends BaseClass {
  public CodeTypeValueCode: number;
  public CodeType: string;
  public LongValue: string;
  public ShortValue: string;
  public ParentValue: string;
  public SeqNo: number;

}
export class CycleOocyteQualityBetweenDateController {
  public TreatmentCycleCode: number;
  public OocyteQualityCode: number;
  public ProtocolName: string;
  public ProtocolStartDate: Date;
  public ProtocolEndDate: Date;
  public LMP: Date;
  public CycleNo: number;
  public InfertilityType: string;
  public EggSourceType: string;
  public LMPCycle: string;
  public IsReadyForPickup: boolean;
  public IsPickedUp: boolean;
  public IsPickupApproved: boolean;
  public RecepientType: string;
  public DateOfInsemination: Date;
  public CycleType: string;
  public CycleCreateAt: Date;
  public CreatedUser: number;
  public CycleCreatedUser: string;
  public CycleCreatedBranch: number;
  public OwnerName: string;
  public OwnerGender: string;
  public OwnerFormattedCode: string;
  public OwnerTelephone1: string;
  public OwnerTelephone2: string;
  public OwnerAgeYears: number;
  public OwnerPatientImageFile: string;
  public OwnerFileExtension: string;
  public RecepientName: string;
  public RecepientGender: string;
  public RecepientFormattedCode: string;
  public RecepientTelephone1: string;
  public RecepientTelephone2: string;
  public RecepientAgeYears: number;
  public RecepientPatientImageFile: string;
  public RecepientFileExtension: string;
  public TotalOocytes: number;
  public PatientCode: number;
  public EggSourceActorCode: number;
  public RecepientActorCode: number;
  public CycleActivity: number;
  public Sign1: number;
  public Sign1Name: string;
  public GradingModel: string;
  public ActivityStatus: string;
  public LastUpdatedTime: Date;
  public EggName: string;
  public EggGender: string;
  public EggFormattedCode: string;
  public EggTelephone1: string;
  public EggTelephone2: string;
  public EggAgeYears: number;
  public EggPatientImageFile: string;
  public EggFileExtension: string;
}
export class CycleOocyteQualityBetweenDateRequest extends BaseClass {
  public FacilityCode: number;
  public FromDate: Date;
  public ToDate: Date;
}
export class OocyteMaturityByCycleController {
  public TreatmentCycle: number;
  public MaturityLevel: string;
  public OccCount: number;
  public DenudedCount: number;
  public OocyteQualityCode: number;
  public DenudationBy: string;
  public DenudedByActor: number;
}
export class OocyteMaturityByCycleRequest extends BaseClass {

  //public string ConditionalOperator { get; set; }
  public CycleCode: number;
}
export class OocyteMorphologyByCycleController {
  public TreatmentCycle: number;
  public Morphology: string;
  public OocyteCount: number;
  public OocyteMorphologyCode: number;
}
export class OocyteMorphologyByCycleRequest extends BaseClass {

  //public string ConditionalOperator { get; set; }
  public CycleCode: number;
}
export class SaveOocyteMaturityInfoRequest extends BaseClass {

  //public string ConditionalOperator { get; set; }

  public CycleCode: number;
  public MaturityLevel: string;
  public OccCount: number;
  public DenudedCount: number;
  public RecordStatus: string;
  public CycleOocyteQualityCode: number;
  public DenudationBy: string;
  public DenudedByActor: number;
  public OqaData: OqaDetails[];
}
export class OqaDetails {
  public MaturityLevel: string;
  public OccCount: number;
  public DenudedCount: number;
  public CycleOocyteQualityCode: number;
}
export class SaveOocyteMorphologyInfoRequest extends BaseClass {

  //public string ConditionalOperator { get; set; }

  public CycleCode: number;
  public Morphology: string;
  public OocyteCount: number;
  public RecordStatus: string;
  public CycleOocyteMorphologyCode: number;
  public OocyteAbnormalitiesData: OocyteAbnormalitiesDetails[];

}
export class OocyteAbnormalitiesDetails {
  public Morphology: string;
  public OocyteCount: number;
  // public DenudedCount: number;
  public CycleOocyteMorphologyCode: number;
}

export class CycleSpermPreparationBetweenDateController {
  public TreatmentCycleCode: number;
  public OocyteQualityCode: number;
  public ProtocolName: string;
  public ProtocolStartDate: Date;
  public ProtocolEndDate: Date;
  public LMP: Date;
  public CycleNo: number;
  public InfertilityType: string;
  public EggSourceType: string;
  public LMPCycle: string;
  public IsReadyForPickup: boolean;
  public IsPickedUp: boolean;
  public IsPickupApproved: boolean;
  public RecepientType: string;
  public DateOfInsemination: Date;
  public CycleType: string;
  public CycleCreateAt: Date;
  public CreatedUser: number;
  public CycleCreatedUser: string;
  public CycleCreatedBranch: number;
  public OwnerName: string;
  public OwnerGender: string;
  public OwnerFormattedCode: string;
  public OwnerTelephone1: string;
  public OwnerTelephone2: string;
  public OwnerAgeYears: number;
  public OwnerPatientImageFile: string;
  public OwnerFileExtension: string;
  public RecepientName: string;
  public RecepientGender: string;
  public RecepientFormattedCode: string;
  public RecepientTelephone1: string;
  public RecepientTelephone2: string;
  public RecepientAgeYears: number;
  public RecepientPatientImageFile: string;
  public RecepientFileExtension: string;
  public TotalOocytes: number;
  public EggSourceActorCode: number;
  public GradingModel: string;
  public ActivityStatus: string;
  public LastUpdatedTime: Date;
  public EggName: string;
  public EggGender: string;
  public EggFormattedCode: string;
  public EggTelephone1: string;
  public EggTelephone2: string;
  public EggAgeYears: number;
  public EggPatientImageFile: string;
  public EggFileExtension: string;
}
export class CycleSpermPreparationBetweenDateRequest extends BaseClass {

  public FacilityCode: number
  public FromDate: Date;
  public ToDate: Date;

}
export class EmbryoGradesBetweenDateController {
  public TreatmentCycleCode: number;
  public EmbryoGradeCode: number;
  public ProtocolName: string;
  public ProtocolStartDate: Date;
  public ProtocolEndDate: Date;
  public LMP: Date;
  public CycleNo: number;
  public InfertilityType: string;
  public EggSourceType: string;
  public LMPCycle: string;
  public IsReadyForPickup: boolean;
  public IsPickedUp: boolean;
  public IsPickupApproved: boolean;
  public CycleType: string;
  public CycleCreateAt: Date;
  public CreatedUser: number;
  public CycleCreatedUser: string;
  public CycleCreatedBranch: number;
  public OwnerName: string;
  public OwnerGender: string;
  public OwnerFormattedCode: string;
  public OwnerTelephone1: string;
  public OwnerTelephone2: string;
  public OwnerAgeYears: number;
  public OwnerPatientImageFile: string;
  public OwnerFileExtension: string;
  public RecepientName: string;
  public RecepientGender: string;
  public RecepientFormattedCode: string;
  public RecepientTelephone1: string;
  public RecepientTelephone2: string;
  public RecepientAgeYears: number;
  public RecepientPatientImageFile: string;
  public RecepientFileExtension: string;
  public DateOfInsemination: Date;
  public TimeOfInsemination: Date;
  public SpermSource: string;
  public EggSourceActorCode: number;
  public GradingModel: string;
  public ActivityStatus: string;
  public LastUpdatedTime: Date;
  public EggName: string;
  public EggGender: string;
  public EggFormattedCode: string;
  public EggTelephone1: string;
  public EggTelephone2: string;
  public EggAgeYears: number;
  public EggPatientImageFile: string;
  public EggFileExtension: string;
  public TCModelID: number;
  public TCModelName: string;

}
export class EmbryoGradesBetweenDateRequest extends BaseClass {

  public FacilityCode: number;
  public FromDate: Date;
  public ToDate: Date;

}
//export class CodeTypeRequest extends BaseClass
//{
//  public  CodeTypeValueCode: number; 
//  public CodeType: string; 
//  public LongValue: string; 
//  public ShortValue: string; 
//  public ParentValue: string; 
//  public SeqNo: number; 

//}

export class IvfCycleTestByCodeController {
  public Date: Date;
  public PatientCode: number;
  public ItemCode: number;
  public ServicePoint: string;
  public PlannedServiceDate: Date;
  public ActualServiceDate: Date;
  public ServiceProvider: number;
  public ServiceProviderName: string;
  public ActualServiceTime: Date;
  public PatientPackage: number;
  public BasePrice: number;
  public IsLabOrderRequested: boolean;
  public GroupName: string;
  public Billable: boolean;
  public OrderringProvider: number;
  public OrderringProviderName: string;
  public ClinicalOrderItem: number;
  public ActorCode: number;
  public CycleActivity: number;
  public TreatmentCycle: number;
  public DOC: number;
  public DocDate: Date;
  public TestInfo: string;
  public TestName: string;
  public Comments: string;
  public TestCode: number;
  public TestDate: Date;
  public Result: string;
  public ResultUnits: string;

}
export class IvfCycleTestByCodeRequest extends BaseClass {
  public ActivityCode: number;
  public CycleCode: number;
  public ActorCode: number;

}
export class IvfCycleMembersListController {
  public TreatmentCycle: number;
  public OwnerName: string;
  public OwnerCode: number;
  public MemberType: string;
  public SourceType: string;
  public MemberActorCode: number;
  public MemberDisplayName: string;
  public MemberAge: number;
  public gender: string;
  public PatientImageFile: string;
  public FileExtension: string;
  public Telephone1: string;
  public Email: string;
  public FormattedCode: string;
}
export class IvfCycleMembersListRequest extends BaseClass {


  public TreatmentCycle: number;

}
export class FollicularPickUpsDetailController {
  public PickUpTreatmentCycle: number;
  public PickupCycleActivity: number;
  public FollicularPickup: number;
  public TriggerDate: Date;
  public TriggerTime: string;
  public Medicine: string;
  public Dose: string;
  public OvumPlannedPickupDate: Date;
  public PickupTime: Date;
  public ActualPickupDate: Date;
  public ActualPickupTime: string;
  public Surgeon: string;
  public AsstSurgeon: string;
  public Anesthesiologist: string;
  public NeedleUsed: string;
  public Route: string;
  public Complications: string;
  public LFollicleAspirated: number;
  public RFollicleAspirated: number;
  public RFollicleCount: number;
  public LFollicleCount: number;
  public TotalRtOocytes: number;
  public TotalLtOocytes: number;
  public PickUpCode: number;
  public PickUpDOC: number;
  public PickUpTotalOocytes: number;
  public FollicularGrowth: number;
  public ActorCode: number;
}
export class FollicularPickUpsDetailRequest extends BaseClass {


  public TreatmentCycle: number;
  public CycleActivity: number;
  public OvumPlannedPickupDate: Date;
  public FollicularPickup: number;
  public ActorCode: number;

}
export class FollicularPickUpsByCodeController {
  public IvfCycleFolliculePickupCode: number;
  public TreatmentCycle: number;
  public DOC: number;
  public DocDate: Date;
  public DocTime: Date;
  public MedicineCode: number;
  public MedicineName: string;
  public MinPickupSize: number;
  public PickupSizeUnits: string;
  public TotalOocytes: number;
  public RecordStatus: string;
  public RFollicleCount: number;
  public LFollicleCount: number;
  public RFollicleAspirated: number;
  public LFollicleAspirated: number;
  public Remarks: string;
  public IsReadyForPickup: string;
  public IsPickedUp: boolean;
  public IsReadyForTransfer: boolean;
  public IsTransferred: boolean;
  public OvumPickupdate: Date;
  public OvumPickupTime: Date;
  public OvumPickupEndTime: Date;
  public DrugUsed: string;
  public TotalRtOocytes: number;
  public TotalLtOocytes: number;
  public Sign1: number;
  public Sign1Name: string;
  public IsSigned: boolean;
  public OvumPlannedPickupTime: string;
  public OvumPlannedPickupDate: Date;
  public IsPickupApproved: boolean;
  public PickupApprovedBy: number;
  public PickupApprovedByName: string;
  public OvulationTriggerDate: Date;
  public OvulationTriggerTime: string;
  public FollicularGrowth: number;
  public Complications: string;
  public AnaesthesiaType: string
  public Anesthesiologist: number;
  public AnesthesiologistName: string;
  public Surgeon: number;
  public SurgeonName: string;
  public AsstSurgeon: number;
  public AsstSurgeonName: string;
  public NeedleUsed: string;
  public Route: string;
  public Dosage: string;
  public triggertype: string;
  public ExpiryDate: Date;
  public Embryologist: number;
  public EmbryologistName: string;
  public BatchNo: string;
  public PickupApprovedBy2: number;
  public PickupApprovedByName2: string;
  public MedicineCode2: number;
  public MedicineName2: string;
  public Dosage2: string;
  public OvulationTriggerDate2: string;
  public OvulationTriggerTime2: string;
  public OvumPlannedPickupDate2: Date;
  public OvumPlannedPickupTime2: string;
  public ExpiryDate2: string;
  public BatchNo2: string;
  public PlannedTime: string;
  public NeedleBatchName: string;
}
export class FollicularPickUpsByCodeRequest extends BaseClass {


  public IvfCycleFolliculePickupCode: number;
  public TreatmentCycle: number;

}
export class SaveFollicularPickupsDetailV2Request extends BaseClass {


  //public int ConditionalOperator { get; set; }
  public TreatmentCycleCode: number;
  public ActivityDate: Date;
  public FollicularGrowthCode: number;
  public ActivityTime: string;
  public ActivityApprovedEmpCode: number;
  public ActivityApprovedActorCode: number;
  public DOC: number;
  public MedicineName: string;
  public MedicineCode: number;
  public ActualDate: Date;
  public ActualTime: Date;
  public FollicularPickupCode: number;
  public Anesthesiologist: number;
  public AnesthesiologistName: string;
  public Surgeon: number;
  public AsstSurgeon: number;
  public SurgeonName: string;
  public AsstSurgeonName: string;
  public Complications: string;
  public AnaesthesiaType: string;
  public NeedleUsed: string;
  public Route: string;
  public MinPickupSize: number;
  public RFollicleCount: number;
  public LFollicleCount: number;
  public TotalRtOocytes: number;
  public TotalLtOocytes: number;
  public LFollicleAspirated: number;
  public RFollicleAspirated: number;
  public Dosage: string;
  public Batch: string;
  public BatchCode: number;
  public NeedleBatchName: string;
  public TotalOocytes: number;
  public ExpiryDate: Date;
  public TriggerType: string;
  public Embryologist: number;
  public EmbryologistName: string;
  public Batch2: string;
  public BatchCode2: number;
  public ActivityApprovedEmpCode2: number;
  public MedicineCode2: number;
  public MedicineName2: string;
  public Dosage2: string;
  public ActivityDate2: Date;
  public ActivityTime2: string;
  public ExpiryDate2: Date;
  public PlannedDate: Date;
  public PlannedTime: string;

}
export class IvfTreatmentPlanController {
  public FollowupPlanCode: number;
  public TreatmentCycleCode: number;
  public PatientActorCode: number;
  public TCModelID: number;
  public TCModelName: string;
}
export class IvfTreatmentPlanRequest extends BaseClass {

  public CycleCode: number;
  public ActorCode: number;
}
export class IvfCycleEmbryoTransferrablesController {
  public GradingCode: number;
  public TreatmentCycle: number;
  public DOC: number;
  public EmbryoCount: number;
  public CellCount: string;
  public Grade1: string;
  public Grade2: string;
  public Grade3: string;
  public RecordStatus: string;
  public FrozenCount: number;
  public DiscardedCount: number;
  public CreatedUser: number;
  public CreatedUserName: string;
  public CreatedTimeStamp: Date;
  public LastModifiedTime: Date;
  public TransferCount: string;
  public CellStage: string;
  public AvailableCount: number;
  public Remarks: string;
  public Fragmentation: number;
  public MultiNucleation: string;
  public actorcode: number;
  public CycleNumber: string;
  public StrawNumber: string;
  public CycleNo: number;
}
export class IvfCycleEmbryoTransferrablesRequest extends BaseClass {

  public CycleCode: number;
  public ActorCode: number;
  public StrawNumber: string;
}
export class IvfCycleEmbryoTransferStoreController {
  public IvfCycleEmbryoTransferCode: number;
  public CycleCode: number;
  public Day: number;
  public Grade1: string;
  public Grade2: string;
  public State: string;
  public CellCount: string;
  public EmbCount: number;
  public StorageAreaCode: number;
  public CreatedUser: number;
  public CreatedUserName: string;
  public CreatedTimeStamp: Date;
  public TransferStatus: string;
  public Remarks: string;
  public EmbryoGrading: number;
  public CycleNo: number;
}
export class IvfCycleEmbryoTransferStoreRequest extends BaseClass {

  public CycleCode: number;
}
export class SaveEmbryoTransferStoreRequest extends BaseClass {
  public CycleCode: number;
  public TransferStoreCode: number;
  public Day: number;
  public Grade1: string;
  public Grade2: string;
  public CellCount: number;
  public EmbCount: number;
  public StorageCode: string;
  public CreatedUser: number;
  public TransferStatus: string;
  public Remarks: string;
  public RecordStatus: string;
}



export class IvfPlanActivityTemplateController {
  public ActivityTemplateCode: number;
  public PlanTemplateCode: number;
  public ActivityType: string;
  public ActivityDescription: string;
  public SeqNo: number;
  public ServiceCode: number;
  public ServiceName: string;
  public DOC: number;
  public Remarks: string;
  public ApplicableTo: string;
}
export class IvfPlanActivityTemplateRequest extends BaseClass {

  public PlanTemplateCode: number;
  public CycleType: string;
  public Protocol: string;
}
export class IvfPlanTemplateController {
  public PlanTemplateCode: number;
  public Protocol: string;
  public CycleType: string;
}
export class IvfPlanTemplateRequest extends BaseClass {


}
export class SaveIvfPlanTemplateRequest extends BaseClass {
  //public string ConditionalOperator { get; set; }
  public TemplateCode: number;
  public CycleType: string;
  public Protocol: string
}
export class SaveIvfPlanActivityTemplateRequest extends BaseClass {

  //public string ConditionalOperator { get; set; }
  public TemplateCode: number;
  public ActivityType: string;
  public ActivityDescription: string;
  public SeqNo: number;
  public ServiceCode: number;
  public DOC: number;
  public Remarks: string;
  public ApplicableTo: string;
  public ServiceName: string;
  public CycleType: string;
  public Protocol: string;
  public ActivityTemplateCode: number;
}
export class BillDetailsController {
  public PatientName: string;
  public Gender: string;
  public FormattedCode: string;
  public RegistrationDate: Date;
  public OldRegistrationNumber: string;
  public Telephone1: string;
  public Telephone2: string;
  public Email: string;
  public AgeYears: number;
  public City: string;
  public ChargeDate: Date;
  public ChargeEntryType: string;
  public CreatedUser: string;
  public GeneratedBranchName: string;
  public AdditionalCharges: number;
  public Balance: number;
  public BillCreatedDate: Date;
  public BillDate: Date;
  public BillNo: string;
  public BillStatus: string;
  public BillType: string;
  public BranchName: string;
  public ChargeEntry: number;
  public Company: number;
  public CompanyName: string;
  public Discount: number;
  public CompanyBillFormattedCode: string;
  public ItemTotal: number;
  public Net: number;
  public OverAllDiscount: number;
  public PaidTotal: number;
  public Total: number;
  public PatientRegistrationNumber: number;
  public ActorCode: number;
  public PatientImageFile: string;
  public FileExtension: string;
}
export class BillDetailsRequest extends BaseClass {
  public BranchCode: number;
  public FromDate: Date;
  public ToDate: Date;
  public SearchText: string;
  // public string ConditionalOperator { get; set; }

}
export class BillsByFormattedCodeController {
  public PatientName: string;
  public Gender: string;
  public FormattedCode: string;
  public RegistrationDate: Date;
  public OldRegistrationNumber: string;
  public Telephone1: string;
  public Telephone2: string;
  public Email: string;
  public AgeYears: number;
  public City: string;
  public ChargeDate: Date;
  public ChargeEntryType: string;
  public CreatedUser: string;
  public GeneratedBranchName: string;
  public AdditionalCharges: number;
  public Balance: number;
  public BillCreatedDate: Date;
  public BillDate: Date;
  public BillNo: string;
  public BillStatus: string;
  public BillType: string;
  public BranchName: string;
  public ChargeEntry: number;
  public Company: number;
  public CompanyName: string;
  public Discount: number;
  public CompanyBillFormattedCode: string;
  public ItemTotal: number;
  public Net: number;
  public OverAllDiscount: number;
  public PaidTotal: number;
  public Total: number;
  public GrandTotal: number;
  public PatientRegistrationNumber: number;
  public ActorCode: number;
  public PatientImageFile: string;
  public FileExtension: string;
}
export class BillsByFormattedCodeRequest extends BaseClass {
  public FormattedCode: string;
  // public string ConditionalOperator { get; set; }
}
export class BillItemsByChargeEntryCodeController {
  public Code: number;
  public PaymentInstrument: string;
  public Amount: number;
  public HandlingCharges: number;
  public ReferenceNo: string;
  public Details: string;
  public CompanyReceiptCode: number;
  public BillNo: string;
  public ReceiptDate: Date;
  public ChargeEntry: number;
  public PatientCode: number;
  public PatientName: string;
  public Branch: string;
  public AmountPaid: number;
  public Payee: string;
  public Payeename: string;
  public AmountPayable: number;
  public BillFormattedCode: string;
  public ReceiptFormattedCode: string;
}
export class BillItemsByChargeEntryCodeRequest extends BaseClass {
  public ChargeEntryCode: number;
  // public string ConditionalOperator { get; set; }
}
export class UpdateIvfCycleByActivityRequest extends BaseClass {

  // public DateTime OvumPlannedPickupDate { get; set; }
  public ActivityName: string
  public TreatmentCycleCode: number;
  public ActivityApprovedEmpCode: number;
  public ActivityApprovedActorCode: number;
  public ActivityDate: Date;
  public ActivityTime: Date;
  public DOC: number;
  public MedicineName: string;
  public MedicineCode: number;
  public Dosage: string;
  public TotalFolicularCount: number;
  public ClosedByUserName: string;
  public ClosedByUser: number;
  public ClosingRemarks: string;
  //public IsCycleClosed: boolean;

  //public string LMPCycleRemarks { get; set; }
  //public DateTime ProtocolStartDate { get; set; }
  //public DateTime ProtocolEndDate { get; set; }

}
export class SaveClinicalFormRequest extends BaseClass {

  //public string ConditionalOperator { get; set; }
  public PatientCode: number;
  public FormattedCode: string;
  public FormName: string;
  public FormCode: number;
  public Date: Date;
  public Provider1Code: number;
  public Provider1Name: string;
  public Provider2Name: string;
  public Provider2Code: number;
  public UserName: string;
  public FacilityCode: number;
  public PatientReportCode: number;
}
export class SaveFollicularPickupsDetailRequest extends BaseClass {



  public TreatmentCycle: number;
  public CycleActivity: number;

  public DOC: number;
  public PickupCode: number;
  public FollicularGrowth: number;

  public OvulationTriggerDate: Date;
  public OvulationTriggerTime: string;
  public MedicineName: string;
  public MedicineCode: number;
  public Dosage: string;
  public PlannedDate: Date;
  public PlannedTime: string;
  public ActualDate: Date;
  public ActualTime: Date;
  public Surgeon: string;
  public AsstSurgeon: string;
  public Anesthesiologist: string;
  public NeedleUsed: string;
  public Route: string;
  public Complications: string;
  public RFollicleCount: number;
  public LFollicleCount: number;
  public TotalRtOocytes: number;
  public TotalLtOocytes: number;
  public LFollicleAspirated: number;
  public RFollicleAspirated: number;

}
export class SaveIvfTreatmentCyclesInfoRequest extends BaseClass {

  public PatientRegistrationCode: number;
  public ProtocolStartDate: Date;
  public ProtocolEndDate: Date;
  public EggLMPDate: Date;
  public CycleNo: number;
  public TreatmentProtocolName: string;
  public PatientName: string;
  public InfertilityType: string;
  public EggSourceType: string;
  public EggSourceActorCode: number;
  public EggSourceFormattedCode: string;
  public LMPCycleRemarks: string;
  public RecepientType: string;
  public RecepientActorCode: number;
  public RecepientFormattedCode: string;
  public RecepientLMP: Date;
  public CycleType: string;
  public CycleTypeChangeRemarks: string;
  public CreatedUserCode: string;
  public CreatedUserName: string;
  public CreatedFacilityCode: number;
  public Remarks: string;
  public IvfTreatmentCycleCode: number;
  public MenstrualCycle: string;
  public TCModelID: number;
  public TCModelName: string;
  public GradingModel: string;
  public EmbryoDonor: number;
  public EmbryoDonorName: string;
  //public EmbryoDonorName: string;
  //public EmbryoDonorActorCode: number;
}
export class OocyteQualityAssessmentByCodeController {
  public SingleWellFollicleCoder: number;
  public TreatmentCycle: number;
  public RecordStatus: string;
  public WellNo: number;
  public OocyteQualityPre: string;
  public OocyteQualityPost: string;
  public Morphology: string;
  public IsFrozen: boolean;
  public IsDiscarded: boolean;
  public IsContinue: boolean;
  public GroupId: string;
  public EmbryoId: string;
}
export class OocyteQualityAssessmentByCodeRequest extends BaseClass {


  public SingleWellFollicleCode: number;

}
export class SaveOocyteQualityAssessmentRequest extends BaseClass {

  public SingleWellFollicleCode: number;
  public TreatmentCycleCode: number;
  public WellNo: number;
  public OocyteQualityPre: string;
  public OocyteQualityPost: string;
  public Morphology: string;
  public IsFrozen: boolean;
  public IsDiscarded: boolean;
  public IsContinue: boolean;

}
export class FollicularScansByCycleController {
  public CycleActivity: number;
  public DocDate: Date;
  public TreatmentCycle: number;
  public FollicularGrowthCode: number;
  public DOC: number;
  public ProtocolName: string;
  public ProtocolStartDate: Date;
  public ProtocolEndDate: Date;
  public LMP: Date;
  public CycleNo: number;
  public InfertilityType: string;
  public EggSourceType: string;
  public LMPCycle: string;
  public IsReadyForPickup: boolean;
  public CycleType: string;
  public FollicularGrowthOwnerName: string;
  public FollicularGrowthOwnerGender: string;
  public FollicularGrowthOwnerFormattedCode: string;
  public FollicularGrowthOwnerTelephone1: string;
  public FollicularGrowthOwnerTelephone2: string;
  public FollicularGrowthOwnerAgeYears: number;
  public FollicularGrowthOwnerPatientImageFile: string;
  public FollicularGrowthOwnerFileExtension: string;
  public OwnerName: string;
  public OwnerGender: string;
  public OwnerFormattedCode: string;
  public OwnerTelephone1: string;
  public OwnerTelephone2: string;
  public OwnerAgeYears: number;
  public OwnerPatientImageFile: string;
  public OwnerFileExtension: string;
}
export class FollicularScansByCycleRequest extends BaseClass {


  public ActorCode: number;
  public FromDate: Date;
  public ToDate: Date;
  //public string Status { get; set; }
  //public long From { get; set; }
  public CycleCode: number;
  //public long Branch { get; set; }
  // public string ConditionalOperator { get; set; }

}
export class FollicularScanDetailsByCodeController {
  public CycleActivity: number;
  public DOC: number;
  public DocDate: Date;
  public EndometriumThickness: number;
  public EndometriumThicknessUnits: string;
  public Sign1: string;
  public Sign2: string;
  public RecordStatus: string;
  public Remarks: string;
  public EndometriumDetails: string;
  public RtOvComments: string;
  public LtOvComments: string;
  public OvarPos: string;
  public Count: number;
  public size: number;
  public FollicularGrowth: number;
  public IvfCycleFollicularGrowthDetailCode: number;
}
export class FollicularScanDetailsByCodeRequest extends BaseClass {


  public ActorCode: number;
  public ScanCode: number;
  public TreatmentCycle: number;
  public FromDate: Date;
  public ToDate: Date;
  //public string Status { get; set; }
  //public long From { get; set; }
  public CycleCode: number;
  //public long Branch { get; set; }
  // public string ConditionalOperator { get; set; }

}
export class IvfCycleMedicineByCodeController {
  public Date: Date;
  public PatientCode: number;
  public RecordStatus: string;
  public OrderType: string;
  public Admission: number;
  public Facility: number;
  public OrderEntryType: string;
  public ClinicalOrderEntry: number;
  public GenericMedicineName: string;
  public GenericMedicineCode: number;
  public MedicineTradeCode: number;
  public ItemCode: string;
  public Form: string;
  public Dose: string;
  public Periodicity: string;
  public Frequency: string;
  public Duration: number;
  public StartDate: Date;
  public EndDate: Date;
  public Instructions: string;
  public StopIf: string;
  public StopDate: Date;
  public IsStopped: boolean;
  public TradedDrugDetailCode: number;
  public DoseNumeric: number;
  public MedicineName: string;
  public DosageForm: string;
  public Remarks: string;
  public Dosage: string;
  public MedicineInstructions: string;
  public ClinicalOrderItem: number;
  public ActorCode: number;
  public CycleActivity: number;
  public TreatmentCycle: number;
  public DOC: number;
  public DocDate: Date;
  public MedicineCode: number;
  public CycleMedicineCode: number;
  public Objective: string;
  public DurationType: string;
}
export class IvfCycleMedicineByCodeRequest extends BaseClass {
  public ActivityCode: number;
  public CycleCode: number;
  public ActorCode: number;
}
export class SaveFollicularScanDetailRequest extends BaseClass {
  //public PatientCode: number;
  public NextScanDate: Date;
  public ScanCode: number;
  public CycleCode: number;
  public FollicularGrowthCode: number;
  public ScanDate: Date;
  public EndometriumThickness: number;
  public RtOvComments: string;
  public LtOvComments: string;
  public EndometriumThicknessUnits: string;
  public EndometriumDetails: string;
  public Remarks: string;
  public RecordStatus: string;
  //public long ScanCode { get; set; }
  public Doc: number;
  public ActorType: string;
  public ActorID: number;
  public CycleActivity: number;
  public Sign1: string;
  public Sign2: string;
  public Sign1Actor: number;
  public Sign2Actor: number;
  public BloodFlowZone: string;
  //public UALeft: string;
  //public UARight: string;
  public GCSF: string;
  public BAPC: string;
  public PILeft: string;
  public PIRight: string;
  public RILeft: string;
  public RIRight: string;
  public Evion: string;


}
export class SaveFollicularScanOvaryDetailRequest extends BaseClass {
  public PatientCode: number;
  public ScanCode: number;
  public CycleCode: number;
  public FollicularGrowthDetailCode: number;
  public FollicularGrowth: number;
  public OvarPos: string;
  public Count: number;
  public Size: number;
  public Remarks: string;
  public RecordStatus: string;
  public AFCCount: string;
}
export class SaveIvfCycleMedicineDataRequest extends BaseClass {
  //public PatientCode: number; 
  public CycleMedicineCode: number;
  public ActivityCode: number;
  public CycleCode: number;
  public MedicineName: string;
  public Form: string;
  public Dose: string;
  public Instructions: string;
  public StartDate: Date;
  public EndDate: Date;
  public DurationType: string;
  public Duration: number;
  public Remarks: string;
  public RecordStatus: string;
  public MedicineCode: number;
  public ActorCode: number;
  public ClinicalOrderItem: number;
  public Objective: string;

}
export class SaveIvfCycleTestDataRequest extends BaseClass {

  //public string ConditionalOperator { get; set; }
  public CycleTestCode: number;
  public ActivityCode: number;
  public CycleCode: number;
  public TestName: string;
  public TestCode: number;
  public TestObservation: number;
  public ActorCode: number;
  public Remarks: string;
  public RecordStatus: string;
  public ClinicalOrderItem: number;
  public TestDate: Date;
  public Result: string;
  public ResultUnits: string;
}
export class DoctorsListController {
  public FacilityCode: number;
  public FacilityName: string;
  public Prefix: string;
  public DisplayName: string;
  public ProviderType: string;
  public ProviderCode: number;
  public Specialty: string;
  public Telephone1: string;
}
export class ServiceProvidersController {
  //public FacilityCode: number;
  //public FacilityName: string;
  //public Prefix: string;
  //public DisplayName: string;
  public ProviderName: string;
  public ProviderCode: number;
  public ProviderCost: number;
  public BranchPrice: number;
  public PrCode: number;
  public CommissionAmount: number;
  //public Specialty: string;
  //public Telephone1: string;
}
export class MaterialHistoryController {
  public TaxPercent: number;
  public TaxTypeName: string;
  public Quantity: number;
  public BonusQuantity: number;
  public TotalOrderQuantity: number;
  public MRP: number;
  public Pack: number;
  public UnitPrice: number;
  public UOM: number;
  public UomName: string;
}
export class PurchaseReturnsController {
  public ReturnDate: Date;
  public Description: string;
  public VendorName: string;
  public BatchNo: string;
  public ExpDate: Date;
  public ReturnQuantity: number;
  public Reason: string;
  public Remarks: string;
  public UserName: string;
  public Supplier: number;
  public MaterialSpec: number;
  public MaterialBatchStorage: number;
  public SupplierMaterialBatch: number;
  public Facility: number;
  public Store: number;  
}
export class MaterialVerificationController {
  public VerifiedDate: Date;
  public Description: string;
  public VendorName: string;
  public BatchNo: string;
  public ExpDate: Date;
  public BookQuantity: number;
  public ActualQuantity: number;
  public Reason: string;
  public Remarks: string;
  public UserName: string;
  public Supplier: number;
  public MaterialSpec: number;
  public MaterialBatchStorage: number;
  public SupplierMaterialBatch: number;
  public Facility: number;
  public Store: number; 
}
export class IvfExtraDataController {
  public CycleCode: number;
  public DataContext: string;
  public DataType: string;
  public DataValue: string;
}
export class FeaturesController {
  public FeatureName: number;
  public ShortName: string;
  public FeatureDescription: string;
  public FeatureType: string;
  public FeatureStatus: string;
  public FeatureID: string;
}
export class StockTransfersController {
  public TransferDate: Date;
  public Description: string;
  public VendorName: string;
  public BatchNo: string;
  public ExpDate: Date;
  public TransferQuantity: number;
  public FromStore: string;
  public ToStore: string;
  public Remarks: string;
  public ReceivingUser: string;
  public Supplier: number;
  public MaterialSpec: number;
  public MaterialBatchStorage: number;
  public SupplierMaterialBatch: number;
  public Facility: number;
  public Store: number;
}

export class AppointmentCancelRequest extends BaseClass {
  public AppointmentCode: number;
  public BranchCode: number;
}
export class CancelBillRequest extends BaseClass {
  public ChargeEntry: number;
  public FacilityCode: number;
}
export class SaveAppointmentInformationRequest extends BaseClass {
  // public long CalendarCode { get; set; }
  public ActorCode: number;
  public SlotNumber: number;
  public Gender: string
  public AppointmentStatus: string
  public PatientName: string;
  public Telephone: string;
  public ConsultationType: string;
  public FormattedCode: string;
  public Email: string;
  public Age: number;
  public ActorGID: string;
  public ProviderCode: number;
  public SessionCode: number;
  public LocationCode: number;
  public wod: number;
  public ProviderName: string;
  public Date: Date;
  public StartTime: Date;
  public Specialty: String;


}
export class IvfEmbryoGradingByCycleController {
  public TreatmentCycle: number;
  public DOC: number;
  public EmbryoCount: number;
  public CellCount: string;
  public Grade1: string;
  public Grade2: string;
  public Grade3: string;
  public EmbryoGradingCode: number;
  public FrozenCount: number;
  public DiscardedCount: number;
  public CreatedUser: number;
  public CreatedUserName: string;
  public CreatedTimeStamp: Date;
  public LastModifiedTime: Date;
  public TransferCount: string;
  public CellStage: string;
  public Remarks: string;
  public Fragmentation: number;
  public MultiNucleation: string;
  public IsSelected: boolean;
  public SelectedFreezeCount: number;
  public AvailableCount: number;
  public NetFrozenCount: number;
  //public SelectedEmbryoCount: number;
}
export class IvfEmbryoGradingByCycleRequest extends BaseClass {

  //public string ConditionalOperator { get; set; }

  public CycleCode: number;
  public DOC: string;


}
export class SaveEmbryoGradingInfoRequest extends BaseClass {

  //public string ConditionalOperator { get; set; }

  public CycleCode: number;
  public DOC: number;
  public CellCount: string;
  public EmbryoCount: number;
  public Grade1: string;
  public Grade2: string;
  public Grade3: string;
  public RecordStatus: string;
  public EmbryoGradingCode: number;
  public FrozenCount: number;
  public DiscardedCount: number;
  public CreatedUser: number;
  public CreatedUserName: string;
  public TransferCount: string;
  public CellStage: string;
  public Remarks: string;
  public Fragmentation: number;
  public MultiNucleation: string;
}
export class EmbryoCount_GradeCode {
  public StoreEmbryoCount: number;
  public EmbryoGradingCode: number;
}
export class SaveEmbryoStorageAreaInfoRequest2 extends BaseClass {

  public CycleCode: number;
  public CryoTopColor: string;
  public CanisterNo: string;
  public Goblet: string;
  public Hexa: string;
  public Viso: string;
  public StorageAreaCode: number;
  public TotalCount: number;
  public StrawNumber: string;
  public EmbryosForStore: EmbryoCount_GradeCode[];
  // public ObservableCollection < EmbryoCount_GradeCode > EmbryosForStore { get; set; }
}

export class AppointmentDetailsByAppointmentCodeRequest extends BaseClass {

  public AppointmentCode: number;
}
export class AppointmentDetailsByAppointmentCodeController {
  public AppointmentCode: number;
  public AppointmentDate: Date;
  public PatientFormattedCode: string;
  public PatientName: string;
  public PatientCode: number;
  public ProviderCode: number;
  public Gender: string;
  public Email: string;
  public Telephone1: string;
  public Age: number;
  public PatientImageFile: string;
  public FileExtension: string;
  public FacilityCode: number;
  public AppointmentStatus: string;
  public FacilityName: string;
  public FacilityGlobalID: string;
  public VisitType: string;
  public BookingStatus: string;
  public ConsultationType: string;
  public ChekInTime: Date;
  public EncounterStartTime: Date;
  public EncounterEndTime: Date;
  public CheckOutTime: Date;
  public StartTime: Time;
  public AppointmentTime: string;
  public PatientVisit: number;
  public ProviderSwapped: number;
  public IsSelected1: boolean;
  public IsSelected2: boolean;
  public IsSelected3: boolean;
  public IsSelected4: boolean;
  public CheckInStatus: boolean;
  public CheckOutStatus: boolean;
  public EncounterStartStatus: boolean;
  public EncounterEndStatus: boolean;
  public NoShowStatus: boolean;
  public ActorCode: number;

}

export class DoctorsListRequest extends BaseClass {

  public FacilityCode: number;
  public ProvidersSpecality: string;
}
export class SavePatientVisitRequest extends BaseClass {
  public ActionItem: string;
  public ActionEvent: boolean;

  public ActorCode: number;
  public ChekInTime: Date;
  public AppointmentCode: number;
  public CheckOutTime: Date;
  public AppointmentTime: string;
  public AppointmentStatus: string;
  public EncounterStartTime: Date;
  public EncounterEndTime: Date;
  public VisitCode: number;
  public ProviderCode: number;
  public ProviderSwapped: number;
}
export class DoctorAppointmentsByDoctorcodeContoller {
  public AppointmentCode: number;
  public AppointmentDate: Date;
  public PatientFormattedCode: string;
  public PatientName: string;
  public PatientCode: number;
  public ProviderCode: number;
  public Gender: string;
  public Email: string;
  public Telephone1: string;
  public Age: number;
  public PatientImageFile: string;
  public FileExtension: string;
  public FacilityCode: number;
  public AppointmentStatus: string;
  public FacilityName: string;
  public FacilityGlobalID: string;
  public ChekInTime: Date;
  public EncounterStartTime: Date;
  public EncounterEndTime: Date;
  public CheckOutTime: Date;
  public BillFormattedCode: string;
  public ChargeEntry: number;
  public BillNo: string;
  public BillAmount: number;
  public BillStatus: string;
  public BillDate: Date;
}
export class DoctorAppointmentsByDoctorCodeRequest extends BaseClass {
  public ProviderCode: number;
  public FromDate: Date;
  public ToDate: Date;
}

export class DoctorAppointmentsByDoctorcode2Contoller {
  public AppointmentCode: number;
  public AppointmentDate: Date;
  public PatientFormattedCode: string;
  public PatientName: string;
  public PatientCode: number;
  public ProviderCode: number;
  public Gender: string;
  public Email: string;
  public Telephone1: string;
  public Age: number;
  public PatientImageFile: string;
  public FileExtension: string;
  public FacilityCode: number;
  public AppointmentStatus: string;
  public FacilityName: string;
  public FacilityGlobalID: string;
  public ChekInTime: Date;
  public EncounterStartTime: Date;
  public EncounterEndTime: Date;
  public CheckOutTime: Date;
  public BillFormattedCode: string;
  public ChargeEntry: number;
  public BillNo: string;
  public BillAmount: number;
  public BillStatus: string;
  public BillDate: Date;
  public VisitType: string;
  public BookingStatus: string;
  public ConsultationType: string;
  public ProviderSwapped: number;
  public PatientVisit: number;
  public CheckInStatus: boolean;
  public CheckOutStatus: boolean;
  public EncounterStartStatus: boolean;
  public EncounterEndStatus: boolean;
  public NoShowStatus: boolean;
  public ActorCode: number;
  public ProviderName: string;
}
export class DoctorAppointmentsByDoctorCode2Request extends BaseClass {
  //public PatientCode: number;
  public ProviderCode: number;
  public FromDate: Date;
  public ToDate: Date;

}
export class ProviderAvlSlotsController {
  public provider: number;
  public wod: number;
  public facility: number;
  public session: number;
  public StartDate: Date;
  public IsActive: number;
  public SessionName: String;
  public StartDateShort: Date;
  public AppointmentCode: number;
  public SlotNo: number;

}
export class ProviderAvlSlotsRequest extends BaseClass {
  public Duration: number;
  public FacilityCode: number;
  public Branch: number;
  public ProviderCode: number;
  public FromDate: Date;
  public ToDate: Date;
}

export class NewsListRequest extends BaseClass {
  public StartIndex: number;
  public NoofRows: number;
  public NewsCode: number;
  public CategoryName: string;

}
export class SaveGuardianInfoRequest extends BaseClass {
  public GuardianActorCode: number;
  public ActorCode: number;
  public RelationName: string;
  public RelationShip: string;
  public RelationType: string;


  public FirstName: string;
  public MiddleName: string;
  public LastName: string;


  public AddressLine1: string;
  public AddressLine2: string;
  public Telephone1: string;
  public Telephone2: string;
  public City: string;
  public State: string;
  public Country: string;
  public Email: string;

}
export class SaveCustomerMessageRequest extends BaseClass {
  public CustomerMessageCode: number;
  public ProviderActorCode: number;
  public CustomerActorCode: number;
  public MessageText: string;
  public Purpose: string;
  public CustomerMessageResponseCode: number;
  public MessageStatus: string;
  public ParentCode: number;
  public CreatedUser: string;
  public ThreadID: number;
  public CreatedTimeStamp: Date;
  public RecordStatus: string;
  public Who2Who: string;
}
export class MisReportXYController {
  public xName: string;
  public yValue: number;
  public Label: string;
}
export class MisReportRequest extends BaseClass {
  public ReportName: string;
  public FacilityCode: number;
  public FromDate: Date;
  public ToDate: Date;
}
export class ServiceCostByProviderController {
  public ServiceCode: number;
  public BranchCode: number;
  public CompanyServiceCode: number;
  public BranchBasePrice: number;
  public ChargeAmount: number;

}
export class ServiceCostByProviderRequest extends BaseClass {
  public ProviderCode: number;
  public ServiceCode: number;
  public FacilityCode: number;
  public PatientFormattedCode: string;
}

export class MisReportCategoriesController {

  public ReportCategory: string;

}
export class MisReportCategoriesRequest extends BaseClass {



}
export class MisReportDefByCategoryController {
  public ReportDefCode: number;
  public ReportName: string;
  public ProcedureDescription: string;
  public DisplayType: string;
  public FeatureID: string;
  public ReportCategory: string;
  public RecordStatus: string;
}
export class MisReportDefByCategoryRequest extends BaseClass {


  public ReportCategory: string;

}
export class ActorProfileRequest extends BaseClass {
  public ActorCode: number;
  // public SendApiRequestModel: ApiRequestModel;
}
export class ActorImageRequest extends BaseClass {
  public ActorCode: number;
  public ActorImageCode: number;
  public FileExtension: string;
  // public SendApiRequestModel: ApiRequestModel;
}

export class ActorImageController {
  public DisplayName: string;
  public ActorType: string;
  public ActorTypeCode: number;
  public ActorImageFile: string;
  public ActorImageFileExtension: string;
  public ActorImageFileUrl: string;
  public ActorImageCode: number;
  public ActorCode: number;
}
export class ActorDocRequest3 extends BaseClass {
  public ActorDocPageCode: number;
  public ActorCode: number;
  public DocType: string;
  public DocCaptureDate: Date;
}

export class ActorDocRequest extends BaseClass {

  //public ConditionalOperator: number;
  public ActorDocPageCode: number;
  public ActorCode: number;
  public ActorDocCode: number;
  public EntryActorCode: number;
  public DocFriendlyName: string;
  public DocID: string;
  public DocTitle: string;
  public DocFileExtension: string;
  public DocRemarks: string;
  public EntryUserName: string;
  public SeqNo: number;
  public RecordStatus: string;
  public DocumentType: string;
  public DocType: string;
  public DocDate: Date;
  //public SendApiRequestModel: ApiRequestModel;

}
export class SaveIvfOocyteEmbryoStorageRequest extends BaseClass {

  public TreatmentCycle: number;
  public ItemType: string;
  public ActorCode: number;
  public WellNo: number;
  public StorageUnitType: string;
  public StorageUnitDetails: string;
  public Status: string;
  public CreatedUser: string;
  public LastUpdateDate: Date;
  public LastUpdateTime: Date;
  public Morphology: string;
  public Grade: string;
  public OocyteEmbryoStorageCode: number;
}
export class IvfOocyteEmbryoStorageByCodeController {
  public OocyteEmbryoStorageCode: number;
  public ItemType: string;
  public TreatmentCycle: number;
  public ActorCode: number;
  public WellNo: number;
  public StorageUnitType: string;
  public StorageUnitDetails: string;
  public Status: string;
  public CreatedUser: string;
  public LastUpdateDate: Date;
  public LastUpdateTime: Date;
  public Morphology: string;
  public Grade: string;

  public CreatedTimeStamp: Date;
  public IsSelected: boolean;
}
export class IvfOocyteEmbryoStorageByCodeRequest extends BaseClass {

  public ActorCode: number;
  public TreatmentCycle: number;
}
export class IvfSpermStoreByCodeController {
  public SpermStoreCode: number;
  public TreatmentCycle: number;
  public ActorCode: number;
  public StorageUnitType: string;
  public StorageUnitDetails: string;
  public Status: string;
  public CreatedUser: string;
  public LastUpdateDate: Date;
  public LastUpdateTime: Date;
  public Volume: number;
  public VolumeUnits: string;
  public CreatedTimeStamp: Date;
}
export class IvfSpermStoreByCodeRequest extends BaseClass {

  public ActorCode: number;
  public TreatmentCycle: number;
}
export class SaveIvfSpermStoreRequest extends BaseClass {

  public TreatmentCycle: number;
  public ItemType: string;
  public ActorCode: number;
  public StorageUnitType: string;
  public StorageUnitDetails: string;
  public Status: string;
  public CreatedUser: string;
  public LastUpdateDate: Date;
  public LastUpdateTime: Date;
  public Volume: number;
  public VolumeUnits: string;
  public SpermStoreCode: number;


}
export class ActorDocRequestByType extends BaseClass {


  public ActorDocCode: number;
  public DocType: string;
  public ActorCode: number;
}
export class SaveArticleRequest extends BaseClass {

  //public ArticleCode: number;
  public Name: string;
  public CreatedAt: Date;
  public Category: string;
  public PostedBy: string;
  public PublishedIn: string;
  public PresentedIn: string;
  public URL: string;
  public CreatedBy: number;
  public Description: string;
}
export class ArticleListController {
  public ArticleCode: number;
  public Name: string;
  public DocumentCategory: string;
  public PostedBy: string;
  public PublishedIn: string;
  public PresentedIn: string;
  public URL: string;
  public CreatedBy: string;
  public CreatedAt: Date;
  public RecordStatus: string;
  public RowNo: number;
  public TotalRowCount: number;
  public StartIndex: number;
  public EndIndex: number;
  public NoofRows: number;
  public Description: string;
  public LikesCount: number;
}
export class ArticleListRequest extends BaseClass {
  public StartIndex: number;
  public NoofRows: number;
  public ArticleCode: number;
  public CategoryName: string;
}
export class ActorDocController {
  public ActorDocCode: number;
  public ActorDocPageCode: number;
  public DocType: string;
  public DocID: string;
  public DocTitle: string;
  public DocFileExtension: string;
  public DocCaptureDate: Date;
  public DocFriendlyName: string;
  public DocRemarks: string;
  public DocPageRemarks: string;
  public SeqNo: number;
  public ActorCode: number;
}
export class ActorDocControllerByType {
  public ActorDocCode: number;
  public ActorDocPageCode: number;
  public DocType: string;
  public DocID: string;
  public DocTitle: string;
  public DocFileExtension: string;
  public DocCaptureDate: Date;
  public DocFriendlyName: string;
  public DocRemarks: string;
  public DocPageRemarks: string;
  public SeqNo: number;
  public ActorCode: number;
}

export class SaveCounsellingPlanRequest extends BaseClass {
  public BranchCode: string;
  public CounsellingPlanCode: number;
  public ActorCode: string;
  //public FormattedCode: string;
  public TreatmentPlan: string;
  public StartDate: Date;
  public EndDate: Date;
  public CreatedUser: string;
  //public CreatedTimeStamp: Date;
  //public string ConditionalOperator { get; set; }
  public RecommendedPackage: string;
  public PackageCost: number;
  public SelectEmi: boolean;
  public FinancialStatus: string;
  public Remarks: string;
  public Concerns: string;
  public PlanStatus: string;
  public CounsellingDoctor: string;
  public Potential: string;
  public VisitCode: string;
  public RecordStatus: string;
  //public CounsellingPlanCode: number;
}
export class ActorIdentitiesRequest extends BaseClass {
  //public ConditionalOperator: number;
  public ActorCredentialCode: number;
  public ActorCode: number;
  public CredentialTypeCode: number;
  public CredentialType: string;
  public CredentialNumber: string;
  public ValidFrom: Date;
  public ValidTo: Date;
  public IssuingAuthority: string;
  public AdditionalDetails: string;
  public Remarks: string;
  // public SendApiRequestModel: ApiRequestModel;
}

export class ActorIdentitiesController {
  public ActorCredentialCode: number;
  public ActorCode: number;
  public CredentialTypeCode: number;
  public CredentialType: string;
  public CredentialTypeGroup: string;
  public GroupOrFolder: string;
  public CredentialNumber: string;
  public ValidFrom: Date;
  public ValidTo: Date;
  public IssuingAuthority: string;
  public AdditionalDetail: string;
  public Remarks: string;
  public ExtData: string;
  public IssuingAuthorityLongValue: string;
  public ActorDocCode: number;
}


export class ActorCertificationRequest extends BaseClass {
  //public ConditionalOperator: number;
  public ActorCredentialCode: number;
  public ActorCode: number;
  public CredentialTypeCode: number;
  public CredentialType: string;
  public CredentialNumber: string;
  public ValidFrom: Date;
  public ValidTo: Date;
  public IssuingAuthority: string;
  public AdditionalDetails: string;
  public Remarks: string;
  // public SendApiRequestModel: ApiRequestModel;
}

export class ActorCertificationsInfoController {
  public ActorCredentialCode: number;
  public ActorCode: number;
  public CredentialTypeCode: number;
  public CredentialType: string;
  public CredentialTypeGroup: string;
  public GroupOrFolder: string;
  public CredentialNumber: string;
  public ValidFrom: Date;
  public ValidTo: Date;
  public IssuingAuthority: string;
  public AdditionalDetail: string;
  public Remarks: string;
  public ExtData: string;
  public IssuingAuthorityLongValue: string;
  public ActorDocCode: number;
}


export class ActorMedicalFitnessRequest extends BaseClass {
  //public ConditionalOperator: number;
  public ActorCredentialCode: number;
  public ActorCode: number;
  public CredentialTypeCode: number;
  public CredentialType: string;
  public CredentialNumber: string;
  public ValidFrom: Date;
  public ValidTo: Date;
  public IssuingAuthority: string;
  public AdditionalDetails: string;
  public Remarks: string;
  // public SendApiRequestModel: ApiRequestModel;
}
export class ActorMedicalFitnessInfoController {
  public ActorCredentialCode: number;
  public ActorCode: number;
  public CredentialTypeCode: number;
  public CredentialType: string;
  public CredentialTypeGroup: string;
  public GroupOrFolder: string;
  public CredentialNumber: string;
  public ValidFrom: Date;
  public ValidTo: Date;
  public IssuingAuthority: string;
  public AdditionalDetail: string;
  public Remarks: string;
  public ExtData: string;
  public IssuingAuthorityLongValue: string;
  public ActorDocCode: number;
}
export class ActorLicenseRequest extends BaseClass {
  //public ConditionalOperator: number;
  public ActorCredentialCode: number;
  public ActorCode: number;
  public CredentialTypeCode: number;
  public CredentialType: string;
  public CredentialNumber: string;
  public ValidFrom: Date;
  public ValidTo: Date;
  public IssuingAuthority: string;
  public AdditionalDetails: string;
  public Remarks: string;
  public IssuingAuthorityLongValue: string;

  // public SendApiRequestModel: ApiRequestModel;
}
export class ActorLicensesInfoController {
  public ActorCredentialCode: number;
  public ActorCode: number;
  public CredentialTypeCode: number;
  public CredentialType: string;
  public CredentialTypeGroup: string;
  public GroupOrFolder: string;
  public CredentialNumber: string;
  public ValidFrom: Date;
  public ValidTo: Date;
  public IssuingAuthority: string;
  public AdditionalDetail: string;
  public Remarks: string;
  public ExtData: string;
  public IssuingAuthorityLongValue: string;
  public ActorDocCode: number;
}

export class EmployeeUserAccountRequest extends BaseClass {
  //public ConditionalOperator: number;
  public ActorType: number;
  public ActorName: string;
  public UserName: string;
  public Password: string;
  public MobileNo: string;
  public Email: string;
  public UserType: number;
  public Remarks: string;
  public FacilityCode: number;
  public EmployeeCode: number;
  public IsEncriptFromClient: boolean;
  // public SendApiRequestModel: ApiRequestModel;
}

export class EmployeesByFacilityCodeController {
  public EmployeeCode: number;
  public FirstName: string;
  public MiddleName: string;
  public LastName: string;
  public DisplayName: string;
  public UserName: string;
  public UserType: number;
  public ActorCode: number;
  public Email: string;
  public MobileNo: string;
  public ActorImageFile: string;
  public FileExtension: string;
  public ActorImageCode: number;
  public EmpFacilityCode: number;
  public EmpFormattedCode: string;
  public Designation: string;
  public DateOfBirth: Date;
  public MaritalStatus: string;
  public Gender: string;
  public Nationality: string;
  public AppointmentDate: Date;
  public JoiningDate: Date;
  public EmploymentType: string;
  public ReportingToActorCode: number;
  public ReportingToActor: string;
  public ReportingType: string;
  public BloodGroup: string;
  public PrimeRelation: string;
  public PrimeRelativeName: string;
  public EducationLevel: string;
  public EducationDetail: string;
  public Status: number;
  public EmployeeDepartment: string;
  public EmployeeSignatureCode: number;
  public EmployeeSignatureImageFile: string;
  public EmployeeSignatureFileExtension: string;
  public GenderLongValue: string;
  public BloodGroupLongValue: string;
  public NationalityLongValue: string;
  public MaritalStatusLongValue: string;
  public EmploymentTypeLongValue: string;
  public UserStatus: string;
  public UserActivationStatus: string;
}


export class EmployeeInfoRequest extends BaseClass {
  // public ConditionalOperator: number;
  public ActorCode: number;
  public EmployeeCode: number;
  public FirstName: string;
  public MiddleName: string;
  public LastName: string;
  public DisplayName: string;
  public Designation: string;
  public DateOfBirth: Date;
  public MaritalStatus: string;
  public Gender: string;
  public Nationality: string;
  public AppointmentDate: Date;
  public JoiningDate: Date;
  public EmploymentType: string;
  public ReportingActorCode: number;
  public ReportingToActor: string;
  public ReportingType: string;
  public BloodGroup: string;
  public PrimeRelation: string;
  public PrimeRelativeName: string;
  public EducationLevel: string;
  public EducationDetail: string;
  public Status: number;
  public FormattedCode: string;
  public EmployeeSignature: number;
  public EmployeeDepartment: string;
  public FacilityCode: number;
  //public SendApiRequestModel: ApiRequestModel;
}



export class FacilityInfoRequest extends BaseClass {
  //public ConditionalOperator: number;
  public ActorCode: number;
  public FacilityCode: number;
  public FacilityShortName: string;
  public ReportHeaderTitle: string;
  public ReportHeaderCaption: string;
  public ReportFooterLine1: string;
  public ReportFooterLine2: string;
  public FacilityIncharge: number;
  public FacilityInchargeName: string;
  public FacilityDisplayName: string;
  public FacilityStatus: string;
  // public SendApiRequestModel: ApiRequestModel;
}

export class FacilityInfoController {
  public FacilityCode: number;
  public ActorCode: number;
  public FacilityShortName: string;
  public ReportHeaderTitle: string;
  public ReportHeaderCaption: string;
  public ReportFooterLine1: string;
  public ReportFooterLine2: string;
  public FacilityIncharge: number;
  public FacilityInchargeName: string;
  public FacilityDisplayName: string;
  public FacilityType: number;
  public FacilityTypeName: string;
  public FacilityStatus: string;
}

//
export class xSearchActorProfileInfoController {
  public ActorCode: number;
  public ActorTypeCode: number;
  public ActorType: string;
  public Salutation: string;
  public FirstName: string;
  public MiddleName: string;
  public LastName: string;
  public DisplayName: string;
  public FormattedCode: string;
  public DateOfBirth: Date;
  public PlaceOfBirth: string;
  public Gender: string;
  public GenderLongValue: string;
  public BloodGroup: string;
  public BloodGroupLongValue: string;
  public Nationality: string;
  public NationalityLongValue: string;
  public Religion: string;
  public ReligionLongValue: string;
  public BirthIdentification1: string;
  public BirthIdentification2: string;
  public LiveIn: string;
  public Occupation: string;
  public MaritalStatus: string;
  public MaritalStatusLongValue: string;
  public SocialSecurityNumber: string;
  public HasWorkPermit: boolean;
  public IsConvicted: boolean;
  public LanguagesSpoken: string;
  public LanguagesRead: string;
  public AddressCode: number;
  public AddressType: number;
  public AddressLine1: string;
  public AddressLine2: string;
  public City: string;
  public State: string;
  public Country: string;
  public CountryLongValue: string;
  public Telephone1: string;
  public Telephone2: string;
  public Fax1: string;
  public Fax2: string;
  public Email: string;
  public Website: string;
  public EmergencyContactPersonName: string;
  public EmergencyContactNo1: string;
  public EmergencyContactNo2: string;
  public EmergencyAddress: string;
  public ActorImageFile: string;
  public ActorImageFileExtension: string;
  public ActorImageFileUrl: string;
  public ActorImageCode: number;
}

export class xSearchProfileInfoRequest extends BaseClass {
  public ActorType: number;
  public LastActorCode: number;
}

export class CompanyInfoRequest extends BaseClass {
  public ActorCode: number;
  public CompanyCode: number;
  public CompanyShortName: string;
  public ReportHeaderTitle: string;
  public ReportHeaderCaption: string;
  public ReportFooterLine1: string;
  public ReportFooterLine2: string;
  public CompanyDisplayName: string;
}

export class CompanyInfoController {
  public CompanyCode: number;
  public ActorCode: number;
  public CompanyShortName: string;
  public ReportHeaderTitle: string;
  public ReportHeaderCaption: string;
  public ReportFooterLine1: string;
  public ReportFooterLine2: string;
  public CompanyDisplayName: string;
  public ActorImageFile: string;
  public ActorImageFileExtension: string;
  public ActorImageFileUrl: string;
  public ActorImageCode: number;
}

export class FacilityUserAccountRequest extends BaseClass {
  public ActorType: number;
  public ActorName: string;
  public UserName: string;
  public Password: string;
  public MobileNo: string;
  public Email: string;
  public UserType: number;
  public Remarks: string;
  public FacilityCode: number;
  public EmployeeCode: number;
  public ActorCode: number;
  public IsEncriptFromClient: boolean;
}

export class NurseUserAccountRequest extends BaseClass {
  public ActorName: string;
  public UserName: string;
  public Password: string;
  public MobileNo: string;
  public Email: string;
  public UserType: number;
  public Remarks: string;
  public FacilityActorCode: number;
  public IsEncriptFromClient: boolean;
}



export class AllActorCertificatesRequest extends BaseClass {
  public ActorCode: number;
}
export class ActorCertificatesInfoByRegistryRequest extends BaseClass {
  public ActorCode: number;
  public FacilityActorCode: number;
}

export class AllActorCertificatesInfoController {
  public Code: number;
  public FromTable: string;
  public CertificateType: string;
  public ActorCode: number;
  public CredentialTypeCode: number;
  public CredentialType: string;
  public CredentialTypeGroup: string;
  public GroupOrFolder: string;
  public CredentialNumber: string;
  public ValidFrom: Date;
  public ValidTo: Date;
  public IssuingAuthority: string;
  public AdditionalDetail: string;
  public Remarks: string;
  public ExtData: string;
  public IssuingAuthorityLongValue: string;
  public ActorDocCode: number;
  public DocCount: number;
  public IsDocVerInciated: boolean;
  //
  public ActorDocVerCode: number;
  public DocVerStatus: string;
  public IsCloseDocVer: boolean;
  public AssignedTo: string;
  public TotalDocAcknowledged: number;
  public TotalDocCancelled: number;
  public TotalDocFailed: number;
  public TotalDocInProcess: number;
  public TotalDocSuccess: number;
  public TotalDocWaitingForResponse: number;
  public TotalDocClosed: number;
  public TotalDocInitiated: number;
  public SuperRegistryActorCode: number;
}


export class EmployeeDetailInfoRequest extends BaseClass {
  public ActorCode: number;
  public EmployeeCode: number;
  public FirstName: string;
  public MiddleName: string;
  public LastName: string;
  public DisplayName: string;
  public Designation: string;
  public DateOfBirth: Date;
  public MaritalStatus: string;
  public Gender: string;
  public Nationality: string;
  public AppointmentDate: Date;
  public JoiningDate: Date;
  public EmploymentType: string;
  public ReportingActorCode: number;
  public ReportingToActor: string;
  public ReportingType: string;
  public BloodGroup: string;
  public PrimeRelation: string;
  public PrimeRelativeName: string;
  public EducationLevel: string;
  public EducationDetail: string;
  public Status: number;
  public FormattedCode: string;
  public EmployeeSignature: number;
  public EmployeeDepartment: string;
  public FacilityCode: number;
  public AddressLine1: string;
  public AddressLine2: string;
  public City: string;
  public State: string;
  public Country: string;
  public Telephone1: string;
  public Telephone2: string;
  public Fax1: string;
  public Fax2: string;
  public Email: string;
  public Website: string;
  public EmergencyContactPersonName: string;
  public EmergencyContactNo1: string;
  public EmergencyContactNo2: string;
  public EmergencyAddress: string;
  public TimeZoneCode: number;
  public TimeZoneDisplayName: string;
  public UserName: string;
}
export class EmployeeDetailInfoController {
  public EmployeeCode: number;
  public FirstName: string;
  public MiddleName: string;
  public LastName: string;
  public DisplayName: string;
  public UserName: string;
  public UserType: number;
  public ActorType: number;
  public ActorCode: number;
  public Email: string;
  public MobileNo: string;
  public ActorImageFile: string;
  public FileExtension: string;
  public ActorImageCode: number;
  public EmpFacilityCode: number;
  public EmpFormattedCode: string;
  public Designation: string;
  public DateOfBirth: Date;
  public MaritalStatus: string;
  public Gender: string;
  public Nationality: string;
  public AppointmentDate: Date;
  public JoiningDate: Date;
  public EmploymentType: string;
  public ReportingToActorCode: number;
  public ReportingToActor: string;
  public ReportingType: string;
  public BloodGroup: string;
  public PrimeRelation: string;
  public PrimeRelativeName: string;
  public EducationLevel: string;
  public EducationDetail: string;
  public Status: number;
  public EmployeeDepartment: string;
  public EmployeeSignatureCode: number;
  public EmployeeSignatureImageFile: string;
  public EmployeeSignatureFileExtension: string;
  public GenderLongValue: string;
  public BloodGroupLongValue: string;
  public NationalityLongValue: string;
  public MaritalStatusLongValue: string;
  public EmploymentTypeLongValue: string;
  public UserStatus: string;
  public UserActivationStatus: string;
  public AddressCode: number;
  public AddressType: number;
  public AddressLine1: string;
  public AddressLine2: string;
  public City: string;
  public State: string;
  public Country: string;
  public CountryLongValue: string;
  public Telephone1: string;
  public Telephone2: string;
  public Fax1: string;
  public Fax2: string;
  public Website: string;
  public EmergencyContactPersonName: string;
  public EmergencyContactNo1: string;
  public EmergencyContactNo2: string;
  public EmergencyAddress: string;
  public UserRole: string;
  public TimeZoneCode: number;
  public TimeZoneDisplayName: string;
}


export class FacilityDetailInfoRequest extends BaseClass {
  public FacilityCode: number;

}


export class FacilityDetailInfoController {
  public FacilityCode: number;
  public FirstName: string;
  public MiddleName: string;
  public LastName: string;
  public DisplayName: string;
  public ActorCode: number;
  public ActorType: number;
  public ActorImageFile: string;
  public FileExtension: string;
  public ActorImageCode: number;
  public FacilityShortName: string;
  public ReportHeaderTitle: string;
  public ReportHeaderCaption: string;
  public ReportFooterLine1: string;
  public ReportFooterLine2: string;
  public FacilityIncharge: number;
  public FacilityInchargeName: string;
  public FacilityDisplayName: string;
  public FacilityType: number;
  public FacilityTypeName: string;
  public FacilityStatus: string;
  public HcpProfileCode: number;
  public ProfileSummary: string;
  public UpdatedDateTime: Date;
  public ProfileTitle: string;
  public HcpProfileFormattedCode: string;
  public AddressCode: number;
  public AddressType: number;
  public AddressLine1: string;
  public AddressLine2: string;
  public City: string;
  public State: string;
  public Country: string;
  public CountryLongValue: string;
  public Telephone1: string;
  public Telephone2: string;
  public Fax1: string;
  public Fax2: string;
  public Email: string;
  public Website: string;
  public Zip: string;
  public EmergencyContactPersonName: string;
  public EmergencyContactNo1: string;
  public EmergencyContactNo2: string;
  public EmergencyAddress: string;
  public ActorGID: string;
}



export class NurseProfilesInfoByRegistryRequest extends BaseClass {

  public RegistryActorCode: number;
  public FromDate: Date;
  public ToDate: Date;
}


export class NurseProfilesInfoByRegistryController {
  public NurseRegistryMapCode: number;
  public NurseActorCode: number;
  public RegistryActorCode: number;
  public RequestedOn: Date;
  public IsRequested: boolean;
  public RequestedRemarks: string;
  public AcceptedOn: Date;
  public IsAccepted: boolean;
  public AcceptedRemarks: string;
  public NurseDisplayName: string;
  public RegistryDisplayName: string;
  public ActorImageFile: string;
  public ActorImageFileExtension: string;
  public ActorImageFileUrl: string;
  public ActorImageCode: number;
  public ActivationDate: Date;
  public ProfileTitle: string;
  public ProfileSummary: string;
  public DocCount: number;
  public NurseUserName: string;
  public Acknowledged: number;
  public Cancelled: number;
  public Failed: number;
  public InProcess: number;
  public Success: number;
  public WaitingForResponse: number;
  public Closed: number;
  public Initiated: number;
}



export class ActorCertificatesInfoByRegistryController {
  public Code: number;
  public FromTable: string;
  public CertificateType: string;
  public ActorCode: number;
  public CredentialTypeCode: number;
  public CredentialType: string;
  public CredentialTypeGroup: string;
  public GroupOrFolder: string;
  public CredentialNumber: string;
  public ValidFrom: Date;
  public ValidTo: Date;
  public IssuingAuthority: string;
  public AdditionalDetail: string;
  public Remarks: string;
  public ExtData: string;
  public IssuingAuthorityLongValue: string;
  public ActorDocCode: number;
  public DocCount: number;
  public IsDocVerInciated: boolean;
  public ActorDocVerCode: number;

  public DocVerStatus: string;
  public IsCloseDocVer: boolean;
  public AssignedTo: string;






  public TotalDocAcknowledged: number;
  public TotalDocCancelled: number;
  public TotalDocFailed: number;
  public TotalDocInProcess: number;
  public TotalDocSuccess: number;
  public TotalDocWaitingForResponse: number;
  public TotalDocClosed: number;
  public TotalDocInitiated: number;
  public FacilityActorCode: number;
  public SuperRegistryActorCode: number;
}



export class FacilitiesInfoByTypeRequest extends BaseClass {
  public FacilityTypeCode: number;
}

export class FacilitiesInfoByJobRequest extends BaseClass {
  public FacilityTypeCode: number;
  public JobCode: number;
}
export class FaciliesInfoByTypeController {
  public FacilityCode: number;
  public FirstName: string;
  public MiddleName: string;
  public LastName: string;
  public DisplayName: string;
  public FacilityActorCode: number;
  public ActorType: number;
  public ActorImageFile: string;
  public FileExtension: string;
  public ActorImageCode: number;
  public FacilityShortName: string;
  public ReportHeaderTitle: string;
  public ReportHeaderCaption: string;
  public ReportFooterLine1: string;
  public ReportFooterLine2: string;
  public FacilityIncharge: number;
  public FacilityInchargeName: string;
  public FacilityDisplayName: string;
  public FacilityType: number;
  public FacilityTypeName: string;
  public FacilityStatus: string;
  public HcpProfileCode: number;
  public ProfileSummary: string;
  public UpdatedDateTime: Date;
  public ProfileTitle: string;
  public HcpProfileFormattedCode: string;
  public AddressCode: number;
  public AddressType: number;
  public AddressLine1: string;
  public AddressLine2: string;
  public City: string;
  public State: string;
  public Country: string;
  public CountryLongValue: string;
  public Telephone1: string;
  public Telephone2: string;
  public Fax1: string;
  public Fax2: string;
  public Email: string;
  public Website: string;
  public EmergencyContactPersonName: string;
  public EmergencyContactNo1: string;
  public EmergencyContactNo2: string;
  public EmergencyAddress: string;

  public IsSelected: boolean;
  public RequestedPositions: number;
}
export class SaveCounsellingActivityRequest extends BaseClass {

  public CounsellingActivityCode: number;
  public PlanCode: number;
  public ActivityDate: Date;
  public ActivityTime: string;
  //public string ConditionalOperator { get; set; }
  public FollowupMode: string;
  public AssignedToName: string;
  public Assignedto: string;
  public CreatedUser: string;
  public Remarks: string;
  public CreatedTimeStamp: string;
  public ActivityStatus: string;
  public RecordStatus: string;
  public ActorCode: number;
  public ActualActivityDate: Date;
  public ActualActivityTime: Time;
  public Followupstatus: string;

}
export class SaveExternalDoctorInfoRequest extends BaseClass {


  public DoctorName: string;

  public DoctorPhoneNo: string;
  public DoctorInstitute: string;
  public Location: string;
  public Salutation: string;
  public IsReferralDoctor: boolean;
  public AddressLine1: string;
  public AddressLine2: string;
  public City: string;
  public Country: string;
  public State: string;
  public ZipCode: string;
  public Email: string;
  public IsInchargeProvider: boolean;
  public IsPrimaryCareGiver: boolean;
  public ProviderCode: number;
}
export class CounsellingActivityController {
  public PlanCode: number;
  public ActivityDate: Date;
  public ActivityTime: Time;
  public FollowupMode: string;
  public Remarks: string;
  public Assignedto: string;
  public AssignedToName: string;
  public CreatedUser: string;
  public CreatedTimeStamp: number;
  public ActivityStatus: string;
  public RecordStatus: string;
  public DisplayName: string;
}
export class CounsellingActivityRequest extends BaseClass {

  public ActorCode: string;
  public PlanCode: number;
  // public string ConditionalOperator { get; set; }

}
export class CustomerMessageController {
  public Who2Who: string;
  public Code: number;
  public ActorCode: number;
  public MessageText: string;
  public Purpose: string;
  public ParentCode: number;
  public ThreadID: number;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
}
export class CustomerMessageRequest extends BaseClass {
  public ActorCode: number;
  public Who2Who: string;
  public MessageCode: number;
}
export class ServiceCategoriesController {
  public ShortName: string;
  public ParentName: string;
  public Code: number;
  public CategoryName: string;
  public ParentCode: number;
  public ItemType: string;

}
export class ServiceCategoriesRequest extends BaseClass {

  public ParentCode: number;

}
export class ServicesByCategoryCodeController {
  public ServiceName: string;
  public CommissionAllowed: boolean;
  public RefundAllowed: boolean;
  public BasePrice: number;
  public DiscountAllowed: boolean;
  public CategoryName: string;
  public Servicecategory: string;
  public EditApprovalREquired: boolean;
  public Code: number;
  public Quantity: number;
  public Discount: number;
  public EditableCharge: boolean;
}
export class ServicesByCategoryCodeController2 {
  public ServiceName: string;
  public CommissionAllowed: boolean;
  public RefundAllowed: boolean;
  public BasePrice: number;
  public DiscountAllowed: boolean;
  public CategoryName: string;
  public Servicecategory: number;
  public EditApprovalREquired: boolean;
  public Code: number;
  public Quantity: number;
  public Discount: number;
  public EditableCharge: boolean;

  public RevenueCategory: string;
  public ServiceType: string;
  public ServicePoint: string;
  public DepartmentCode: number;
  public DepartmentName: string;

  public BranchBasePrice: number;
}

export class ServicesByCategoryCodeRequest extends BaseClass {
  public ServiceCategory: string;
  public BranchCode: number;
  public ActorCode: number;
  public ChargeEntryCode: number;
  public PrescriberCode: number;

}
export class CounsellingPlanController {
  public FacilityShortName: string;
  public BranchCode: string;
  public CounsellingPlanCode: number
  public ActorCode: number;
  public TreatmentPlan: string;
  public StartDate: Date;
  public RecommendedPackage: string;
  public PackageCost: number;
  public SelectEmi: boolean;
  public FinancialStatus: string;
  public Remarks: string;
  public Concerns: string;
  public CreatedUser: string;
  public CreatedTimestamp: string;
  public PlanStatus: string;
  public LastModified: string;
  public EndDate: Date;
  public LastModifiedUser: string;
  public CounsellingDoctor: string;
  public Potential: string;
  public VisitCode: number;
  public RecordStatus: string;
  public PatientImageFile: string;
  public DisplayName: string;
  public Gender: string;
  public Age: string;
  public Telephone1: string;
  public Telephone2: string;
  public FormattedCode: string;
}
export class CounsellingPlanRequest extends BaseClass {
  public ActorCode: string;
  public SearchText: string;
  public FromDate: Date;
  public ToDate: Date;
  public PlanCode: number;
  public BranchCode: number;

}
export class GenericCounsellingPlanRequest extends GenericProcPostRequest {
  public NextCode: number;
  public BranchCode: number;
  public ActorCode: string;
  public SearchText: string;
  public FromDate: Date;
  public ToDate: Date;
  public PlanCode: number;
}
export class CounsellingActivitiesByTimeController {
  public Operation: number;
  public PlanCode: number;
  public ActivityDate: Date;
  public ActivityTime: string;
  public FollowupMode: string;
  public FormattedCode: string;
  public FacilityShortName: string;
  public ActorCode: number;
  public Remarks: string;
  public Assignedto: number;
  public AssignedToName: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Time;
  public ActivityStatus: string;
  public RecordStatus: string;
  public DisplayName: string;
  public ActualActivityDate: Date;
  public ActualActivityTime: Time;
  public FollowupStatus: string;
  public CounsellingActivityCode: number;
  public ActivityType: string;
  public ActivityTypeName: string;
  public ActivityName: string;
  public PlanName: string;
}

export class CounsellingActivitiesByTimeRequest extends BaseClass {
  public PlanCode: number;
  public SearchText: string;
  public FromDate: Date;
  public ToDate: Date;
  public ActorCode: number;
  public BranchCode: number;
}
export class SaveProviderServiceChargeRequest extends BaseClass {
  public ProviderServiceChargeCode: number;
  public ProviderCode: number;
  public ServiceCode: number;
  public BranchCode: number;
  public Price: number;
  public Commission: number;
  public CreatedBy: number;
}
export class ServiceDetailsByCodeController {
  public ServiceCode: number;
  public CategoryName: string;
  public Name: string;
  public Tax: number;
  public BasePrice: number;
  public IsTaxable: boolean
  public Tax1: number;
  public IsTaxIncluded: boolean;
  public CommissionAllowed: boolean;
  public ServiceCategory: string;
  public RefundApprovalRequired: boolean;
  public EditableCharge: boolean;
  public EditApprovalRequired: boolean;
  public ServiceType: string;
  public UOM: string;
  public Note: string;
  public RevenueCategory: string;
  public DefaultCommission: number;
  public MinimumCommission: number;
  public MaximumCommission: number;
  public MaxDiscountAllowed: number;
  public HasChildServices: boolean;
  public ServicePoint: string;
  public ServicePointReferenceNo: number;
  public ServiceType1: string;
  public DiscountType: string;
  public DiscountMax: number;
  public IsCategoryApplicable: boolean;
  public Profile: string;
  //public FormattedCode: number;
}


export class ServiceDetailsByCodeRequest extends BaseClass {

  public ServiceCode: number;
}
export class ServiceBranchMapByServiceCodeController {
  public ServiceCode: number;
  public Branch: string;
  public BranchName: string;
  public CompanyServiceCode: number;
  public IsFacilityMapped: string;
  public BranchBasePrice: number;
  public PriceFactor: string;
  public Percentage: number;
  public ServiceName: string;
  public IsSelected: boolean;
}
export class ServiceBranchMapByServiceCodeRequest extends BaseClass {
  public ServiceCode: number;
}

export class ServiceConsultantMapController {
  public BranchCode: number;
  public BranchShortName: string;
  public BranchBasePrice: number;
  public Consultant: string;
  public CommissionFactor: string;
  public CommissionPercentage: number;
  public CommissionAmount: number;
  public ConsultantServiceCode: number;
  public ChargeAmount: number;
  public Department: string;
  public DisplayName: string;
  public IsSelected: boolean;
}
export class ServiceConsultantMapRequest extends BaseClass {
  public ServiceCode: number;
  public ProviderCode: number;
}
export class PatientInfoByFormattedCodeController {
  public Prefix: string;
  public DisplayName: string;
  public Gender: string;
  public DateOfBirth: Date;
  public Age: string;
  public MaritalStatus: string;
  public Nationality: string;
  public Occupation: string;
  public Institution: string;
  public EducationalLevel: number;
  public EducationInDetail: string;
  public EducationTitle: string;
  public PrimeRelation: string;
  public PrimeRelativeName: string;
  public AddressLine1: string;
  public AddressLine2: string;
  public City: string;
  public State: string;
  public County: string;
  public ZipCode: string;
  public Telephone1: string;
  public Telephone2: string;
  public Email: string;
  public Website: string;
  public PatientRegistrationNumber: number;
  public RegistrationValidity: Date;
  public FormattedCode: string;
  public RegistrationDate: Date;
  public PrimaryDoctor: string;
  public PrimaryDiagnosis: string;
  public RefferingDoctor: string;
  public FirstVisitDate: Date;
  public LastVisitDate: Date;
  public RegistrationComment: string;
  public PatientCategory: string;
  public PatientCategory2: string;
  public FacilityName: string;
  public PatientImageFile: string;
  public FileExtension: string;
  public ActorCode: number;
  public AddressCode: number;
  public FacilityCode: number;
  public FacilityGID: string;
  public MotherTongue: string;
  public LanguagesKnown: string;
  public Contacts: string;
  public Address: string;
  public ReferalDetailCode: number;
  public RefType: string;
  public RefCode: number;
  public RefDetails: string;
  public Remarks: string;
  public RefInstitute: string;
  public RefContactNo2: string;
  public RecordStatus: string;
  public OwnerCode: number;
  public RefContactNo1: string;
  public Organisation: string;
  public BloodGroup: string;
  public Religion: string;
  public IsInsured: boolean;
  public InsuranceProvider: string;
  public BirthIdentification1: string;
  public BirthIdentification2: string;
  public Language: string;
  public RegistrationType: string;
  public RegistrationReason: string
  public BillingCategory: string;
  public IsOldRegistration: boolean;
  public OldRegistrationNumber: string;
  public CredentialType: string;
  public Validfrom: Date;
  public ValidTo: Date;
  public IssuingAuthority: string;
  public AdditionalDetail: string;
  public UserName: string;
  public CreatedUser: string;
  public CreatedUserName: string;
  public PartnerName: string;
  public Photo: number;
  public IdProof: string;
}
export class PatientInfoByFormattedCodeRequest extends BaseClass {
  public FormattedCode: string;
  public SearchText: string;
  public Branch: number;
  public FromDate: Date;
  public ToDate: Date;
  public IsToday: boolean;
  public IsDuration: boolean;
  public ActorCode: number;

}
export class TreatmentCyclesController {
  public Code: number;
  public PatientCode: number;
  public ProtocolStartDate: Date;
  public ProtocolEndDate: Date;
  public ProtocolDuration: number;
  public CycleResult: string;
  public RecordStatus: string;
  public LMP: string;
  public CycleNo: number;
  public Episode: number;
  public Protocol: string;
  public ProtocolName: string;
  public Remarks: string;
  public PatientName: string;
  public InfertilityType: string;
  public TreatmentProcedure: string;
  public EggSourceType: string;
  public EggSource: string;
  public SpermSourceType: string;
  public SpermSource: number;
  public EggSourceFormattedCode: string;
  public SpermSourceFormattedCode: string;
  public SpermRetrieval: string;
  public PregnancyType: string;
  public ClinicianSign: string;
  public EmbryologistSign: string;
  public LMPCycle: string;
  public DateOfInsemination: Date;
  public TimeOfInsemination: Time;
  public IsReadyForPickup: boolean;
  public IsPickedUp: boolean;
  public IsReadyForTransfer: boolean;
  public IsTransferred: boolean;
  public IsPickupApproved: boolean;
  public LMPCycleRemarks: string;
  public MemberRegistration: number;
  public RecepientType: string;
  public Recepient: number;
  public RecepientFormattedCode: string;
  public RecepientLMP: number;
  public BlockEggDonor: boolean;
  public BlockRecepient: boolean;
  public BlockSpermDonor: boolean;
  public IsCycleClosed: boolean;
  public ClosingRemarks: string;
  public ClosedByUser: number;
  public ClosedByUserName: string;
  public ETPending: boolean;
  public ETPendingDate: Date;
  public ETResume: boolean;
  public ETResumeDate: Date;
  public ETPendingRemarks: string;
  public CycleType: string;
  public CycleTypeChangeRemarks: string;
  public CreatedDate: Date;
  public CreatedUser: string;
  public CreatedUserName: string;
  public CreatedFacility: number;
  public FormattedCode: string;
  public ClosingDate: Date;
  public PatientRegNo: string;
  public Prefix: string;
  public DisplayName: string;
  public Gender: string;
  public ActorCode: number;
  public RegistrationDate: Date;
  public OldRegistrationNumber: string;
  public Age: number;
  public Telephone1: string;
  public Telephone2: string;
  public FacilityCode: number;
  public ShortName: string;
  public FacilityShortName: string;
  public Duration: number;
  public TCModelID: number;
  public TCModelName: string;
  public GradingModel: string;
  public EmbryoDonor: number;
  public EmbryoDonorName: string;
  //public SearchText: string;
  //public EmbryoDonorName: string;
  //public EmbryoDonorActorCode: number;
  public CompletedStatus: string;
}
export class TreatmentCyclesRequest extends BaseClass {
  public FromDate: Date;
  public ToDate: Date;
  //public Status: string; 
  //public From: number; 
  //public CycleCode: number; 
  public Branch: number;
  public SearchText: string;
  public ActorCode: number;
  // public string ConditionalOperator { get; set; }

}
export class TreatmentCycleActiityMasterController {
  public CycleActivityCode: number;
  public TreatmentCycleCode: number;
  public DOC: number;
  public DocDate: Date;
  public ActorID: number;
}
export class IvfCycleActivityMasterRequest extends BaseClass {
  public TreatmentCycle: number;
}
export class TreatmentCyclesByActorCodeController {
  public Code: number;
  public ProtocolName: string;
  public ProtocolStartDate: Date;
  public ProtocolEndDate: Date;
  public ProtocolDuration: number;
  public CycleResult: string;
  public LMP: Date;
  public CycleNo: number;
  public Episode: number;
  public Protocol: string;
  public CycleRemarks: string;
  public InfertilityType: string;
  public TreatmentProcedure: string;
  public EggSourceType: string;
  public EggSource: string;
  public SpermSourceType: string;
  public SpermSource: string;
  public SpermSourceFormattedCode: string;
  public SpermRetrieval: string;
  public PregnancyType: string;
  public ClinicianSign: string;
  public EmbryologistSign: string;
  public LMPCycle: string;
  public DateOfInsemination: Date;
  public TimeOfInsemination: Time;
  public IsReadyForPickup: boolean;
  public IsPickedUp: boolean;
  public IsReadyForTransfer: boolean;
  public IsTransferred: boolean;
  public IsPickupApproved: boolean;
  public LMPCycleRemarks: string;
  public MemberRegistration: number;
  public RecepientType: string;
  public Recepient: string;
  public RecepientLMP: Date;
  public BlockEggDonor: boolean;
  public BlockRecepient: boolean;
  public BlockSpermDonor: boolean;
  public IsCycleClosed: boolean;
  public ClosingRemarks: string;
  public ClosedByUser: number;
  public ClosedByUserName: string;
  public ETPending: boolean;
  public ETPendingDate: Date;
  public ETResume: boolean;
  public ETResumeDate: Date;
  public ETPendingRemarks: string;
  public CycleType: string;
  public CycleTypeChangeRemarks: string;
  public CreatedDate: Date;
  public CreatedUser: string;
  public CreatedUserName: string;
  public CreatedFacility: string;
  public ClosingDate: Date;
  public OwnerName: string;
  public OwnerGender: string;
  public OwnerFormattedCode: string;
  public OwnerRegistrationDate: Date;
  public OwnerOldRegistrationNo: string;
  public OwnerTelephone1: string;
  public OwnerTelephone2: string;
  public OwnerEmail: string;
  public OwnerAgeYears: number;
  public OwnerCity: string;
  public OwnerPatientRegistrationNo: number;
  public OwnerActorCode: number;
  public OwnerPatientImageFile: string;
  public OwnerFileExtension: string;
  public EggName: string;
  public EggGender: string;
  public EggFormattedCode: string;
  public EggRegistrationDate: Date;
  public EggOldRegistrationNo: string;
  public EggTelephone1: string;
  public EggTelephone2: string;
  public EggEmail: string;
  public EggAgeYears: number;
  public EggCity: string;
  public EggPatientRegistrationNo: number;
  public EggActorCode: number;
  public EggPatientImageFile: string;
  public EggFileExtension: string;
  public RecepientName: string;
  public RecepientGender: string;
  public RecepientFormattedCode: string;
  public RecepientRegistrationDate: Date;
  public RecepientOldRegistrationNo: string;
  public RecepientTelephone1: string;
  public RecepientTelephone2: string;
  public RecepientEmail: string;
  public RecepientAgeYears: number;
  public RecepientCity: string;
  public RecepientPatientRegistrationNo: number;
  public RecepientActorCode: number;
  public RecepientPatientImageFile: string;
  public RecepientFileExtension: string;
  public FacilityName: string;
  public TCModelID: number;
  public TCModelName: string;
}
export class TreatmentCyclesByActorCodeRequest extends BaseClass {


  public ActorCode: number;
  public FromDate: Date;
  public ToDate: Date;
  //public string Status { get; set; }
  //public long From { get; set; }
  //public long CycleCode { get; set; }
  public CycleCode: number;
  public Branch: number;
  public SearchText: string;

}
export class IvfCycleEmbryoStorageAreaController {
  public IvfCycleEmbryoTransferCode: number;
  public CycleCode: number;
  public EmbryoGrading: number;
  public IvfCycleEmbryoStorageAreaCode: number;
  public CanisterNo: string;
  public CryoTopColor: string;
  public Goblet: string;
  public Hexa: string;
  public Viso: string;
  public EmbryoCount: number;
  public UsedCount: number;
  public StrawNumber: string;
}
export class IvfCycleEmbryoStorageAreaRequest extends BaseClass {

  public CycleCode: number;
  public EmbryoGradingCode: number;
}
export class SaveEmbryoStorageAreaInfoRequest extends BaseClass {
  public EmbryoGradingCode: number;
  public CycleCode: number;
  public CryoTopColor: string;
  public Goblet: string;
  public Hexa: string;
  public Viso: string;
  public StoreEmbryoCount: number;
  public StorageAreaCode: number;
  public CanisterNo: string;

}
export class IvfCycleEmbryoTransferredController {
  public Code: number;
  public TransferAttempt: number;
  public EmbryoGrading: number;
  public FromTreatmentCycle: number;
  public CycleStore: number;
  public StorageArea: number;
  public UsedCount: number;
  public Regrade1: string;
  public Regrade2: string;
  public Regrade3: string;
  public Purpose: string;
  public CreatedUser: number;
  public CreatedUserName: string;
  public TimeStamp: Date;
  public ToTreatmentCycle: number;
  public DOC: number;
  public Cellstage: string;
  public StrawNumber: string;
}
export class IvfCycleEmbryoTransferredRequest extends BaseClass {

  public CycleCode: number;
}
export class SaveIvfCycleEmbryoTransferredInfoRequest extends BaseClass {
  public TransferAttempt: number;
  public EmbryoGrading: number;
  public FromTreatmentCycle: number;
  public CycleStore: number;
  public StorageArea: number;
  public UsedCount: number;
  public Regrade1: string;
  public Regrade2: string;
  public Regrade3: string;
  public Purpose: string;
  public CreatedUser: number;
  public TimeStamp: Date;
  public ToTreatmentCycle: number;
  public EmbryoTransferredCode: number;
}


export class GuardianInfoController {
  public GuardianActorCode: number;
  public ActorTypeCode: number;
  public AddressCode: number;
  public ParentActorCode: number;
  public FirstName: string;
  public MiddleName: string;
  public LastName: string;
  public DisplayName: string;
  public AddressType: number;
  public AddressLine1: string;
  public AddressLine2: string;
  public Telephone1: string;
  public Telephone2: string;
  public City: string;
  public State: string;
  public Country: string;
  public Email: string;
  public Relationname: string;
  public RelationShip: string;
}
export class GuardianInfoRequest extends BaseClass {
  public ActorCode: number;
}
export class OTFormsByFormattedCodeController {
  public PatientReportCode: number;
  public ReportType: string;
  public ReportDocTemplateCode: number;
  public TemplateName: string;
  public ShortName: string;
  public OTReportTemplateCode: number;
  public DiagnosisCode: string;
  public ChiefComplaint: string;
  public Speciality: string;
  public PatientReportDate: Date;
  public FromTime: Date;
  public ToTime: Date;
  public Anesthetist: string;
  public AnesthetistName: string;
  public Surgeon: string;
  public SurgeonName: string;
  public Sign1: string;
  public Sign1Name: string;
  public Sign2: string;
  public Sign2Name: string;
  public RecordStatus: string;
  public ReportStatus: string;
  public GeneratedLocation: string;
  public AssistantName: string;
  public Anesthesia: string;
  public Assistant: string;
  public PatientName: string;
  public Gender: string;
  public FormattedCode: string;
  public RegistrationDate: Date;
  public OldRegistrationNumber: string;
  public Telephone1: string;
  public Telephone2: string;
  public Email: string;
  public AgeYears: number;
  public City: string;
  public FacilityName: string;
  public PatientRegistrationNumber: number;
  public ActorCode: number;
  public PatientImageFile: string;
  public FileExtension: string;

}
export class OTFormsByFormattedCodeRequest extends BaseClass {
  public FormattedCode: string;
}
export class DSAActivityByCycleCodeController {
  public TreatmentCycle: number;
  public ActorCode: number;
  public ActivityDate: Date;
  public StimulationStart: Date;
  public AntagStart: Date;
  public DOC: string;
  public STIMULATION: string;
  public ANTAG: string;
  public DSA: string;
}
export class DSAActivityByCycleCodeRequest extends BaseClass {

  public ActorCode: number;
  public TreatmentCycle: number;

}
export class SaveIvfCycleInseminationLogRequest extends BaseClass {

  public TreatmentCycleCode: number;
  public IterationType: string;
  public DateofCollection: Date;
  public TimeofCollection: Date;
  public NtimesInformed: number;
  public InseminationDate: Date;
  public InseminationTime: Date;
  public ProcessedBy: number;
  public ProcessedByName: string;
  public SlideObserved: boolean;
  public Doctor: number;
  public DoctorName: string;
  public Nurse: number;
  public NurseName: string;
  public Patient: number;
  public Doc: string;
  public InseminationLogCode: number;
  public InseminationTimeText: string;
  public RecordStatus: string;
}
export class OTFormDetailByReportCodeController {
  public PatientCode: number;
  public SectionTitle: string;
  public SectionSequenceNO: number;
  public SectionTypeCode: number;
  public SectionCode: number;
  public AttributeName: string;
  public ValueData: string;
  public ValueType: string;
  public SequenceNo: number;
  public HasUnit: number;
  public Unit: string;
  public ValueSource: string;
  public HasChildAttributes: boolean;
  public RootCOde: number;
  public ParentCode: number;
  public UOM: string;
  public Unitsdata: string;
  public remarks: string;
  public fileid: string;
  public fileExtension: string;
  public type: number;
  public TemplateItemCode: number;
  public DataKey: number;
}
export class OTFormDetailByReportCodeRequest extends BaseClass {
  public PatientReportCode: string;
  public PatientFormattedCode: string;
}
export class SaveOTSectionDataRequest extends BaseClass {
  /// <summary>
  /// this will be tehre in section data also.. 
  /// lets send it again..
  /// 
  /// 
  /// </summary>
  public PatientReportCode: number;
  /// <summary>
  /// you are passing section data with all fields..  
  /// </summary>
  public SectionData: SectionData;

  /// <summary>
  /// Normall we send this also as part of request params.. lets send current date and time from here
  /// but dont use this field (pavan will send , but we wont use in our api)
  /// </summary>
  public LastUpdateTime: Date;

}
export class VitalItemHistoryByFormattedCodeController {
  public Code: number;
  public PatientReport: string;
  public SectionTemplate: string;
  public ValueData: string;
  public UnitsData: string;
  public RecordStatus: string;
  public IsSharedAttr: string;
  public SharedAttribute: string;
  public SummaryText: string;
  public Remarks: string;
  public FieldTemplateCode: number;
  public AttributeName: string;
  public ValueType: string;
  public SequenceNo: number;
  public Unit: string;
  public UOM: string;
  public MaxChars: number;
  public ValidationExpr: string;
  public Parent: string;
  public Section: string;
  public Body: string;
  public Template: string;
  public Report: number;
  public SectionTitle: string;
  public ParentName: string;
  public ReportType: string;
  public Date: Date;
  public FromTime: Date;
}
export class VitalItemHistoryByFormattedCodeRequest extends BaseClass {
  public FormattedCode: string;
  public VitalItemType: string;
}
export class VitalLatestFormByFormattedCodeController {
  public Code: number;
  public PatientReport: string;
  public SectionTemplate: string;
  public ValueData: string;
  public UnitsData: string;
  public RecordStatus: string;
  public IsSharedAttr: string;
  public SharedAttribute: string;
  public SummaryText: string;
  public Remarks: string;
  public FieldTemplateCode: number;
  public AttributeName: string;
  public ValueType: string;
  public SequenceNo: number;
  public Unit: string;
  public UOM: string;
  public MaxChars: number;
  public ValidationExpr: string;
  public Parent: string;
  public Section: string;
  public Body: string;
  public Template: string;
  public Report: number;
  public SectionTitle: string;
  public ParentName: string;
  public Date: Date;
  public FromTime: Date;
}
export class VitalLatestFormByFormattedCodeRequest extends BaseClass {
  public FormattedCode: string;
  public ReportType: string;
}
export class SaveVitalItemRequest extends BaseClass {
  public FormattedCode: string;
  public VitalItemType: string;
  public UpdateDate: Date;
  public ValueData: string;
  public Remarks: string;
  public SectionTemplate: string;
}

export class FaciliesInfoByJobController {
  public FacilityCode: number;
  public FirstName: string;
  public MiddleName: string;
  public LastName: string;
  public DisplayName: string;
  public FacilityActorCode: number;
  public ActorType: number;
  public ActorImageFile: string;
  public FileExtension: string;
  public ActorImageCode: number;
  public FacilityShortName: string;
  public ReportHeaderTitle: string;
  public ReportHeaderCaption: string;
  public ReportFooterLine1: string;
  public ReportFooterLine2: string;
  public FacilityIncharge: number;
  public FacilityInchargeName: string;
  public FacilityDisplayName: string;
  public FacilityType: number;
  public FacilityTypeName: string;
  public FacilityStatus: string;
  public HcpProfileCode: number;
  public ProfileSummary: string;
  public UpdatedDateTime: Date;
  public ProfileTitle: string;
  public HcpProfileFormattedCode: string;
  public AddressCode: number;
  public AddressType: number;
  public AddressLine1: string;
  public AddressLine2: string;
  public City: string;
  public State: string;
  public Country: string;
  public CountryLongValue: string;
  public Telephone1: string;
  public Telephone2: string;
  public Fax1: string;
  public Fax2: string;
  public Email: string;
  public Website: string;
  public EmergencyContactPersonName: string;
  public EmergencyContactNo1: string;
  public EmergencyContactNo2: string;
  public EmergencyAddress: string;

  public IsSelected: boolean;
  public RequestedPositions: number = 1;
  public Ordered: number;
  public Submissions: number;
  public Unavailable: number; /// by 

}

export class AutoGenSectionBase {
  public Data: SectionData;
  public SectionType: string = '';
  constructor(st: string = 'NONE') {
    this.SectionType = st;
  }
}
export class AutoGenTextSection extends AutoGenSectionBase {
  constructor() {
    super('Text');
  }
  public Fields: Array<AutoGenText>;
}

export class AutoGenImageSection extends AutoGenSectionBase {
  constructor() {
    super('Image');
  }
  public Fields: Array<AutoGenImage>;
}

export class AutoGenAttrValSection extends AutoGenSectionBase {
  constructor() {
    super('AttrVal');
  }
  public Fields: Array<AutoGenBase>;

}

export class FieldData {
  public FontStyle: string;
  public TitleFontStyle: string;
  public Title: string;
  public Value: string;
  public Units: string;
  public Remarks: string;
  public ImageFile: string;
  public HasImage: boolean;
  public ImageCode: number;

  public isHeader: boolean;
  public isSubHeader: boolean;
  public isSubChild: boolean;
  public isTextField: boolean;
  public HasSeparator: boolean;
  public ImageHeight: number;
  public Margin: string;
  public Foreground: string;
  public TitleForeground: string;
  public TemplateItemCode: number;
  public SectionTypeCode: number;
  public DataKey: number;

  public ValueType: string;
  public ValueSource: string;
  public UOM: string;
  public Unitsdata: string;
  public Unit: string;
  public SequenceNo: number;
  public RootCOde: number;
  public ParentCode: number;
  public HasUnit: boolean;
  public HasChildAttributes: boolean;
  public IsAdded: boolean = false;
  public RowIndex: number;


  constructor() {
    this.Foreground = "#FF0091EA";
    this.FontStyle = "Normal";
    this.TitleForeground = "#FF999999";
    this.TitleFontStyle = "Normal";
  }
}
export class AutoGenBase {
  public Data: FieldData;

}
export class AutoGenText extends AutoGenBase {

}
export class AutoGenTextUnits extends AutoGenText {

}
export class AutoGenImage extends AutoGenBase {

}
export class AutoGenLabel extends AutoGenBase {

}
export class AutoGenGrade extends AutoGenBase {


}


export class AutoGenBool extends AutoGenBase {
  public HasChildren: boolean;
  public Children: Array<AutoGenBase>

}

export class AutoGenDate extends AutoGenBase {

}

export class AutoGenCvs extends AutoGenBase {

}
export class AutoGenCsvList extends AutoGenBase {

  public ValueSourceName: string;

  public ValueSourceList: string[];
  public parse() {
    if (this.ValueSourceName != null)
      this.ValueSourceList = this.ValueSourceName.split(",");
  }
}

export class AutoGenList extends AutoGenBool {
  //public HasChildren: boolean;
  //public Children: Array<AutoGenBase>;
}
export class AutoGenListH extends AutoGenList {
  //public HasChildren: boolean;
  //public Children: Array<AutoGenBase>;
}
export class AutoGenGrid extends AutoGenBool {

  public HeaderNames: string[];
  public HasFixedHeaders: boolean;
  public KeepPrefix: boolean;
  public CurrentRow: number;

  public RowHeaders: GridRowHeader[];

  public Columns: FieldData[];
  public Rows: GridRow[];

  public AddCellsToRow(row: GridRow) {

    if (this.Rows == null)
      this.Rows = new Array<GridRow>();

    row.Cells = new Array<FieldData>();
    for (let r of this.Columns) {
      switch (r.ValueType) {

        case "Text": {
          // AutoGenText t
          //row.Cells.push(t);

        } break;

        default:
          break;
      };
    }


  }
}

export class AutoGenGridH extends AutoGenGrid {


}
export class GridRowHeader extends AutoGenBase {
  public HeaderName: string;
}

//export class GridRowData extends  FieldData{
//    Cells: AutoGenBase[];

//}

//export class GridCell extends FieldData {

//}
export class GridRow extends FieldData {//AutoGenBase {
  IsChoiceSelected: boolean;
  Header: GridRowHeader;
  Cells: FieldData[];

  public SetCellValue(TemplateNo: number, ColumnCode: number, Value: string, ValueUnits: string) {

    var d = this.Cells.filter(function (v: FieldData, ind: number, data: FieldData[]) {
      //TemplateNo
      return v.TemplateItemCode == ColumnCode;
    });
    d[0].Value = Value;
    if (ValueUnits != null) {
      d[0].Unitsdata = ValueUnits;
    }
    //(x => x.Data.TemplateNo == ColumnCode)
    //    .First() as FormFieldType4).ValueData = Value;

    //if (!string.IsNullOrEmpty(ValueUnits))
    //    (Cells.Where(x => x.TemplateNo == ColumnCode).First() as FormFieldType4).UnitsData = ValueUnits;
  }
}


export class AutoGenGridCvs extends AutoGenBase {
  public ValueSourceName: string;


}



export class AutoGenListItem extends AutoGenBase {
  public IsChoiceSelected: boolean;
}

export class GridData extends FieldData {
  public Columns: FieldData[];
  public Rows: GridRow[];

}
export class SectionData {
  public Title: string;
  public SectionSequenceNO: number;
  public SectionTypeCode: number;
  public Fields: FieldData[];
  public SectionType: string;
  public DataKey: number;
  public ImageCode: number;

}

export class FormOrganizer {

  Sections: SectionData[];
  TextSections: SectionData[];
  ImageSections: SectionData[];
  AttrValSections: SectionData[];
  AutoSections: Array<AutoGenSectionBase>;
  constructor() {
    this.AutoSections = new Array<AutoGenSectionBase>();
  }
  public Organize() {
    if (this.AutoSections.length == 0) {
      this.TextSections =
        this.Sections.filter
          (x => x.SectionType == 'Text');

      this.ImageSections =
        this.Sections.filter
          (x => x.SectionType == 'Image');

      this.AttrValSections =
        this.Sections.filter
          (x => x.SectionType == 'AttrVal');

      for (let l of this.Sections) {

        switch (l.SectionType) {
          case 'Text':
            this.AddTextSection(l);
            break;
          case 'Image':
            this.AddImageSection(l);
            break;
          case 'AttrVal':
            this.AddAttrValSection(l);
            break;
          default:
            break;

        }
      }
    }
  }
  public AddTextSection(data: SectionData) {
    data.Fields.forEach(
      function (v, i, fd) {
        v.IsAdded = false;
      });
    var s: AutoGenTextSection = new AutoGenTextSection();
    s.Data = data;
    this.AutoSections.push(s);
    s.Fields = new Array<AutoGenText>();
    for (let d of data.Fields) {
      var f: AutoGenText = new AutoGenText();
      f.Data = d;
      d.IsAdded = true;
      s.Fields.push(f);
    }

  }
  public AddImageSection(data: SectionData) {

    data.Fields.forEach(
      function (v, i, fd) {
        v.IsAdded = false;
      });
    var s: AutoGenImageSection = new AutoGenImageSection();
    s.Data = data;
    this.AutoSections.push(s);
    s.Fields = new Array<AutoGenImage>();
    for (let d of data.Fields) {
      var f: AutoGenImage = new AutoGenImage();
      f.Data = d;
      d.IsAdded = true;
      s.Fields.push(f);
    }
  }

  //AutoGenGrid
  public AddChildAttributes_Grid(f: AutoGenGrid, fields: FieldData[]) {
    // alert(f.Data.Title + ' Has Children ? ' + f.Data.HasChildAttributes)
    f.Columns = new Array<FieldData>();
    f.Rows = new Array<GridRow>();

    f.Children = new Array<AutoGenBool>();

    var gd = f.Data as GridData;
    if (gd && gd.Columns && Array.isArray(gd.Columns)) {
      for (let c of gd.Columns) {
        f.Columns.push(c);
        if (fields && Array.isArray(fields)) {
          fields.forEach(function (v, i, ary) {
            if (v.TemplateItemCode == c.TemplateItemCode)
              v.IsAdded = true;
          });
        }
      }
    }
    if (gd && gd.Rows && Array.isArray(gd.Rows)) {
      for (let r of gd.Rows) {
        f.Rows.push(r);
      }
    }
    //    //f.Data.
    //    var children = fields.filter(x => (x.ParentCode == f.Data.TemplateItemCode));//.First();

    //    for (let child of children) {

    //        if (child.IsAdded)
    //            continue;

    //        //      alert(child.Title + ' Has Children ? ' + child.HasChildAttributes);
    //        switch (child.ValueType) {
    //            case "Text":
    //                {
    //                    var textField: AutoGenText = new AutoGenText();
    //                    textField.Data = child;
    //                    child.IsAdded = true;
    //                    f.Children.push(textField);
    //                } break;
    //            case "Grade":
    //                {
    //                    var textField: AutoGenGrade = new AutoGenGrade();
    //                    textField.Data = child;
    //                    child.IsAdded = true;
    //                    f.Children.push(textField);
    //                } break;
    //            case "CVS":
    //                {
    //                    var textField: AutoGenCvs = new AutoGenCvs();
    //                    textField.Data = child;
    //                    child.IsAdded = true;
    //                    f.Children.push(textField);
    //                } break;
    //            case "CsvList":
    //                {
    //                    var csv: AutoGenCsvList = new AutoGenCsvList();
    //                    csv.Data = child;
    //                    csv.ValueSourceName = child.ValueSource;
    //                    child.IsAdded = true;
    //                    f.Children.push(csv);
    //                } break;
    //            case "Date":
    //                {
    //                    var textField: AutoGenDate = new AutoGenDate();
    //                    textField.Data = child;
    //                    child.IsAdded = true;
    //                    f.Children.push(textField);
    //                }

    //                break;
    //            case "Bool":
    //                {
    //                    var boolField: AutoGenBool = new AutoGenBool();
    //                    {
    //                        boolField.Data = child;
    //                        child.IsAdded = true;
    //                        f.Children.push(boolField);
    //                        if (child.HasChildAttributes) {
    //                            //  alert(boolField.Data.Title + ' Has Children ? ' + children.length)

    //                            boolField.HasChildren = true;
    //                            this.AddChildAttributes(boolField, fields);
    //                        }
    //                    }
    //                }
    //                break;
    //            case "List":
    //                {
    //                    var boolField: AutoGenList = new AutoGenList();

    //                    boolField.Data = child;
    //                    child.IsAdded = true;
    //                    f.Children.push(boolField);
    //                    if (child.HasChildAttributes) {
    //                        boolField.HasChildren = true;
    //                        //  alert(boolField.Data.Title + ' Has Children ? ' + children.length)
    //                        this.AddChildAttributes(boolField, fields);
    //                    }

    //                }
    //                break;
    //            case "ListH":
    //                {
    //                    var boolField: AutoGenListH = new AutoGenListH();

    //                    boolField.Data = child;
    //                    child.IsAdded = true;
    //                    f.Children.push(boolField);
    //                    if (child.HasChildAttributes) {
    //                        boolField.HasChildren = true;
    //                        //  alert(boolField.Data.Title + ' Has Children ? ' + children.length)
    //                        this.AddChildAttributes(boolField, fields);
    //                    }

    //                }
    //                break;
    //            case "Grid":
    //                {
    //                    //  alert("grid...")
    //                    // if (child.TemplateItemCode)
    //                    {
    //                        var gridField: AutoGenGrid = new AutoGenGrid();
    //                        gridField.Data = child;
    //                        child.IsAdded = true;
    //                        f.Children.push(gridField);
    //                        if (child.HasChildAttributes) {
    //                            gridField.HasChildren = true;
    //                            //  alert(boolField.Data.Title + ' Has Children ? ' + children.length)
    //                            this.AddChildAttributes(gridField, fields);
    //                        }
    //                    }
    //                }
    //                break;
    //            default:
    //                break;
    //        }

    //    }
    //}

  }
  public AddChildAttributes(f: any, fields: FieldData[]) {
    //alert(f.Data.Title + ' Has Children ? ' + f.Data.HasChildAttributes)
    f.Children = new Array<AutoGenBool>();

      var children = fields.filter(x => (
        x.ParentCode != null && f.Data != null &&
        (
          (f.Data.SectionTypeCode != null && f.Data.SectionTypeCode !== 0 && (x.ParentCode == f.Data.SectionTypeCode || x.ParentCode.toString() === f.Data.SectionTypeCode.toString()))
          ||
          (f.Data.TemplateItemCode != null && f.Data.TemplateItemCode !== 0 && (x.ParentCode == f.Data.TemplateItemCode || x.ParentCode.toString() === f.Data.TemplateItemCode.toString()))
        )
      ));

      for (let child of children) {

        if (child.IsAdded)
          continue;

        //      alert(child.Title + ' Has Children ? ' + child.HasChildAttributes);
        switch (child.ValueType) {
          case "Text":
            {
              var textField: AutoGenText = new AutoGenText();
              textField.Data = child;
              child.IsAdded = true;
              f.Children.push(textField);
            } break;
          case "Grade":
            {
              var textField: AutoGenGrade = new AutoGenGrade();
              textField.Data = child;
              child.IsAdded = true;
              f.Children.push(textField);
            } break;
          case "CVS":
            {
              var textField: AutoGenCvs = new AutoGenCvs();
              textField.Data = child;
              child.IsAdded = true;
              f.Children.push(textField);
            } break;
          case "CsvList":
            {
              var csv: AutoGenCsvList = new AutoGenCsvList();
              csv.Data = child;
              csv.ValueSourceName = child.ValueSource;
              csv.parse();
              child.IsAdded = true;
              f.Children.push(csv);
            } break;
          case "Date":
            {
              var textField: AutoGenDate = new AutoGenDate();
              textField.Data = child;
              child.IsAdded = true;
              f.Children.push(textField);
            }

            break;
          case "Bool":
            {
              var boolField: AutoGenBool = new AutoGenBool();
              {
                boolField.Data = child;
                child.IsAdded = true;
                f.Children.push(boolField);
                if (child.HasChildAttributes) {
                  //  alert(boolField.Data.Title + ' Has Children ? ' + children.length)

                  boolField.HasChildren = true;
                  this.AddChildAttributes(boolField, fields);
                }
              }
            }
            break;
          case "List":
            {
              var boolField: AutoGenList = new AutoGenList();

              boolField.Data = child;
              child.IsAdded = true;
              f.Children.push(boolField);
              if (child.HasChildAttributes) {
                boolField.HasChildren = true;
                //  alert(boolField.Data.Title + ' Has Children ? ' + children.length)
                this.AddChildAttributes(boolField, fields);
              }

            }
            break;
          case "ListH":
            {
              var boolField: AutoGenListH = new AutoGenListH();

              boolField.Data = child;
              child.IsAdded = true;
              f.Children.push(boolField);
              if (child.HasChildAttributes) {
                boolField.HasChildren = true;
                //  alert(boolField.Data.Title + ' Has Children ? ' + children.length)
                this.AddChildAttributes(boolField, fields);
              }

            }
            break;
          case "Grid":
            //{
            //  //  alert("grid...")
            //   // if (child.TemplateItemCode)
            //    {
            //        var gridField: AutoGenGrid = new AutoGenGrid();
            //        gridField.Data = child as GridData;
            //        child.IsAdded = true;
            //        f.Children.push(gridField);
            //       // alert("grid..." + gridField);
            //        //if (child.HasChildAttributes)
            //        {
            //            gridField.HasChildren = true;
            //            //  alert(boolField.Data.Title + ' Has Children ? ' + children.length)
            //            this.AddChildAttributes_Grid(gridField, fields);
            //        }
            //    }
            //}
            break;
          default:
            break;
        }

      }

  }
  public AddAttrValSection(data: SectionData) {
    if (!data || !data.Fields) return;
    data.Fields.forEach(function (v, i, fd) {
      v.IsAdded = false;
    });
    var s: AutoGenAttrValSection = new AutoGenAttrValSection();
    s.Data = data;
    this.AutoSections.push(s);
    s.Fields = new Array<AutoGenBase>();
    for (let d of data.Fields) {
      switch (d.ValueType) {
        case "Text":
          {
            if (!d.IsAdded) {
              let textField: AutoGenText = new AutoGenText();
              textField.Data = d;
              textField.Data.IsAdded = true;
              s.Fields.push(textField);
            }
          }
          break;
        case "Grade":
          {
            if (!d.IsAdded) {
              let textField: AutoGenGrade = new AutoGenGrade();
              textField.Data = d;
              textField.Data.IsAdded = true;
              s.Fields.push(textField);
            }
          }
          break;
        case "CVS":
          {
            if (!d.IsAdded) {
              let textField: AutoGenCvs = new AutoGenCvs();
              textField.Data = d;
              textField.Data.IsAdded = true;
              s.Fields.push(textField);
            }
          }
          break;
        case "CsvList":
          {
            if (!d.IsAdded) {
              let cvs: AutoGenCsvList = new AutoGenCsvList();
              cvs.Data = d;
              cvs.ValueSourceName = d.ValueSource;
              cvs.parse();
              cvs.Data.IsAdded = true;
              s.Fields.push(cvs);
            }
          }
          break;
        case "Date":
          {
            if (!d.IsAdded) {
              let textField: AutoGenDate = new AutoGenDate();
              textField.Data = d;
              textField.Data.IsAdded = true;
              s.Fields.push(textField);
            }
          }
          break;
        case "Bool":
          {
            if (!d.IsAdded) {
              let f: AutoGenBool = new AutoGenBool();
              f.Data = d;
              f.Data.IsAdded = true;
              s.Fields.push(f);
              if (f.Data.HasChildAttributes) {
                f.HasChildren = true;
                this.AddChildAttributes(f, data.Fields!);
              }
            }
          }
          break;
        case "List":
          {
            if (!d.IsAdded) {
              let f: AutoGenList = new AutoGenList();
              f.Data = d;
              f.Data.IsAdded = true;
              s.Fields.push(f);
              if (f.Data.HasChildAttributes) {
                f.HasChildren = true;
                this.AddChildAttributes(f, data.Fields!);
              }
            }
          }
          break;
        case "ListH":
          {
            if (!d.IsAdded) {
              let f: AutoGenListH = new AutoGenListH();
              f.Data = d;
              f.Data.IsAdded = true;
              s.Fields.push(f);
              if (f.Data.HasChildAttributes) {
                f.HasChildren = true;
                this.AddChildAttributes(f, data.Fields!);
              }
            }
          }
          break;
        case "List2":
          {
            let f: AutoGenBool = new AutoGenBool();
            f.Data = d;
            f.Data.IsAdded = true;
            s.Fields.push(f);
            if (f.Data.HasChildAttributes) {
              f.HasChildren = true;
              this.AddChildAttributes(f, data.Fields!);
            }
          }
          break;
        case "Grid":
          {
            if (!d.IsAdded) {
              let gridField: AutoGenGrid = new AutoGenGrid();
              gridField.Data = d as GridData;
              d.IsAdded = true;
              s.Fields.push(gridField);
              gridField.HasChildren = true;
              this.AddChildAttributes_Grid(gridField, data.Fields!);
            }
          }
          break;
        default:
          {
            if (!d.IsAdded) {
              if (d.ValueSource) {
                let cvsField: AutoGenCvs = new AutoGenCvs();
                cvsField.Data = d;
                d.IsAdded = true;
                s.Fields.push(cvsField);
              } else {
                let textField: AutoGenText = new AutoGenText();
                textField.Data = d;
                d.IsAdded = true;
                s.Fields.push(textField);
              }
            }
          }
          break;
      }
    }
  }

}
export class SaveiahOrderRequest extends BaseClass {
  public IahOrderCode: number;
  public ActorCode: number;
  public MobileNumber: string;
  public Mail: string;
  public OrderDate: Date;
  public OrderSource: string;
  public CustomerActorCode: number;
  public CustomerName: string;
  public CreatedUser: string;
  public Branch: number;
  public PrescriberDoctor: PrescribingDoctor[];
  public ReferringDoctor: ReferringDoctor[];
  public TotalBill: number;
  public DeliveryAddress: string;
  public NetPayable: number;
  public OrderType: string;
  public OrderItems: OrderData[];

}
export class SaveAdmissionDetailsRequest extends BaseClass {
  public AdmissionCode: number;
  public PatientCode: number;
  public FacilityCode: number;
  public AdmissionDate: Date;
  public AdmissionType: string;
  public CaseType: string;
  public TreatmentCategory: string;
  public ProviderCode: number;
  public ProviderName: string;
  public CareUnitCode: number;
  public CareUnit: string;
  public BedLocation: string;
  public PlannedDischargeDate: Date;
  public EstimatedStay: any;
  public ServiceCategoryCode: number;
  public AdmissionStatus: string;
  public RoomNo: string;
  public Ward: string;
  public TpiApprovalStatus: string;
  public CareUnitType: string;
  public AdmissionReason: string;
  public CareUnitLocation: string;
  public ReferralCode: number;
  public ReferralName: string;
  public ProposedTreatment: string;
  public ProposedTreatmentRemarks: string;
  public ConsentFormNo: string;
  public Instructions: string;
  public LastModifiedUser: number;
}

export class BillAdvancesListController {
  public BillDate: Date;
  public ReceiptDate: Date;
  public CompanyReceipt: number;
  public PaymentInstrument: string;
  public AdvanceAmount: number;
  public PatientName: string;
  public AdvanceType: number;
  public AdvanceName: string;
  public ReceiptFormattedCode: string;
}
export class BillAdvancesListRequest extends BaseClass {
  public FacilityCode: number;
  public PatientCode: number;
  public AdmissionCode: number;
}
export class ItemWiseSalesController {
  public GeneratedBranch: number;
  public PatientChargeEntryCode: number;
  public ChargeType: string;
  public BillNo: string;
  public BillDate: Date;
  public PatientName: string;
  public PatientFormattedCode: string;
  public ProposedTreatment: string;
  public ServiceCategoryName: string;
  public ItemDescription: string;
  public Quantity: number;
  public RefundQuantity: number;
  public UnitPrice: number;
  public BeforeDiscount: number;
  public Discount: number;
  public AfterDiscount: number;
  public TaxType: string;
  public TaxPercent: number;
  public TaxAmount: number;
  public Total: number;
  public RecordStatus: string;
  public BillStatus: string;
  public RefundNo: number;
  public PrescriberName: string;
  public ProviderName: string;
  public CommissionAmount: number;
  public BranchCode: number;
  public BranchName: string;
  public CompanyCode: number;
  public CompanyName: string;
  public HSNCODE: string;
}
export class ItemWiseSalesRequest extends BaseClass {
  public ItemCode: number;
  public FacilityCode: number;
  public StoreCode: number;
  public FromDate: Date;
  public ToDate: Date;

}
export class ModuleData {
  public ModuleName: string;
  public ModuleID: string;
  public Description: string;
}
export class RolesData {
  public RoleName: string;
  public RoleID: string;
  public Description: string;
}
export class AccessRightData {
  public ModuleID: string;
  public ROLEMAPPEDID: string;
  public FeatureID: string;
  public FeatureName: string;
  public FeatureDescription: string;
  public ModuleName: string;
  public HasAccess: boolean;

}
export class SaveJoinSpouse extends GenericProcPostRequest {
  public ActorCode: number;
  public UserName: string;
  public SelectedActorcode: number;
  public PartnerActorCode: number;
}
export class SaveActorRegistationType extends GenericProcPostRequest {
  public ActorCode: number;
  public DonorType: string;
  public UserName: string;
}
export class SaveActorReportSetting extends GenericProcPostRequest
{
  public ActorCode: number;
  public FeatureCode: number;
  public UserName: string;
  public AccessLevel: boolean;

}
export class SaveDoccumentStateRequest extends GenericProcPostRequest {
  public DocumentType: number;
  public DocCode: number;
  public DocID: string;
  public ActionTag: string;
  public ActorCode: number;
  public UserName: string;
}
export class SaveDeletedBillItemRequest extends GenericProcPostRequest {
  //public DoccumentType: number;
  public ChargeEntry: number;
  public ItemCode: number;
  public ActionTag: string;
  public ActorCode: number;
  public UserName: string;
}
export class SaveDeletedMaterialRequest extends GenericProcPostRequest {
  public HsnCode: number;
  public BatchNo: string;
  public MaterialBatchStorage: number;
  public SupplierMaterialBatchCode: number;
  public MaterialSpecCode: number;
  public ActionTag: string;
  public ActorCode: number;
  public UserName: string;
}
export class DeletedAdmissionServiceRequest extends GenericProcPostRequest {
  public BranchCode: number;
  public TreatmentCategory: string;
  public ServiceCode: number;
  public AdmissionNo: number;
  public AdmissionServiceItemID: string;
  public AdmissionServiceItemCode: number;
  public ActionTag: string;
  public ActorCode: number;
  public UserName: string;
}
export class GetServicesRequest extends GenericProcPostRequest {
  public SearchText: string;
  public FacilityCode: number;
}
export class GetServiceProvidersRequest extends GenericProcPostRequest {
  public ServiceCode: number;
  public Branch: number;
}
export class GetMaterialHistoryRequest extends GenericProcPostRequest {
  public FacilityCode: number;
  public MaterialCode: number;
  public VendorCode: number;
}
export class GetPurchaseReturnsRequest extends GenericProcPostRequest {
  public Store: number;
  public ItemCode: number;
  public FromDate: Date;
  public ToDate: Date;
  public FacilityCode: number;
}
export class GetLabOrderTestResultsRequest extends GenericProcPostRequest {
  public OrderCode: number;
  public UserCode: number;
  public OrderTestCode: number;
}
export class GetMaterialVerificationRequest extends GenericProcPostRequest {
  public Store: number;
  public ItemCode: number;
  public FromDate: Date;
  public ToDate: Date;
  public FacilityCode: number;
}
export class GetSpermSourceDetailsRequest extends GenericProcPostRequest {
  public FromDate: Date;
  public ToDate: Date;
  public Status: string;
  public CycleCode: number;
  public Branch: number;
  public SemanDataCode: number;
}
export class GetFeatureDetailsRequest extends GenericProcPostRequest {
  public ModuleID: string;
  public Branch: number;
}
export class GetTreamtmentCyclesListRequest extends BaseClass {
  public FromDate: Date;
  public ToDate: Date;
  public Branch: number;
  public SearchText: string;
  public ActorCode: number;
}
export class GetStockTransfersRequest extends GenericProcPostRequest {
  public Store: number;
  public ItemCode: number;
  public FromDate: Date;
  public ToDate: Date;
  public FacilityCode: number;
}
export class GetAdmissionServices extends GenericProcPostRequest {
  public AdmissionNo: number;
  public FacilityCode: number;
}
export class GetOPOrdersByPatient extends GenericProcPostRequest {
  public FormattedCode: string;
  public FacilityCode: number;
  public FromDate: Date;
  public ToDate: Date;
}
export class SaveMaterialBatchRequest extends GenericProcPostRequest {
  public HsnCode: number;
  public BatchNo: string;
  public MaterialBatchStorage: number;
  public SupplierMaterialBatchCode: number;
  public MaterialSpecCode: number;
  public EntryDate: Date;
  public ExpiryDate: Date;
  public AvailableQuantity: number;
  public BatchQuantity: number;
  public TaxPercent: number;
  public SupplierShortName: string;
  public ActionTag: string;
  public ActorCode: number;
  public UserName: string;
  public PurchaseUnitPrice: number;
  public SellingPrice: number;

}
export class SaveIvfAdditionalDataRequest extends GenericProcPostRequest {
  public FacilityCode: number;
  public TreatmentCycle: number;
  public ActionTag: string;
  public ActorCode: number;
  public UserName: string;

}

export class SaveSemanAnalysisRequest extends GenericProcPostRequest {
  public FacilityCode: number;
  public TreatmentCycle: number;
  public ActionTag: string;
  public ActorCode: number;
  public UserName: string;

}
export class SaveFeatureDetailsRequest extends GenericProcPostRequest {
  public ModuleID: string;
  public Name: string;
  public ShortName: string;
  public Description: string;
  public FeatureType: string;
  public Status: string;
  public UserName: string;
  public FacilityCode: number;
}
export class SaveBillDateRequest extends GenericProcPostRequest {
  public BillNo: number;
  public ChargeEntry: number;
  public UpdatedDate: Date;
  public ActionTag: string;
  public ActorCode: number;
  public UserName: string;
}
export class SaveMaterialBatchRequest2 extends GenericProcPostRequest {
  public HsnCode: number;
  public BatchNo: string;
  public MaterialBatchStorage: number;
  public SupplierMaterialBatchCode: number;
  public MaterialSpecCode: number;  
  public ReturnQuantity: number;
  public AvailableQuantity: number;
  public ActionTag: string;
  public ActorCode: number;
  public UserName: string;
  public Reason: string;
  public Remarks: string;

}
export class SaveMaterialBatchRequest3 extends GenericProcPostRequest {
  public HsnCode: number;
  public BatchNo: string;
  public MaterialBatchStorage: number;
  public SupplierMaterialBatchCode: number;
  public MaterialSpecCode: number;
  public ActualQuantity: number;
  public ActionTag: string;
  public ActorCode: number;
  public UserName: string;
  public Reason: string;
  public Remarks: string;

}
export class SaveMaterialBatchRequest4 extends GenericProcPostRequest {
  public HsnCode: number;
  public BatchNo: string;
  public MaterialBatchStorage: number;
  public SupplierMaterialBatchCode: number;
  public MaterialSpecCode: number;
  public TranferQuantity: number;
  public ActionTag: string;
  public ActorCode: number;
  public UserName: string;
  public FacilityName: string;
  public FacilityCode: number;
  public StoreName: string;
  public StoreCode: number;
  public EmployeeName: string;
  public EmployeeCode: number;
  public RecievingUser: string;  
  public Remarks: string;

}
export class SaveNewServiceProvider extends GenericProcPostRequest {
  public ProviderCode: number;
  public BranchCode: number;
  public ServiceCode: number;
  public Price: number;
  public OpType: string;
  public CommissionAmount: number;
}
export class SaveServiceToOP extends GenericProcPostRequest {
  public BranchCode: number;
  public ServiceCode: number;
  public ServiceName: string;
  public ServiceDate: Date;
  public ProviderCode: number;
  public ProviderName: string;
  public Quantity: number;
  public PatientFormattedCode: string;
  public ServiceItemID: string;
  public ServiceItemCode: number;
  public TreatmentCategory: string;
  public Remarks: string;
}
export class SaveServiceToAdmission extends GenericProcPostRequest {
  public BranchCode: number;
  public ServiceCode: number;
  public ServiceName: string;
  public ServiceDate: Date;
  public ProviderCode: number;
  public ProviderName: string;
  public Quantity: number;
  public AdmissionNo: number;
  public AdmissionServiceItemID: string;
  public AdmissionServiceItemCode: number;
  public TreatmentCategory: string;
  public Remarks: string;

  public ProviderCost: number;
}
export class SaveServiceToOrder extends GenericProcPostRequest {
  public BranchCode: number;
  public ServiceCode: number;
  public ServiceName: string;
  public ServiceDate: Date;
  public ProviderCode: number;
  public ProviderName: string;
  public Quantity: number;
  public FormattedCode: string;
  public OPServiceItemID: string;
  public OPServiceItemCode: number;
  public TreatmentCategory: string;
  public Remarks: string;
  public ProviderCost: number;
}
export class SaveDischargeDetails extends GenericProcPostRequest {
  public AdmissionNo: number;
  public DischargeInitiatedBy: number;
  public DischargeInitiatedUser: string;
  public DischargingPhysician: number;
  public DischargingPhysicianName: string;
  public ApprovedBy: number;
  public ApprovedByName: string;
  public DischargeDate: Date;
  public Remarks: string;
  public IsDiscAgainstMedAdvise: boolean;
  public UserName: string;
  public ActionTag: string;
}
export class SaveAdmissionTreatmentCategory extends GenericProcPostRequest {
  //public BranchCode: number;
  public UserName: string;
  public AdmissionNo: number;
  public TreatmentCategory: string;
}
export class SaveAdmissionBillDetails extends GenericProcPostRequest {
  public UserName: string;
  public AdmissionNo: number;
}
export class SaveAdmissionLabDetails extends GenericProcPostRequest {
  public UserName: string;
  public AdmissionNo: number;
}
export class SaveOPBillDetails extends GenericProcPostRequest {
  public UserName: string;
  public FormattedCode: string;
}
export class SaveOPLabDetails extends GenericProcPostRequest {
  public UserName: string;
  public FormattedCode: string;
}
export class UpdateRegistration extends GenericProcPostRequest {
  public OldFormattedCode: string;
  public NewFormattedCode: string;
}
export class AddPartner extends GenericProcPostRequest {
  public ActionTag: string;
  public ExistingFormattedCode: string;
  public ExistingPatientName: string;
  public PartnerFormattedCode: string;
  public PartnerActorCode: number;
  public PartnerSalutation: string;
  public PartnerDisplayName: string;
  public PartnerDateOfBirth: Date;
  public PartnerGender: string;
  public PartnerMobileNumber: string;
}
export class UpdateOverseas extends GenericProcPostRequest {
  public PassportNumber: string;
  public PassportExpiryDate: Date;
  public VisaType: string;
  public IssueCountry: string;
  public VisaExpiryDate: Date;
  public NationalRegNo: string;
  public FormattedCode: string;
}
export class UpdateBillingCategory extends GenericProcPostRequest {
  public BillingCategory: string;
  public FormattedCode: string;
}
export class UpdateWeddingDate extends GenericProcPostRequest {
  public WeddingDate: Date;
  public FormattedCode: string;
}
export class UpdateTestResultStatus extends GenericProcPostRequest {
  public OrderCode: number;
  public OrderTestCode: number;
  public OriginalTestCode: number;
  public SignStatus: string;
}
export class SaveNewServiceRequest extends GenericProcPostRequest {
  public ServiceName: string;
  //public ServiceCode: number;
  //public ServiceCategory: number;
  //public ServiceGroup: number;
  public RevenueCategoryCode: number;
  public Price: number;
  public ServicePoint: string;
  public IsPriceEditable: boolean;
  public ActorCode: number;
  public UserName: string;
  public ServiceType: string;
  public DepartmentCode: number;
  public ServiceCategoryCode: number;
}
export class EditCodeTypeValueRequest extends GenericProcPostRequest {
  public CodeType: string;
  public Code: number;
  public LongValue: string;
  public ShortValue: string;
  public UpdatedLongValue: string;
  public UpdatedShortValue: string;
  public ActorCode: number;
  public UserName: string;
}
export class SaveEggDonorEpisode extends GenericProcPostRequest {
  public EggLMPDate: Date;
  public ProtocolStartDate: Date;
  public ProtocolEndDate: Date;
  public PatientRegistrationCode: number;
  public PatientName: string;
  public CreatedFacilityCode: number;
  public CreatedUserCode: number;
  public CreatedUserName: string;
  public ActorCode: number;
  public FormattedCode: string;
  public Remarks: string;
  public CycleType: string;

  public DonorName: string;
  public DonorFormattedCode: string;
  public DonorActorCode: number;
  public DonorRegistrationCode: number;
  public DonorCycleCode: number;
  public DonorEpisode: number; 

  public DonorCycleType: string;
  public DonorCycleNo: string;
  public DonorGradingModel: string;
  public DonorTreatmentProtocolName: string;
  public DonorInfertilityType: string;
  public DonorConcerns: string;

  public EggSourceType: string;
  public RecepientType: string;
  public RecepientLMP: Date;
  public IvfTreatmentCycleCode: number;
  public TCModelID: number;
  public TCModelName: string;
}
export class EditTreatmentCycleRequest extends GenericProcPostRequest {
  public CycleNo: number;
  public Code: number;
  public MenstrualCycle: string;
  public ProtocolName: string;
  public InfertilityType: string;
  public ProtocolEndDate: Date;
  public Remarks: string;
  public ActorCode: number;
  public UserName: string;
}
export class EditTreatmentCycleActvityRequest extends GenericProcPostRequest {
  public ActivityTypeName: string;
  public CounsellingActivityCode: number;
  public ActivityName: string;
  public Remarks: string;
  public ActorCode: number;
  public UserName: string;
}
export class GetIVFAdditionalDetailsRequest extends GenericProcPostRequest {
  public CycleCode: number;
  public Title: string;
  public Context: string;
  public Notes: string;
  public ActorCode: number;
  public UserName: string;
}
export class SaveCodeTypeValueRequest extends GenericProcPostRequest {
  public CodeTypeValueCode: number;
  public CodeType: string;
  public LongValue: string;
  public ShortValue: string;
  public ActorCode: number;
  public UserName: string;
}
export class EditTreatmentCycleStatusRequest extends GenericProcPostRequest {
  public CycleCode: number;
  public ActivityStatus: string;
  public ActivityName: string;
  public ActorCode: number;
  public UserName: string;
}
export class DeleteCodeTypeValueRequest extends GenericProcPostRequest {
  public CodeType: string;
  public Code: number;
  public LongValue: string;
  public ShortValue: string;
  public ActorCode: number;
  public UserName: string;
}
export class DeleteFollicularScanRequest extends GenericProcPostRequest {
  public CycleCode: number;
  public FollicularGrowthCode: number;
  public ActivityCode: number;
  public PatientCode: number;
  public EggSourceType: string;
  public ActorCode: number;
  public DOC: number;
  public GradingModel: string;
  public EmpActorCode: number;
  public UserName: string;
}
export class DeleteTreatmentCycleRequest extends GenericProcPostRequest {
  public CycleCode: number;
  public ActorCode: number;
  public UserName: string;
}
export class DeletePatientRequest extends GenericProcPostRequest {
  public FormattedCode: string;
  public ActorCode: number;
  public UserName: string;
}
export class DeletePatientHealthRecordRequest extends GenericProcPostRequest {
  public FormattedCode: string;
  public PatientReportCode: number;
  public ReportType: string;
  public TemplateName: string;
  public ActorCode: number;
  public UserName: string;
}
export class DeleteLabOrderRequest extends GenericProcPostRequest {
  public OrderCode: number;
  public OrderTestCode: number;
  public ActorCode: number;
  public UserName: string;
}
export class DeleteCycleActivityRequest extends GenericProcPostRequest {
  public CounsellingActivityCode: number;
  public ActorCode: number;
  public UserName: string;
}
export class DeleteCycleMedicineOrTestRequest extends GenericProcPostRequest {
  public CycleActivity: number;
  public TreatmentCycle: number;
  public ActorCode: number;
  public UserName: string;
}
export class EditMaterialDetailsInfoRequest extends GenericProcPostRequest {
  public MaterialCode: number;
  public MaterialName: string;
  public SellingUnit: string;
  public PurchaseUnit: string;
  public HsnCode: string;
  public MaterialGroupCode: number;
  public TaxPercentage: number;

  public MaterialSpec: number;
  public ActorCode: number;
  public UserName: string;
}
export class SaveEditServiceRequest extends GenericProcPostRequest {
  public ServiceName: string;
  public ServiceCode: number;
  public RevenueCategory: string;
  public CategoryName: string;
  public BasePrice: number;
  public ActorCode: number;
  public UserName: string;
  public ServiceType: string;
  public DepartmentCode: number;
  public ServiceCategory: number;

  public BranchPrice: number;
  public BranchCode: number;
}
export class SaveBillItemsInfoRequest2 extends GenericProcPostRequest {
  public Bill: NewBillData;
  public ChargeEntry: string;
  //public ProviderCode: number;
  //public ProviderName: string;
}
export class SaveNewEnquiryRequest extends GenericProcPostRequest {
  public Salutation: string;
  public DisplayName: string;
  public DateOfBirth: Date;
  public FemaleDateofBirth: Date;
  public Telephone1: number;
  public PartnerName: string;
  public ActorCode: number;
  public UserName: string;
  public Gender: string;
  public AddressLine1: string;
  public AddressLine2: string;
  public AddressCode: number;
  public CreatedUser: number;
  public ActorType: number;
  public UserLoginFacility: number;
}
export class ReassignActivityRequest extends GenericProcPostRequest {

  public CounsellingActivityCode: number;
  public AssignedToName: string;
  public AssignedTo: number;
  public UserLoginFacility: number;
  public UserName: string;
  public CreatedUser: number;
}
export class GenericInstantReportRequest extends GenericProcPostRequest {

  ReportName: string;
  ReportCode: number;
  VariableList: string;
  Facility: number;
  FromDate: Date;
  ToDate: Date;
  Employee: number;
  PatientFormatted: string;
  ProcedureName: string;


  IsFacility: Boolean;
  IsFromDate: Boolean;
  IsToDate: Boolean;
  IsEmployee: Boolean;
  IsPatientFormatted: Boolean;


}
export class SaveAccessRightRequest extends BaseClass {
  public ModuleID: string;
  public RoleID: string;
  public FeatureID: string;
  public HasAccess: boolean;
}
export class AccessRightsByRoleController {
  public ModuleID: string;
  public ROLEMAPPEDID: string;
  public FeatureID: string;
  public FeatureName: string;
  public FeatureDescription: string;
  public ModuleName: string;
  public HasAccess: boolean;
}
export class AccessRightsByRoleRequest extends BaseClass {
  public RoleID: string;
  public ModuleID: string;
}
export class IPBillServiceTrackingRequest extends BaseClass {
  public Branch: number;
  public FromDate: Date;
  public ToDate: Date;
}
export class IPBillServiceTrackingController {
  public PatientName: string;
  public BillitemCode: number;
  public ItemStatus: string;
  public Comments: string;
  public UserName: string;
  public TimeStamp: Date;
  public ChargeEntry: number;
  public ChargeItemCode: number;
  public ItemDescription: string;
  public BillFormattedCode: string;
  public Column1: string;
}

export class DataSetModel {
  DataTables: any[];
}
export class DataTableModel {
  Name: string;
  TableColumns: Array<any>;
  TableRows: Array<any>;
}
export class AdmissionServicesController {
  public AdmissionNo: number;
  public Facility: number;
  public OrderType: string;
  public OrderEntryType: string;
  public AdmissionServiceItemID: string;
  public AdmissionServiceItemCode: number;
  public ServiceCode: number;
  public TreatmentCategory: string;
  public PlannedServiceDate: Date;
  public ActualServiceDate: Date;
  public ProviderCode: number;
  public ProviderName: string;
  public Quantity: number;
  public ItemStatus: string;
  public Details: string;
  public Remarks: string;
  public UnitPrice: number;
}
export class DischargeDetailsController {
  public AdmissionNo: number;
  public DischargeInitiatedBy: number;
  public DischargeInitiatedDate: Date;
  public DischargeAgainstAdvice: boolean;
  public DischargeInitiatedTime: Date;
  public AdmissionFormattedCode: string;
  public DischargeCode: number;
  public DischargeInitiatedUser: string;
  public DischargingPhysician: number;
  public DischargingPhysicianName: string;
  public IsDischarged: boolean;
  public IsDischargeInitiated: boolean;
  public PatientCode: number;
  public PatientFormattedCode: string;
  public PatientName: string;
  public PlannedDischargeOn: Date;
  public DischargeApprovedUser: string;
  public ClearanceStatus: string;
}
export class AdmissionServiceDetail {
  
  public AdmissionDate: Date; // the day on which admission is made
  public CareUnit: string;
  public BedLocation: string;
  public PatientName: string;
  public BranchName: string;
 
  public PatientFormattedCode: string;

  public BranchCode: number;
  // the below set should come.. as part of request.. ok sir
  public TreatmentCategory: string;
  public ServiceCode: number;
  public ServiceName: string;
  public ServiceDate: Date; // the day on which service is provided
  public ProviderCode: number;
  public ProviderName: string;
  public Quantity : number;
  public Remarks: string;
  public AdmissionNo: number; // ?? whatis this>> should it b e number or formattedcode? string sir
  public AdmissionServiceItemID: string;  // create only if you are adding.. for editing.. id comes from database...
  public AdmissionServiceItemCode: number;

  public ProviderCost: number;
}

export class OPServiceDetail {
  public PatientName: string;
  public BranchName: string;
  public PatientFormattedCode: string;
  public BranchCode: number;
  public TreatmentCategory: string;
  public ServiceCode: number;
  public ServiceName: string;
  public ServiceDate: Date; // the day on which service is provided
  public ProviderCode: number;
  public ProviderName: string;
  public Quantity: number;
  public Remarks: string;
  public OPServiceItemID: string;  // create only if you are adding.. for editing.. id comes from database...
  public OPServiceItemCode: number;
  public ProviderCost: number;
}

export class FTV {
  public FieldName: string;
  public DataType: string; // int, bigint, float, string, date, bool ..
  public FieldValue: any;

  /**
   * 
   * @param FieldName
   * @param DataType
   * @param FieldValue
   */
  constructor(FieldName: string, DataType: string, FieldValue: any) {
       this.FieldName = FieldName;
    this.DataType = DataType;
    this.FieldValue = FieldValue;
  }
 
  //}
}

export class GenericParams extends GenericProcPostRequest{
  public Params : FTV[];
}

export class
  // All appt sin a  duriation
  AppointmentsInWeek {
  // 7 slots.. from start date
  StartDate: Date;
  Branch: number;
  Provider: number;
  ProviderName: string;
  DaySlots : SlotsInDay[];
}

// Appointments in a aday
export class SlotsInDay{
  AppointmentDate: Date;  
  //SlotAppts: ApptSlot[];
//  AppointmnetDate: Date;
  AppointmentTime: Date;
  SlotCode: number;
  ApptCount: number;
  CanAddMore: boolean;
  FilledSlots: Appt[];
}

//// apppointmst in a slot

//export class ApptSlot{
//  AppointmnetDate: Date;
//  AppointmentTime: Date;
//  SlotCode: number;
//  ApptCount: number;
//  CanAddMore: boolean;
//  FilledSlots: Appt[];
//}


// booked in  a slot
export class Appt{
  AppointmnetDate: Date;
  AppointmentTime: Date;
  SlotCode: number;
  ApptCode: number;
  PatientName: string;
  PatientFormattedCode: string;
  AppointmentStatus: string;
}
export class OPOrdersController {
  public FormattedCode: string;
  public Facility: number;
  public OrderType: string;
  public OrderEntryType: string;
  public ServiceItemID: string;
  public ServiceItemCode: number;
  public ServiceCode: number;
  public TreatmentCategory: string;
  public PlannedServiceDate: Date;
  public ActualServiceDate: Date;
  public ProviderCode: number;
  public ProviderName: string;
  public Quantity: number;
  public ItemStatus: string;
  public Details: string;
  public Remarks: string;
  public UnitPrice: number;
}
